(function() {
  'use strict';

  angular
    .module('CoherentDemos', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource', 'ui.router', 'ui.bootstrap', 'toastr', 'ngFileUpload', 'pascalprecht.translate']);

})();

(function() {
  'use strict';

  angular
      .module('CoherentDemos')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Bootstrap',
        'url': 'http://getbootstrap.com/',
        'description': 'Bootstrap is the most popular HTML, CSS, and JS framework for developing responsive, mobile first projects on the web.',
        'logo': 'bootstrap.png'
      },
      {
        'title': 'Angular UI Bootstrap',
        'url': 'http://angular-ui.github.io/bootstrap/',
        'description': 'Bootstrap components written in pure AngularJS by the AngularUI Team.',
        'logo': 'ui-bootstrap.png'
      },
      {
        'title': 'Sass (Node)',
        'url': 'https://github.com/sass/node-sass',
        'description': 'Node.js binding to libsass, the C version of the popular stylesheet preprocessor, Sass.',
        'logo': 'node-sass.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('CoherentDemos')
    .directive('range', drctv);

  /** @ngInject */
  function drctv() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/range/range.html',
      scope: {
        min: '=',
        max: '=',
        model: '=',
        disabled: '=',
        change: '&'
      },
      link: linkFunc,
      controller: ctrl,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;

      var update = _.debounce(vm.change, 500);

      watcher = scope.$watch('vm.model', function () {
        el[0].children[0].style.backgroundSize = ((vm.model - vm.min) / (vm.max - vm.min) * 100) + '% 100%';
        el[0].children[0].value = vm.model;

        update();
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function ctrl() {
      var vm = this;

      return vm;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('CoherentDemos')
    .directive('navbar', navbar);

  /** @ngInject */
  function navbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController($state) {
      var vm = this;

      vm.$state = $state;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('CoherentDemos')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('CoherentDemos')
    .directive('loader', loader);

  /** @ngInject */
  function loader() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/loader/loader.html',
      controller: LoaderController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function LoaderController($rootScope, $scope) {
      var vm = this;

      vm.loading = false;

      $scope.$watch('$root.loading', function() {
        vm.loading = $rootScope.loading;
      });
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('CoherentDemos')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('CoherentDemos')
    .directive('backNavbar', backNavbar);

  /** @ngInject */
  function backNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/backNavbar/backNavbar.html',
      scope: {
          content: '@',
          icon: '@',
          link: '@',
          removeMargin: '@'
      },
      controller: BackNavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function BackNavbarController($scope, $state, $window) {
      var vm = this;

      vm.back = function() {
        if(vm.link) {
          $state.go(vm.link);
        } else {
          $window.history.back();
        }
      };

      vm.content = $scope.content;
      vm.icon = $scope.icon;
      vm.link = $scope.link;
      vm.removeMargin = angular.isDefined($scope.removeMargin) && $scope.removeMargin;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('CoherentDemos')
    .directive('footer', footer);

  /** @ngInject */
  function footer() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/footer/footer.html',
      scope: {
      },
      controller: FooterController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function FooterController($translate) {
      var vm = this;

      vm.translate = function(language) {
        $translate.use(language);
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('CoherentDemos')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($timeout, webDevTec, toastr) {
    var vm = this;

    vm.awesomeThings = [];
    vm.classAnimation = '';
    vm.creationDate = 1627099227167;
    vm.showToastr = showToastr;

    activate();

    function activate() {
      getWebDevTec();
      $timeout(function() {
        vm.classAnimation = 'rubberBand';
      }, 4000);
    }

    function showToastr() {
      toastr.info('Fork <a href="https://github.com/Swiip/generator-gulp-angular" target="_blank"><b>generator-gulp-angular</b></a>');
      vm.classAnimation = '';
    }

    function getWebDevTec() {
      vm.awesomeThings = webDevTec.getTec();

      angular.forEach(vm.awesomeThings, function(awesomeThing) {
        awesomeThing.rank = Math.random();
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('CoherentDemos')
    .service('UnderwritingService', UnderwritingService);

  /** @ngInject */
  function UnderwritingService() {
    var vm = this;

  }
})();

"use strict";

(function () {
  'use strict';

  angular.module('CoherentDemos').controller('LifeUW4Controller', LifeUW4Controller);
  /** @ngInject */

  function LifeUW4Controller($state, UnderwritingService, $http) {
    var vm = this;


  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('CoherentDemos').controller('LifeUW3Controller', LifeUW3Controller);
  /** @ngInject */

  function LifeUW3Controller($state, UnderwritingService, $http) {
    var vm = this;

    vm.data = UnderwritingService.data

    console.log(vm.data)
    vm.BasicPremium = 192
    vm.TotalPremium = Math.round(vm.BasicPremium * (1 + vm.data['Total_Loading']))
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('CoherentDemos').controller('LifeUW2Controller', LifeUW2Controller);
  /** @ngInject */

  function LifeUW2Controller($state, UnderwritingService, $http) {
    var vm = this;

    vm.CancerTypes = [];
    vm.ExecuteInput = {"request_data":{"inputs":{"Age":26,"Cover":"WOP","Diastolic":80,"HealthAnswers":[{"Index":"Q1","Answer":"N"},{"Index":"Q1.1","Answer":"N"},{"Index":"Q1.2","Answer":"N"},{"Index":"Q1.3","Answer":"N"},{"Index":null,"Answer":null},{"Index":"Q2","Answer":"N"},{"Index":"Q2.1","Answer":"Malignant Neoplasm, Unspecified"}],"Height":1.61,"Occupation":"ARCH","Systolic":120,"UWDate":"2023-11-01","Weight":64}},"request_meta":{"service_category":"#Default#","compiler_type":"Neuron"}}
    vm.refer = false
    vm.Decline = true

    vm.Execute = function() {
      vm.BasicDataUpdate();
      var req = {
        method: 'POST',
        url: 'https://excel.uat.us.coherent.global/coherent/api/v3/folders/Spark FE Demos/services/UW_STP_Demo_v2/Execute',
        headers: {
          'SecretKey': '2277565c-9fad-4bf4-ad2b-1efe5748dd11',
          'x-tenant-name': 'coherent'
        },
        data: vm.ExecuteInput
      };
      $http(req).then(function (response) {
        vm.data = response.data.response_data.outputs;
        vm.HealthQuestions = vm.data["HealthQuestions"]
        if(vm.data.UWstatus=="Refer") {
          vm.refer = true
          vm.Decline = false
        } else if(vm.data.UWstatus=="Decline") {
          vm.refer = false
          vm.Decline = true
        } else {
          vm.refer = false
          vm.Decline = false
        }
        console.log(vm.data)
      }, function () {});
    }    

    vm.CallOptions = function() {
      var req = {
        method: 'POST',
        url: 'https://excel.uat.us.coherent.global/coherent/api/v3/folders/Spark FE Demos/services/UW_STP_Demo_v2/Execute',
        headers: {
          'SecretKey': '2277565c-9fad-4bf4-ad2b-1efe5748dd11',
          'x-tenant-name': 'coherent'
        },
        data: '{"request_data":{"inputs":{}},"request_meta":{"service_category":"Options","compiler_type":"Neuron"}}'
      };
      $http(req).then(function (response) {
        vm.OptionsData = response.data.response_data.outputs;
        vm.CancerTypes = vm.OptionsData["Options.CancerTypes"]
      }, function () {});
    }

    vm.Answer = function(index, value) {
      var array = vm.ExecuteInput.request_data.inputs.HealthAnswers;
      var obj = {};
      for (var i = 0; i < array.length; i++) {
          if (array[i].Index === index) {
              array[i].Answer = value;
              break;
          }
      }

      console.log(vm.refer)

      vm.Execute();
    }

    vm.YesCheck = function(index) {
      var array = vm.ExecuteInput.request_data.inputs.HealthAnswers;
      var obj = {};
      for (var i = 0; i < array.length; i++) {
        if (array[i].Index === index) {
          if (array[i].Answer === 'Y') {
            return true
          } else {
            return false
          }
        }
      }
    }

    vm.BasicDataUpdate = function() {
      vm.ExecuteInput.request_data.inputs.Age = UnderwritingService.Age;
      vm.ExecuteInput.request_data.inputs.Weight = UnderwritingService.Weight;
      vm.ExecuteInput.request_data.inputs.Height = UnderwritingService.Height;
      vm.ExecuteInput.request_data.inputs.Occupation = UnderwritingService.Occupation;
      vm.ExecuteInput.request_data.inputs.Diastolic = UnderwritingService.Diastolic;
      vm.ExecuteInput.request_data.inputs.Systolic = UnderwritingService.Systolic;
      console.log(vm.ExecuteInput.request_data.inputs);
    }

    vm.Back = function() {
      $state.go('life-uw-1');
    }

    vm.Submit = function() {
      UnderwritingService.data = vm.data
      if (vm.refer) {
        $state.go('life-uw-4');
      } else {
        $state.go('life-uw-3');
      }
    }

    vm.CallOptions();
    vm.Execute();

  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('CoherentDemos').controller('LifeUW1Controller', LifeUW1Controller);
  /** @ngInject */

  function LifeUW1Controller($state, UnderwritingService, $http) {
    var vm = this;

    vm.Age = 32;
    vm.Height = 1.7;
    vm.Weight = 110;
    vm.Occupation = "";
    vm.Diastolic = 80;
    vm.Systolic = 140;

    vm.OptionsOccupations = [];

    vm.Loading = false
    
    vm.CallOptions = function() {
      var req = {
        method: 'POST',
        url: 'https://excel.uat.us.coherent.global/coherent/api/v3/folders/Spark FE Demos/services/UW_STP_Demo_v2/Execute',
        headers: {
          'SecretKey': '2277565c-9fad-4bf4-ad2b-1efe5748dd11',
          'x-tenant-name': 'coherent'
        },
        data: '{"request_data":{"inputs":{}},"request_meta":{"service_category":"Options","compiler_type":"Neuron"}}'
      };
      $http(req).then(function (response) {
        vm.OccupationsData = response.data.response_data.outputs;
        vm.OptionsOccupations = vm.OccupationsData["Options.Occupation"]
        console.log(vm.data)
      }, function () {});
    }

    function ocrSpaceApiCall(file, callback) {
      var OCR_API_ENDPOINT = 'https://api.ocr.space/parse/image';
      var API_KEY = 'K86518917388957';  // Replace with your API key

      var formData = new FormData();
      formData.append('file', file);
      formData.append('apikey', API_KEY);
      formData.append('language', 'eng'); // you can change the language code if needed

      var xhr = new XMLHttpRequest();
      xhr.open('POST', OCR_API_ENDPOINT, true);

      xhr.onreadystatechange = function() {
        if (xhr.readyState === 4) {
          vm.Loading = false;  // set to false once results are back or there's an error
          var data = JSON.parse(xhr.responseText);
          if (xhr.status === 200 && data) {
            callback(null, data);
          } else {
            callback('HTTP error! Status: ' + xhr.status);
          }
        }
      };

      xhr.send(formData);
    }

    // Example usage:
    document.querySelector('#yourFileInputId').addEventListener('change', function(event) {
      var file = event.target.files[0];
      if (file) {
        vm.Loading = true;  // set to true while API is being called
        ocrSpaceApiCall(file, function(error, jsonResponse) {
          if (error) {
            console.error('Error during OCR processing:', error);
          } else {
            console.log(jsonResponse);
            if (jsonResponse.ParsedResults && jsonResponse.ParsedResults.length > 0) {
              console.log(jsonResponse.ParsedResults[0].ParsedText);
              vm.readInput(jsonResponse.ParsedResults[0].ParsedText)
            }
          }
        });
      }
    });

    vm.readInput = function(inputString) {
      var OPENAI_API_KEY = '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';
      var ENGINE = 'davinci';
      var ENDPOINT = 'https://api.openai.com/v1/engines/' + ENGINE + '/completions';

      var xhr = new XMLHttpRequest();

      xhr.open('POST', ENDPOINT, true);
      xhr.setRequestHeader('Authorization', 'Bearer ' + OPENAI_API_KEY);
      xhr.setRequestHeader('Content-Type', 'application/json');

      xhr.onreadystatechange = function() {
        if (xhr.readyState == 4 && xhr.status == 200) {
          var jsonResponse = JSON.parse(xhr.responseText);
          console.log(jsonResponse.choices[0].text.trim());
        }
        // Additional error handling can be added here
      };

      var data = JSON.stringify({
        prompt: 'convert the following string into a json with paramters "Diastolic", "Systolic", "Height", "Weight" --> "BP Systolic\r\nBP Diastolic\r\n120\r\n80\r\nHeight\r\nWeight\r\n1.7\r\n110\r\n"',
        max_tokens: 150
      });

      xhr.send(data);
    }

    vm.CallOptions();

    vm.SaveData = function() {
      UnderwritingService.Age = vm.Age;
      UnderwritingService.Height = vm.Height;
      UnderwritingService.Weight = vm.Weight;
      UnderwritingService.Occupation = vm.Occupation;
      UnderwritingService.Diastolic = vm.Diastolic;
      UnderwritingService.Systolic = vm.Systolic;

      $state.go('life-uw-2');
    }

  }
})();
(function() {
  'use strict';

  angular
    .module('CoherentDemos')
    .service('CatalogService', CatalogService);

  /** @ngInject */
  function CatalogService($http) {
    var vm = this;

    vm.coreSolutions = [
      {name: "Actuarial Modelling", keywords: "Actuarial"},  
      {name: "Data Management", keywords: "Data Management"},
      {name: "ESG", keywords: "ESG"}, 
      {name: "EUC", keywords: "EUC"}, 
      {name: "Explainer", keywords: "Explainer"}, 
      {name: "Finance", keywords: "Reconcillation / Finance / Stress Test / Risk Modelling"},
      {name: "Pensions", keywords: "Pension / 401k / Secure 2.0"}, 
      {name: "Legacy Modernization", keywords: "Legacy"}, 
      {name: "Loan Management", keywords: "Loan / ECL"},  
      {name: "Modular Product", keywords: "Modular / Embedded"},  
      {name: "Rating / Pricing", keywords: "Rater / Explainer / Insurance"}, 
      {name: "Securities Services", keywords: "Securities Services"}
    ];

    vm.Features = [
      {name: "Complex Modelling", keywords: "Complex Modelling"}, 
      {name: "xCall", keywords: "xCall"}, 
      {name: "Data Consolidation", keywords: "Data Consolidation"}, 
      {name: "Goal Seek", keywords: "Goal Seek"}, 
      {name: "Data Illustration", keywords: "Data Illustration"}, 
      {name: "Goal Seek", keywords: "Goal Seek"}, 
      {name: "EUC", keywords: "EUC"}, 
      {name: "Spark Shell", keywords: "Spark Shell"}
    ];

    // Catalog API Call
    vm.getCatalog = function(input) {
      return new Promise(function(resolve, reject) {
        var req = {
          method: 'POST',
          url: vm.apiConstants.catalog.url,
          headers: {
            'SecretKey': vm.apiConstants.catalog.apikey,
            'x-tenant-name': vm.apiConstants.catalog.tenant
          },
          data: input
        };

        $http(req).then(
          function(response) {
            resolve(response.data.response_data.outputs);
          },
          function(error) {
            reject(error);
          }
        );
      });
    }
    // Page API Call


    // API constants
    vm.apiConstants = {
      "catalog": {
        "inputTemplate": '{"request_data":{"inputs":{}},"request_meta":{"service_category":"#Default#,authenticate","compiler_type":"Neuron"}}',
        "outputTemplate": [
    {
      "Topic Group": "ESG",
      "Resource Name": "ESG Solution Brief",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "PDF One Pager",
      "Solution": "ESG (Modelling and Reporting)",
      "Industry": "_ALL INDUSTRIES, Banking, Insurance: Life & Retirement/Annuity, Capital Markets, Insurance: P&C, Other Industries, Wealth & Asset Management",
      "Persona": "CSO (Sustainability), CRO (Risk), CIO (Investment)",
      "Pricing": "API Calls",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/GTMPlanning/EUO-qVD-D5FHjLthahnSXmEBFJH5v7k6Dowp8F6CTan3Kw?e=jp6bM7",
      "External": "https://app.hubspot.com/documents/4052288/summary/5911476",
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "ESG",
      "Resource Name": "ESG Solution Pitch",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "PPT Deck",
      "Solution": "ESG (Modelling and Reporting)",
      "Industry": "_ALL INDUSTRIES, Banking, Insurance: Life & Retirement/Annuity, Capital Markets, Insurance: P&C, Other Industries, Wealth & Asset Management",
      "Persona": "CSO (Sustainability), CRO (Risk), CIO (Investment)",
      "Pricing": "API Calls",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/GTMPlanning/EWmQHy6T64RBr7bPIOosa5QBDI8994kYo_Gt5EDQOiKElQ?e=nXaL03",
      "External": "https://app.hubspot.com/documents/4052288/summary/5911477",
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "ESG",
      "Resource Name": "ESG Demo Model (Carbon tax optimization)",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Demo Model",
      "Solution": "ESG (Modelling and Reporting)",
      "Industry": "_ALL INDUSTRIES, Banking, Insurance: Life & Retirement/Annuity, Capital Markets, Insurance: P&C, Other Industries, Wealth & Asset Management",
      "Persona": "CSO (Sustainability), CRO (Risk), CIO (Investment)",
      "Pricing": "API Calls",
      "Internal Sharepoint": "https://spark.uat.us.coherent.global/coherent/shared/products/ESG",
      "External": null,
      "Video": null,
      "Features": "'Complex Modelling', 'xCall', 'Data Consolidation', 'Goal Seek', 'Interactive Front End'",
      "Group ID": 1
    },
    {
      "Topic Group": "ESG",
      "Resource Name": "ESG Demo Front-end (Carbon tax optimization)",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Demo Front-End",
      "Solution": "ESG (Modelling and Reporting)",
      "Industry": "_ALL INDUSTRIES, Banking, Insurance: Life & Retirement/Annuity, Capital Markets, Insurance: P&C, Other Industries, Wealth & Asset Management",
      "Persona": "CSO (Sustainability), CRO (Risk), CIO (Investment)",
      "Pricing": "API Calls",
      "Internal Sharepoint": "https://coherentspark-esg-model.streamlit.app/",
      "External": null,
      "Video": null,
      "Features": "'xCall', 'Goal Seek', 'Interactive Front End'",
      "Group ID": 1
    },
    {
      "Topic Group": "Explainer",
      "Resource Name": "Explainer Intro Email Template",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Email Template",
      "Solution": "Explainer",
      "Industry": "_ALL INDUSTRIES, Banking, Insurance: Life & Retirement/Annuity, Capital Markets, Insurance: P&C, Other Industries, Wealth & Asset Management",
      "Persona": "CAO (Actuary), CPO (Product), CMO (Marketing), Head of Transformation, CDO (Digital)",
      "Pricing": "API Services",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:w:/s/GTMPlanning/EbY4pt41VvFJlIyk1WyAIm4B87TRw9HZ3fYFoNZx03P6sw?e=62GfBV",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Explainer",
      "Resource Name": "Explainer Solution Brief",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "PPT Deck",
      "Solution": "Explainer",
      "Industry": "_ALL INDUSTRIES, Banking, Insurance: Life & Retirement/Annuity, Capital Markets, Insurance: P&C, Other Industries, Wealth & Asset Management",
      "Persona": "CAO (Actuary), CPO (Product), CMO (Marketing), Head of Transformation, CDO (Digital)",
      "Pricing": "API Services",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/CoherentExplainer/EVMSdaac6yFMuLMrj3K_LNgB99fvGATGwxdJ6puVNy1DLQ?e=oAU05j",
      "External": "https://app.hubspot.com/documents/4052288/summary/5936457",
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Explainer",
      "Resource Name": "Explainer Video",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Video",
      "Solution": "Explainer",
      "Industry": "_ALL INDUSTRIES, Banking, Insurance: Life & Retirement/Annuity, Capital Markets, Insurance: P&C, Other Industries, Wealth & Asset Management",
      "Persona": "CAO (Actuary), CPO (Product), CMO (Marketing), Head of Transformation, CDO (Digital)",
      "Pricing": "API Services",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:v:/r/sites/CoherentExplainer/Shared%20Documents/General/Documents/Sales%20Deck/Coherent%20Explainer%20Edits%20v5.mp4?csf=1&web=1&e=tSJYWl",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Explainer",
      "Resource Name": "Explainer Solution Pitch",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "PPT Deck",
      "Solution": "Explainer",
      "Industry": "_ALL INDUSTRIES, Banking, Insurance: Life & Retirement/Annuity, Capital Markets, Insurance: P&C, Other Industries, Wealth & Asset Management",
      "Persona": "CAO (Actuary), CPO (Product), CMO (Marketing), Head of Transformation, CDO (Digital)",
      "Pricing": "API Services",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/CoherentExplainer/EbnwipjljZ9Hh49WP1T1a_YBk2nhwn9c6a2q1Jxh0kWDbQ?e=PNBgav",
      "External": "https://app.hubspot.com/documents/4052288/summary/5936458",
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Explainer",
      "Resource Name": "Explainer Templates Directory",
      "Description / Notes": null,
      "Sensitivity": "Internal",
      "Resource Type": "Demo Model",
      "Solution": "Explainer",
      "Industry": "_ALL INDUSTRIES, Banking, Insurance: Life & Retirement/Annuity, Capital Markets, Insurance: P&C, Other Industries, Wealth & Asset Management",
      "Persona": "CAO (Actuary), CPO (Product), CMO (Marketing), Head of Transformation, CDO (Digital)",
      "Pricing": "API Services",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:f:/r/sites/CoherentExplainer/Shared%20Documents/General/Documents/Demo%20Materials/Explainer%20Demo%20Config%20Forms%20Per%20Release?csf=1&web=1&e=cvErly",
      "External": null,
      "Video": null,
      "Features": "'Complex Modelling', 'Data Illustration', 'Interactive Front End'",
      "Group ID": 4
    },
    {
      "Topic Group": "Explainer",
      "Resource Name": "Explainer Sample Front-End",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Demo Front-End",
      "Solution": "Explainer",
      "Industry": "_ALL INDUSTRIES, Banking, Insurance: Life & Retirement/Annuity, Capital Markets, Insurance: P&C, Other Industries, Wealth & Asset Management",
      "Persona": "CAO (Actuary), CPO (Product), CMO (Marketing), Head of Transformation, CDO (Digital)",
      "Pricing": "API Services",
      "Internal Sharepoint": "https://explainer.uat.us.coherent.global/SL-1.2?tenant=explainer&service_uuid=d4bfa415-467a-4055-bd2f-9c2756759e41#/",
      "External": null,
      "Video": null,
      "Features": "'Complex Modelling', 'Data Illustration', 'Interactive Front End'",
      "Group ID": 4
    },
    {
      "Topic Group": "Loan",
      "Resource Name": "Credit Risk UW (Loan Origination LO) Solution Pitch",
      "Description / Notes": "Credit Scoring, loan eligibility calculation and loan offers are processed manually on excel by some of the lending companies and mid-tier banks. Spark offers a strong proposition to help audit the credit risk underwriting process and faster turnaround time for customer applications. Other key Benefit: Speed to Market to launch new products (fast prototyping and launch)",
      "Sensitivity": "External",
      "Resource Type": "PPT Deck",
      "Solution": "Loan Origination ",
      "Industry": "Banking",
      "Persona": "COO, CRO (Risk), Head of Credit Risk, CPO (Product), Unnamed record",
      "Pricing": "API Calls",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/GTMPlanning/EYCYRHDHcMlHvzApKT5xhoUBJmAcMkXHKaf20sSBXvJCGQ?e=wao81a",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Loan",
      "Resource Name": "Credit Risk UW (Loan Origination) Overview",
      "Description / Notes": "Credit Scoring, loan eligibility calculation and loan offers are processed manually on excel by some of the lending companies and mid-tier banks. Spark offers a strong proposition to help audit the credit risk underwriting process and faster turnaround time for customer applications. Other key Benefit: Speed to Market to launch new products (fast prototyping and launch)",
      "Sensitivity": "Internal",
      "Resource Type": "PPT Deck",
      "Solution": "Loan Origination ",
      "Industry": "Banking",
      "Persona": "COO, CRO (Risk), Head of Credit Risk, CPO (Product)",
      "Pricing": "API Calls",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/GTMPlanning/EYN-rZGI9a5JtGJrawdvDy8BBzl7OOYM1dd2RJ70tb1IMg?e=r6j3cQ",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Loan",
      "Resource Name": "Credit Risk UW(Loan Origination)  Solution Brief",
      "Description / Notes": "Credit Scoring, loan eligibility calculation and loan offers are processed manually on excel by some of the lending companies and mid-tier banks. Spark offers a strong proposition to help audit the credit risk underwriting process and faster turnaround time for customer applications. Other key Benefit: Speed to Market to launch new products (fast prototyping and launch)",
      "Sensitivity": "External",
      "Resource Type": "PPT Deck",
      "Solution": "Loan Origination ",
      "Industry": "Banking",
      "Persona": "COO, CRO (Risk), Head of Credit Risk, CPO (Product)",
      "Pricing": "API Calls",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/GTMPlanning/ERwPD4DgAC1Iq1jctSBG1AwBfeJYHyM9JW4FZkUJ7vDslQ?e=knbcXa",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Loan",
      "Resource Name": "Credit Risk UW (Loan Origination) video",
      "Description / Notes": "Credit Scoring, loan eligibility calculation and loan offers are processed manually on excel by some of the lending companies and mid-tier banks. Spark offers a strong proposition to help audit the credit risk underwriting process and faster turnaround time for customer applications. Other key Benefit: Speed to Market to launch new products (fast prototyping and launch)",
      "Sensitivity": "External",
      "Resource Type": "Video",
      "Solution": "Loan Origination ",
      "Industry": "Banking",
      "Persona": "COO, CRO (Risk), Head of Credit Risk, CPO (Product)",
      "Pricing": "API Calls",
      "Internal Sharepoint": "https://resources.coherent.global/content/lending-demo-video/",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Loan",
      "Resource Name": "Credit Risk UW (Loan Origination) Case Study",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "PPT Deck",
      "Solution": "Loan Origination ",
      "Industry": "Banking",
      "Persona": "COO, CRO (Risk), Head of Credit Risk, CPO (Product)",
      "Pricing": "API Calls",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/GTMPlanning/EbEAtkPxB-5MuNE09tT7VEMBLW5so2aKh8_aOJTN6I7UDQ?e=CuAXAy",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Loan",
      "Resource Name": "Credit Risk UW Demo excel (Retail Loan Origination)",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Demo Model",
      "Solution": "Loan Origination ",
      "Industry": "Banking",
      "Persona": "COO, CRO (Risk), Head of Credit Risk, CPO (Product)",
      "Pricing": "API Calls",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:x:/s/GTMPlanning/EfrNdvAyYE5IqAqMHN_SmqABJcnbFTgNB9sF1jiTfBGNzA?e=zQpINu",
      "External": null,
      "Video": null,
      "Features": "'Complex Modelling', 'Interactive Front End'",
      "Group ID": 3
    },
    {
      "Topic Group": "Loan",
      "Resource Name": "Credit Risk UW Demo Front-end (Retail Loan Origination)",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Demo Front-End",
      "Solution": "Loan Origination ",
      "Industry": "Banking",
      "Persona": "COO, CRO (Risk), Head of Credit Risk, CPO (Product)",
      "Pricing": "API Calls",
      "Internal Sharepoint": "https://coherent-demos-fs-cmb-loanorigination-streamlit-app-6rns7h.streamlit.app",
      "External": null,
      "Video": "https://coherentcapital.sharepoint.com/:v:/s/GTMPlanning/ESQ8u6nnTVdJpbpgCWisaPUB2XmZx1aNYh3nNgQhGS4jjA?e=2j7GWN",
      "Features": "'Complex Modelling',",
      "Group ID": 3
    },
    {
      "Topic Group": "Risk Modelling",
      "Resource Name": "Risk Modelling Overview",
      "Description / Notes": null,
      "Sensitivity": "Internal",
      "Resource Type": "PPT Deck",
      "Solution": "Model Control & Governance",
      "Industry": "Capital Markets",
      "Persona": "CRO (Risk), COO, CFO",
      "Pricing": "Models Stored",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/GTMPlanning/EeabA0rjJZhMrzyJ-IwasnMBtCWePx9H4X3xXdX4p43PcA?e=0zSG3G",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Risk Modelling",
      "Resource Name": "Risk Modelling Solution Brief",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "PPT Deck",
      "Solution": "Model Control & Governance",
      "Industry": "Capital Markets",
      "Persona": "CRO (Risk), COO, CFO",
      "Pricing": "Models Stored",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/GTMPlanning/EX7FaSsJDthLuipWuk7oxyMBtfjZkboWmCUci5r0Rjc2Ow?e=LaC1zq",
      "External": "https://app.hubspot.com/documents/4052288/summary/6108475",
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Risk Modelling",
      "Resource Name": "Risk Modelling Solution Pitch",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "PPT Deck",
      "Solution": "Model Control & Governance",
      "Industry": "Capital Markets",
      "Persona": "CRO (Risk), COO, CFO",
      "Pricing": "Models Stored",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/GTMPlanning/EcXHJAM_vZdDkSBJwdaqkzwB9Z_5lP99MnzgzB6EHvZ8Ew?e=uPmVeu",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Actuarial Modelling",
      "Resource Name": "Actuarial Modelling Email Template",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Email Template",
      "Solution": "Actuarial Modelling",
      "Industry": "Insurance: Life & Retirement/Annuity, Insurance: P&C",
      "Persona": "CAO (Actuary), CFO",
      "Pricing": "API Calls",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:w:/s/GTMPlanning/EVQVI6qNyMFFs7IQIxieJ6gB3b0zZ8fZH06RKTZGA6bwag?e=gqUreD",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Actuarial Modelling",
      "Resource Name": "Actuarial Modelling Solution Brief",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "PPT Deck",
      "Solution": "Actuarial Modelling",
      "Industry": "Insurance: Life & Retirement/Annuity, Insurance: P&C",
      "Persona": "CAO (Actuary), CFO",
      "Pricing": "API Calls",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/GTMPlanning/EQQXsvnKggFPqFxJWqKMiNkBlYN0NaBJo9Fo-11JCJjtTg?e=6zoN3G",
      "External": "https://app.hubspot.com/documents/4052288/summary/5911503",
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Actuarial Modelling",
      "Resource Name": "Actuarial Modelling Gong (EY Asia)",
      "Description / Notes": null,
      "Sensitivity": "Internal",
      "Resource Type": "Gong Call",
      "Solution": "Actuarial Modelling",
      "Industry": "Insurance: Life & Retirement/Annuity, Insurance: P&C",
      "Persona": "CAO (Actuary), CFO",
      "Pricing": "API Calls",
      "Internal Sharepoint": "https://us-53346.app.gong.io/call?id=1882010293771418457&highlights=%5B%7B%22type%22%3A%22SHARE%22%2C%22from%22%3A269%2C%22to%22%3A4303%7D%5D",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Actuarial Modelling",
      "Resource Name": "Actuarial Modelling Gong (Swisss Re)",
      "Description / Notes": null,
      "Sensitivity": "Internal",
      "Resource Type": "Gong Call",
      "Solution": "Actuarial Modelling",
      "Industry": "Insurance: Life & Retirement/Annuity, Insurance: P&C",
      "Persona": "CAO (Actuary), CFO",
      "Pricing": "API Calls",
      "Internal Sharepoint": "https://us-53346.app.gong.io/call?id=9091704086844256489",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Actuarial Modelling",
      "Resource Name": "Actuarial Modelling Gong (New York Life)",
      "Description / Notes": null,
      "Sensitivity": "Internal",
      "Resource Type": "Gong Call",
      "Solution": "Actuarial Modelling",
      "Industry": "Insurance: Life & Retirement/Annuity, Insurance: P&C",
      "Persona": "CAO (Actuary), CFO",
      "Pricing": "API Calls",
      "Internal Sharepoint": "https://us-53346.app.gong.io/call?id=9118878876274849971",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Client FAQ",
      "Resource Name": "Client Ready FAQ Deck",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Internal Ref",
      "Solution": "_ALL SOLUTIONS / USE CASES",
      "Industry": "_ALL INDUSTRIES",
      "Persona": "_ALL PERSONAS",
      "Pricing": "_ALL PRICING MODELS",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/GTMPlanning/EedoiKYRRVtPmKe_JsTdIxYBI2waz3rNNqTUX837-er6Aw?e=40xjs8",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Data Mgt",
      "Resource Name": "Data Management Solution Pitch",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "PPT Deck",
      "Solution": "Data Management",
      "Industry": "_ALL INDUSTRIES, Banking, Insurance: Life & Retirement/Annuity, Capital Markets, Insurance: P&C, Other Industries, Wealth & Asset Management",
      "Persona": "CDO (Data), COO, CIO (Information), CISO (InfoSec), CPO (Product)",
      "Pricing": "API Services",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/GTMPlanning/EQnlyfZgcutJr0Hgm7NZFDEBv-i6WkD1gCiKOL6W462Zcg?e=QGMyEr",
      "External": "https://app.hubspot.com/documents/4052288/summary/6053148",
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Data Mgt",
      "Resource Name": "Data Management Gong (UiPath)",
      "Description / Notes": null,
      "Sensitivity": "Internal",
      "Resource Type": "Gong Call",
      "Solution": "Data Management",
      "Industry": "_ALL INDUSTRIES, Banking, Insurance: Life & Retirement/Annuity, Capital Markets, Insurance: P&C, Other Industries, Wealth & Asset Management",
      "Persona": "CDO (Data), COO, CIO (Information), CISO (InfoSec), CPO (Product)",
      "Pricing": "API Services",
      "Internal Sharepoint": null,
      "External": null,
      "Video": "https://us-53346.app.gong.io/call?id=4572036226599888077",
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "EUC",
      "Resource Name": "EUC Overview",
      "Description / Notes": null,
      "Sensitivity": "Internal",
      "Resource Type": "PPT Deck",
      "Solution": "EUC (End User Computing)",
      "Industry": "_ALL INDUSTRIES, Banking, Insurance: Life & Retirement/Annuity, Capital Markets, Insurance: P&C, Other Industries, Wealth & Asset Management",
      "Persona": "COO, CRO (Risk), CAO (Actuary), CTO, Office of Controllers",
      "Pricing": "Models Stored",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/GTMPlanning/EQWFFOeZsKxPu5YvGgMpi1EB3u3KgZo82ugAt3DjK5FZnA?e=FZwDkE",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "EUC",
      "Resource Name": "EUC Email Template",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Email Template",
      "Solution": "EUC (End User Computing)",
      "Industry": "_ALL INDUSTRIES, Banking, Insurance: Life & Retirement/Annuity, Capital Markets, Insurance: P&C, Other Industries, Wealth & Asset Management",
      "Persona": "COO, CRO (Risk), CAO (Actuary), CTO, Office of Controllers",
      "Pricing": "Models Stored",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:w:/s/GTMPlanning/ESIHQzkJPWBOvCJnObHcz3gBfzi6JkVd50osNZNQU8Bocw?e=ktbDJJ",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "EUC",
      "Resource Name": "EUC Solution Brief",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "PPT Deck",
      "Solution": "EUC (End User Computing)",
      "Industry": "_ALL INDUSTRIES, Banking, Insurance: Life & Retirement/Annuity, Capital Markets, Insurance: P&C, Other Industries, Wealth & Asset Management",
      "Persona": "COO, CRO (Risk), CAO (Actuary), CTO, Office of Controllers",
      "Pricing": "Models Stored",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/GTMPlanning/EYKBLsxcyKFLuuBS4O6FbjIBDqxWeufPQiGChvlepLs2hw?e=bsxcKN",
      "External": "https://app.hubspot.com/documents/4052288/summary/5911481",
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "EUC",
      "Resource Name": "EUC Solution Pitch",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "PPT Deck",
      "Solution": "EUC (End User Computing)",
      "Industry": "_ALL INDUSTRIES, Banking, Insurance: Life & Retirement/Annuity, Capital Markets, Insurance: P&C, Other Industries, Wealth & Asset Management",
      "Persona": "COO, CRO (Risk), CAO (Actuary), CTO, Office of Controllers",
      "Pricing": "Models Stored",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/GTMPlanning/EcxgICBJ9WxDs2x9_ZRWxhQBXYDshYCG3coNGKTKLfNhZA?e=pKSnnz",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "EUC",
      "Resource Name": "EUC Demo (Spark)",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Demo Front-End",
      "Solution": "EUC (End User Computing)",
      "Industry": "_ALL INDUSTRIES, Banking, Insurance: Life & Retirement/Annuity, Capital Markets, Insurance: P&C, Other Industries, Wealth & Asset Management",
      "Persona": "COO, CRO (Risk), CAO (Actuary), CTO, Office of Controllers",
      "Pricing": "Models Stored",
      "Internal Sharepoint": "https://spark-euc.dev.coherent.global/coherent-euc/admin/eucAdmin ",
      "External": null,
      "Video": null,
      "Features": "'EUC',",
      "Group ID": 5
    },
    {
      "Topic Group": "EUC",
      "Resource Name": "EUC Demo (Script)",
      "Description / Notes": null,
      "Sensitivity": "Internal",
      "Resource Type": "Demo Front-End",
      "Solution": "EUC (End User Computing)",
      "Industry": "_ALL INDUSTRIES, Banking, Insurance: Life & Retirement/Annuity, Capital Markets, Insurance: P&C, Other Industries, Wealth & Asset Management",
      "Persona": "COO, CRO (Risk), CAO (Actuary), CTO, Office of Controllers",
      "Pricing": "Models Stored",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:w:/s/GTMPlanning/EVXuoag1yjFFg-RpNpweavUBrOwwuT2EJtU_7g_EMvWslQ?e=eMHgE8",
      "External": null,
      "Video": null,
      "Features": "'EUC',",
      "Group ID": 5
    },
    {
      "Topic Group": "Finance",
      "Resource Name": "Finance Overview",
      "Description / Notes": null,
      "Sensitivity": "Internal",
      "Resource Type": "PPT Deck",
      "Solution": "Finance",
      "Industry": "_ALL INDUSTRIES, Banking, Insurance: Life & Retirement/Annuity, Capital Markets, Insurance: P&C, Other Industries, Wealth & Asset Management",
      "Persona": "CFO, Office of Controllers, CAO (Actuary)",
      "Pricing": "API Calls",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/GTMPlanning/ESCJ0xIG3mVNtIMWZ9ShlyIBClW3ehuKvJbYguBNH4GkkA?e=sz0crd",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Finance",
      "Resource Name": "Finance Solution Brief",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "PPT Deck",
      "Solution": "Finance",
      "Industry": "_ALL INDUSTRIES, Banking, Insurance: Life & Retirement/Annuity, Capital Markets, Insurance: P&C, Other Industries, Wealth & Asset Management",
      "Persona": "CFO, Office of Controllers, CAO (Actuary)",
      "Pricing": "API Calls",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/GTMPlanning/EdySQm8JkptMgUcVwkEfkd8BE6Sr1PQoySgJ-eyyWNjEsw?e=kr8eB2",
      "External": "https://app.hubspot.com/documents/4052288/summary/6053156",
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Legacy",
      "Resource Name": "Legacy Modernization Overview",
      "Description / Notes": null,
      "Sensitivity": "Internal",
      "Resource Type": "PPT Deck",
      "Solution": "Legacy Modernisation",
      "Industry": "_ALL INDUSTRIES, Banking, Insurance: Life & Retirement/Annuity, Capital Markets, Insurance: P&C, Other Industries, Wealth & Asset Management",
      "Persona": "CTO, CIO (Information), COO, CDO (Digital), CPO (Product)",
      "Pricing": "API Services",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/GTMPlanning/ETXId-KR9o1El2TVVrCSUwgBvqpRJaVn793ZnkkvZNwUdw?e=ZMnVfO",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Legacy",
      "Resource Name": "Legacy Modernization Solution Brief",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "PPT Deck",
      "Solution": "Legacy Modernisation",
      "Industry": "_ALL INDUSTRIES, Banking, Insurance: Life & Retirement/Annuity, Capital Markets, Insurance: P&C, Other Industries, Wealth & Asset Management",
      "Persona": "CTO, CIO (Information), COO, CDO (Digital), CPO (Product)",
      "Pricing": "API Services",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/GTMPlanning/EWzRfWu2Nv1HpCQcJIq2tZMBimXlkuKy5LM-3FvDBYtDUA?e=gJgmpE",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Legacy",
      "Resource Name": "Legacy Modernization Solution Pitch",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "PPT Deck",
      "Solution": "Legacy Modernisation",
      "Industry": "_ALL INDUSTRIES, Banking, Insurance: Life & Retirement/Annuity, Capital Markets, Insurance: P&C, Other Industries, Wealth & Asset Management",
      "Persona": "CTO, CIO (Information), COO, CDO (Digital), CPO (Product)",
      "Pricing": "API Services",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/GTMPlanning/Edf-Q-NQthNPgdNeptglT4UBRe7cq8NxRXQIV8rTjBMRDA?e=5gexCv",
      "External": "https://app.hubspot.com/documents/4052288/summary/5911475",
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Actuarial Modelling",
      "Resource Name": "Actuarial Modelling & IFRS17 Pitch",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "PPT Deck",
      "Solution": "Actuarial Modelling",
      "Industry": "Insurance: Life & Retirement/Annuity, Insurance: P&C",
      "Persona": "CAO (Actuary), CFO",
      "Pricing": "API Calls",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/GTMPlanning/EY8bGXTQixJFtRh9rWPE33UB0s8HlunyvFt13Rx1NSJCCw?e=AJvAqp",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Legacy",
      "Resource Name": "Legacy Modernization DML Tool Video",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Video",
      "Solution": "Legacy Modernisation",
      "Industry": "_ALL INDUSTRIES, Banking, Insurance: Life & Retirement/Annuity, Capital Markets, Insurance: P&C, Other Industries, Wealth & Asset Management",
      "Persona": "CTO, CIO (Information), COO, CDO (Digital), CPO (Product)",
      "Pricing": "API Services",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:v:/s/GTMPlanning/EfbTPDE1vPhNnO4sOxAPf74B0nOHQbpK3L39YCEGW5qK3w?e=kean52",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Modular",
      "Resource Name": "Modular Product Overview",
      "Description / Notes": null,
      "Sensitivity": "Internal",
      "Resource Type": "PPT Deck",
      "Solution": "Modular Product ",
      "Industry": "Insurance: Life & Retirement/Annuity, Insurance: P&C",
      "Persona": "CIO (Information), CTO, CPO (Product), CDO (Digital)",
      "Pricing": "API Services",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/GTMPlanning/Ee0JlBfUyOxBrAQ2tUeWy_QB0AxkuWE2PtowMpWwnp6W1A?e=GgZqOW",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Modular",
      "Resource Name": "Modular Product Solution Brief",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "PPT Deck",
      "Solution": "Modular Product ",
      "Industry": "Insurance: Life & Retirement/Annuity, Insurance: P&C",
      "Persona": "CIO (Information), CTO, CPO (Product), CDO (Digital)",
      "Pricing": "API Services",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/GTMPlanning/ERkMyyO2AJtOiLVM9KpcT08BoqssYaVtA1C-VeEqxKp-hw?e=88gXhz",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Pensions",
      "Resource Name": "Pensions eMPF Solution Brief",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "PPT Deck",
      "Solution": "Pensions | eMPF",
      "Industry": "Insurance: Life & Retirement/Annuity",
      "Persona": "Fund/Pensions Admin, Asset Managers",
      "Pricing": "API Calls",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/GTMPlanning/EdgEEuZzr19Cjv6Dq2HFZGUBvejjXqvpMiKctag9kSY6gg?e=4UkZz7",
      "External": "https://app.hubspot.com/documents/4052288/summary/5941361",
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Pensions",
      "Resource Name": "Pensions eMPF Solution Pitch",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "PPT Deck",
      "Solution": "Pensions | eMPF",
      "Industry": "Insurance: Life & Retirement/Annuity",
      "Persona": "Fund/Pensions Admin, Asset Managers",
      "Pricing": "API Calls",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/GTMPlanning/EbusNqlYuK5LoyoL4KdcOMgBlBEya0gaWr6o9R-M6NlWgQ?e=sH2vI0",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Rating",
      "Resource Name": "Rating Solution Brief",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "PPT Deck",
      "Solution": "Rating / Quotation / Pricing",
      "Industry": "Insurance: Life & Retirement/Annuity, Insurance: P&C",
      "Persona": "CIO (Information), CTO, CDO (Digital), CPO (Product)",
      "Pricing": "API Services",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/GTMPlanning/EbVex2PDHyRAsv2SAVsiXAsBVn_saGxcxb1u_8-dm4PE0w?e=nI4i25",
      "External": "https://app.hubspot.com/documents/4052288/summary/6108489",
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Reconcillation",
      "Resource Name": "Reconciliation Overview",
      "Description / Notes": null,
      "Sensitivity": "Internal",
      "Resource Type": "PPT Deck",
      "Solution": "Reconciliation",
      "Industry": "_ALL INDUSTRIES, Banking, Insurance: Life & Retirement/Annuity, Capital Markets, Insurance: P&C, Other Industries, Wealth & Asset Management",
      "Persona": "COO, CFO, Fund/Pensions Admin, Treasury",
      "Pricing": "API Calls",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/GTMPlanning/EWQjaqMbdopGrN2IoPtZ4wgB-7-QthP-zL_zkKOkAYUIgg?e=Dcp8pN",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Reconcillation",
      "Resource Name": "Reconciliation Solution Brief",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "PPT Deck",
      "Solution": "Reconciliation",
      "Industry": "_ALL INDUSTRIES, Banking, Insurance: Life & Retirement/Annuity, Capital Markets, Insurance: P&C, Other Industries, Wealth & Asset Management",
      "Persona": "COO, CFO, Fund/Pensions Admin, Treasury",
      "Pricing": "API Calls",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/GTMPlanning/EcDy15aInbVNjkxKthpbZQsBKDs1x8sUzKqEUJ4T9JH7ZQ?e=qt1mvF",
      "External": "https://app.hubspot.com/documents/4052288/summary/5911478",
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Reconcillation",
      "Resource Name": "Reconciliation Solution Pitch",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "PPT Deck",
      "Solution": "Reconciliation",
      "Industry": "_ALL INDUSTRIES, Banking, Insurance: Life & Retirement/Annuity, Capital Markets, Insurance: P&C, Other Industries, Wealth & Asset Management",
      "Persona": "COO, CFO, Fund/Pensions Admin, Treasury",
      "Pricing": "API Calls",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/GTMPlanning/ESbV5983HVdFpYZqNlkxow4B9o3aCIPDBg0s2K2gX1oL4A?e=z7uFkQ",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Securities",
      "Resource Name": "Securities Services Overview",
      "Description / Notes": null,
      "Sensitivity": "Internal",
      "Resource Type": "PPT Deck",
      "Solution": "Securities Services",
      "Industry": "Capital Markets",
      "Persona": "COO, CAO (Actuary), CPO (Product), CTO",
      "Pricing": "API Services",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/GTMPlanning/EZHB3vaeQmJPjDngYWDSS4ABhA-l8zqEhD12STGErMLDJg?e=WEx0Ht",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Securities",
      "Resource Name": "Securities Services Solution Brief (Deal Pricing)",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "PPT Deck",
      "Solution": "Securities Services",
      "Industry": "Capital Markets",
      "Persona": "COO, CAO (Actuary), CPO (Product), CTO",
      "Pricing": "API Services",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/GTMPlanning/EQiuro7Kka1ImGDu54CPMgkBZL4z-66bMJIHlVdSH05LXw?e=HQaXMa",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Securities",
      "Resource Name": "Securities Services Solution Brief (Generic)",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "PPT Deck",
      "Solution": "Securities Services",
      "Industry": "Capital Markets",
      "Persona": "COO, CAO (Actuary), CPO (Product), CTO",
      "Pricing": "API Services",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/GTMPlanning/EZi379O7RB1PphUp-XOEpdIBlOEKJ3gt8N5ylkcmVAzC0A?e=Yd81oW",
      "External": "https://app.hubspot.com/documents/4052288/summary/6108474",
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Securities",
      "Resource Name": "Securities Services Solution Pitch (Deal Pricing)",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "PPT Deck",
      "Solution": "Securities Services",
      "Industry": "Capital Markets",
      "Persona": "COO, CAO (Actuary), CPO (Product), CTO",
      "Pricing": "API Services",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/GTMPlanning/EVXBO4-Uyz5OqkQUfZ99FmsBzKpKSdHR_a5JYDaTr-pwCQ?e=9KBFcu",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Securities",
      "Resource Name": "Securities Services Demo Video (Deal Pricing)",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Video",
      "Solution": "Securities Services",
      "Industry": "Capital Markets",
      "Persona": "COO, CAO (Actuary), CPO (Product), CTO",
      "Pricing": "API Services",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:v:/s/GTMPlanning/EfU-F7wMF5xFu91VZrTFxLkBxZ0WeBc44MNNPgWB25qP4w?e=itTYUI",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Securities",
      "Resource Name": "Securities Services Demo Model (Deal Pricing)",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Demo Model",
      "Solution": "Securities Services",
      "Industry": "Capital Markets",
      "Persona": "COO, CAO (Actuary), CPO (Product), CTO",
      "Pricing": "API Services",
      "Internal Sharepoint": "https://spark.uat.us.coherent.global/coherent/products/SS%20Test%20Usecases/Sample%20-%20SS%20Pricing%20template_mapped/serviceDocumentation/uploadSummary",
      "External": null,
      "Video": null,
      "Features": "'Complex Modelling', 'Interactive Front End'",
      "Group ID": 6
    },
    {
      "Topic Group": "Securities",
      "Resource Name": "Securities Services Demo Front-end (Deal Pricing)",
      "Description / Notes": null,
      "Sensitivity": "Internal",
      "Resource Type": "Demo Front-End",
      "Solution": "Securities Services",
      "Industry": "Capital Markets",
      "Persona": "COO, CAO (Actuary), CPO (Product), CTO",
      "Pricing": "API Services",
      "Internal Sharepoint": "https://sspricingtemplate-sandbox.mxapps.io/",
      "External": null,
      "Video": null,
      "Features": "'Complex Modelling', 'Interactive Front End'",
      "Group ID": 6
    },
    {
      "Topic Group": "VBA FAQ",
      "Resource Name": "[FAQ] Does Spark support VBA?",
      "Description / Notes": "#VBA",
      "Sensitivity": "Internal",
      "Resource Type": "HubSpot Snippet",
      "Solution": "_ALL SOLUTIONS / USE CASES",
      "Industry": "_ALL INDUSTRIES",
      "Persona": "_ALL PERSONAS",
      "Pricing": "_ALL PRICING MODELS",
      "Internal Sharepoint": "https://app.hubspot.com/snippets/4052288/edit/2469808?folder=516669&page=1",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "References",
      "Resource Name": "Pricing Strategy",
      "Description / Notes": null,
      "Sensitivity": "Internal",
      "Resource Type": "Internal Ref",
      "Solution": "_ALL SOLUTIONS / USE CASES",
      "Industry": "_ALL INDUSTRIES",
      "Persona": "_ALL PERSONAS",
      "Pricing": "_ALL PRICING MODELS",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/GTMPlanning/Efs9vsu2YcVIj7K7vRXd2xQBJakZFnLntpcoqdj6Zh-xaA?e=2bfeyK",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "References",
      "Resource Name": "EY Intependence Form (Filled Sample Reference)",
      "Description / Notes": null,
      "Sensitivity": "Internal",
      "Resource Type": "Internal Ref",
      "Solution": "_ALL SOLUTIONS / USE CASES",
      "Industry": "_ALL INDUSTRIES",
      "Persona": "_ALL PERSONAS",
      "Pricing": "_ALL PRICING MODELS",
      "Internal Sharepoint": "https://coherentcapital-my.sharepoint.com/:w:/g/personal/amy_ma_coherent_global/EV0ZACh6DwhIn2w7YTqqOCcBHTcrcHXSVvIaWhr9FfcdtQ?e=Y15Ba9",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "References",
      "Resource Name": "Global Case Studies",
      "Description / Notes": null,
      "Sensitivity": "Internal",
      "Resource Type": "Internal Ref",
      "Solution": "_ALL SOLUTIONS / USE CASES",
      "Industry": "_ALL INDUSTRIES",
      "Persona": "_ALL PERSONAS",
      "Pricing": "_ALL PRICING MODELS",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/GTMPlanning/ESVTVB15iWNJibfGxxJvuTUBAVq0lGsBM8Avspj0q7hH_g?e=gzdkoe",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "References",
      "Resource Name": "Shortlisted Case Studies (Cross Sector)",
      "Description / Notes": null,
      "Sensitivity": "Internal",
      "Resource Type": "Internal Ref",
      "Solution": "_ALL SOLUTIONS / USE CASES",
      "Industry": "_ALL INDUSTRIES",
      "Persona": "_ALL PERSONAS",
      "Pricing": "_ALL PRICING MODELS",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/CoherentSales/EQ2MHY-QRlJDjGGZ0DCArmcBMMJMbIiVJnBRUdtX9USfrg?e=mvH6cz",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "References",
      "Resource Name": "Coherent Contract Templates",
      "Description / Notes": "Templates for:\n- NDA\n- Master License Agreement\n- SOW\n- Letter of Intent\n- Partnership Agreement\n- Starter Tenant\n- Project Agreement\n\nNote: There may be different templates for US versus NON-US, as well as some templates specific to a unique country. ",
      "Sensitivity": "Internal",
      "Resource Type": "Internal Ref",
      "Solution": "_ALL SOLUTIONS / USE CASES",
      "Industry": "_ALL INDUSTRIES",
      "Persona": "_ALL PERSONAS",
      "Pricing": "_ALL PRICING MODELS",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:f:/s/BillingsandContracts/Eg0s6YUFlI5JvrOQDI3h2XIBxBHTKgEso65oVyG3y_4n5w",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "ESG",
      "Resource Name": "ESG Solution Overview",
      "Description / Notes": null,
      "Sensitivity": "Internal",
      "Resource Type": "Internal Ref",
      "Solution": "ESG (Modelling and Reporting)",
      "Industry": "_ALL INDUSTRIES, Banking, Insurance: Life & Retirement/Annuity, Capital Markets, Insurance: P&C, Other Industries, Wealth & Asset Management",
      "Persona": "CSO (Sustainability), CRO (Risk), CIO (Investment)",
      "Pricing": "API Calls",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/GTMPlanning/ES6BazUa-cNBkIXAyUXOSs8BzAZSHKsDaqwVPyXK1v2-aw?e=QDJN5G",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "EUC",
      "Resource Name": "EUC Solution Deep Dive",
      "Description / Notes": null,
      "Sensitivity": "Internal",
      "Resource Type": "Gong Call",
      "Solution": "EUC (End User Computing)",
      "Industry": "_ALL INDUSTRIES, Banking, Insurance: Life & Retirement/Annuity, Capital Markets, Insurance: P&C, Other Industries, Wealth & Asset Management",
      "Persona": "COO, CRO (Risk), CAO (Actuary), CTO, Office of Controllers",
      "Pricing": "Models Stored",
      "Internal Sharepoint": "https://us-53346.app.gong.io/call?id=7724408862539474820&xtid=5ftk06cza2t9oqx6lno",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Loan",
      "Resource Name": "Loan Origination Solution Deep Dive",
      "Description / Notes": null,
      "Sensitivity": "Internal",
      "Resource Type": "Gong Call",
      "Solution": "Loan Origination ",
      "Industry": "Banking",
      "Persona": "COO, CRO (Risk), Head of Credit Risk, CPO (Product)",
      "Pricing": "API Calls",
      "Internal Sharepoint": "https://us-53346.app.gong.io/call?id=3659757998097092881&xtid=7n7i7m2jairl1deize9",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Loan",
      "Resource Name": "Reconciliation Solution Deep Dive",
      "Description / Notes": null,
      "Sensitivity": "Internal",
      "Resource Type": "Gong Call",
      "Solution": "Reconciliation",
      "Industry": "_ALL INDUSTRIES, Banking, Insurance: Life & Retirement/Annuity, Capital Markets, Insurance: P&C, Other Industries, Wealth & Asset Management",
      "Persona": "COO, CFO, Fund/Pensions Admin, Treasury",
      "Pricing": "API Calls",
      "Internal Sharepoint": "https://us-53346.app.gong.io/call?id=6754232489124813087&xtid=5rlzjakw14frx0tmq88",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Legacy",
      "Resource Name": "Legacy Modernization Solution Deep Dive",
      "Description / Notes": null,
      "Sensitivity": "Internal",
      "Resource Type": "Gong Call",
      "Solution": "Legacy Modernisation",
      "Industry": "_ALL INDUSTRIES, Banking, Insurance: Life & Retirement/Annuity, Capital Markets, Insurance: P&C, Other Industries, Wealth & Asset Management",
      "Persona": "CTO, CIO (Information), COO, CDO (Digital), CPO (Product)",
      "Pricing": "API Services",
      "Internal Sharepoint": "https://us-53346.app.gong.io/call?id=7907436144309580545&xtid=5yn2b1alm70803u3mjp",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Insurance",
      "Resource Name": "Insurance Sector Intro",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "PPT Deck",
      "Solution": "_ALL SOLUTIONS / USE CASES",
      "Industry": "Insurance: Life & Retirement/Annuity, Insurance: P&C",
      "Persona": "_ALL PERSONAS",
      "Pricing": "_ALL PRICING MODELS",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/GTMPlanning/EXMGbYe1TFVPhXV-ExGnZD8BTK0tGL863swcSfkV40iMlQ?e=WDWYX4",
      "External": "https://app.hubspot.com/documents/4052288/summary/5911465",
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "BCM",
      "Resource Name": "Banking & Capital Markets Sector Intro",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "PPT Deck",
      "Solution": "_ALL SOLUTIONS / USE CASES",
      "Industry": "Banking, Capital Markets",
      "Persona": "_ALL PERSONAS",
      "Pricing": "_ALL PRICING MODELS",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/GTMPlanning/EUNnR1AmgfRAimn8PyIH8a4B6AihBKhYHNsFE1SlVwgZGg?e=hkO2e6",
      "External": "https://app.hubspot.com/documents/4052288/summary/5992553",
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Legacy",
      "Resource Name": "Legacy Modernization Video",
      "Description / Notes": "Coherent branded - new branding",
      "Sensitivity": "External",
      "Resource Type": "Video",
      "Solution": "Legacy Modernisation",
      "Industry": "_ALL INDUSTRIES, Banking, Insurance: Life & Retirement/Annuity, Capital Markets, Insurance: P&C, Other Industries, Wealth & Asset Management",
      "Persona": "CTO, CIO (Information), COO, CDO (Digital), CPO (Product)",
      "Pricing": "API Services",
      "Internal Sharepoint": null,
      "External": null,
      "Video": "https://resources.coherent.global/content/legacy-modernization-with-spark/",
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "ESG",
      "Resource Name": "ESG Solution Deep Dive",
      "Description / Notes": null,
      "Sensitivity": "Internal",
      "Resource Type": "Gong Call",
      "Solution": "ESG (Modelling and Reporting)",
      "Industry": "_ALL INDUSTRIES, Banking, Insurance: Life & Retirement/Annuity, Capital Markets, Insurance: P&C, Other Industries, Wealth & Asset Management",
      "Persona": "CSO (Sustainability), CRO (Risk), CIO (Investment)",
      "Pricing": "API Calls",
      "Internal Sharepoint": "https://us-53346.app.gong.io/call?id=8589206571113212441",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "ESG",
      "Resource Name": "ESG Demo Model (Portfolio Analytics)",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Demo Model",
      "Solution": "ESG (Modelling and Reporting)",
      "Industry": "_ALL INDUSTRIES, Capital Markets, Banking",
      "Persona": "Asset Managers, CIO (Investment), CRO (Risk), CSO (Sustainability)",
      "Pricing": "API Calls",
      "Internal Sharepoint": "https://spark.staging.coherent.global/coherent/products/ESG%20Investment%20Screening",
      "External": null,
      "Video": null,
      "Features": "'Complex Modelling', 'xCall', 'Data Consolidation', 'Goal Seek', 'Data Illustration', 'Interactive Front End'",
      "Group ID": 2
    },
    {
      "Topic Group": "ESG",
      "Resource Name": "ESG Demo Front-end (Portfolio Analytics)",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Demo Front-End",
      "Solution": "ESG (Modelling and Reporting)",
      "Industry": "_ALL INDUSTRIES, Capital Markets, Banking",
      "Persona": "Asset Managers, CIO (Investment), CRO (Risk), CSO (Sustainability)",
      "Pricing": "API Calls",
      "Internal Sharepoint": "https://coherentspark-esg-screener.streamlit.app/",
      "External": null,
      "Video": null,
      "Features": "'Complex Modelling', 'xCall', 'Data Consolidation', 'Goal Seek', 'Data Illustration', 'Interactive Front End'",
      "Group ID": 2
    },
    {
      "Topic Group": "Feature",
      "Resource Name": "Introducing Coherent XCall",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Video",
      "Solution": "_ALL SOLUTIONS / USE CASES",
      "Industry": "_ALL INDUSTRIES",
      "Persona": "_ALL PERSONAS",
      "Pricing": null,
      "Internal Sharepoint": null,
      "External": null,
      "Video": "https://resources.coherent.global/?s=xcall&wpessid=990613",
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "References",
      "Resource Name": "Portfolio Optimization Tool",
      "Description / Notes": null,
      "Sensitivity": null,
      "Resource Type": null,
      "Solution": null,
      "Industry": null,
      "Persona": null,
      "Pricing": null,
      "Internal Sharepoint": "https://portfoliooptimization.showcase.coherent.global/",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "References",
      "Resource Name": "New Corporate Intro Deck (7 June)",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "PPT Deck",
      "Solution": null,
      "Industry": null,
      "Persona": null,
      "Pricing": null,
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/g/EZbWN_SgBd1PibJKzO9CJXIBe0gNsn4_t4y6vsffG7SpHA?e=1TGWLd",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "ESG",
      "Resource Name": "ESG Znglist",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Znglist",
      "Solution": "ESG (Modelling and Reporting)",
      "Industry": "_ALL INDUSTRIES",
      "Persona": "_ALL PERSONAS",
      "Pricing": null,
      "Internal Sharepoint": "https://resources.coherent.global/znglist/esg-modelling-with-no-compromises-2/?c=cG9zdDo5OTE2NDM=",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Modular",
      "Resource Name": "Modular Insurance (Cross Sector) Znglist",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Znglist",
      "Solution": "Modular Product ",
      "Industry": "Insurance: Life & Retirement/Annuity, Insurance: P&C, Banking",
      "Persona": null,
      "Pricing": null,
      "Internal Sharepoint": "https://resources.coherent.global/znglist/modular-insurance/?c=cG9zdDo5OTE4MTc=",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Cross Sector",
      "Resource Name": "Excel as a Programming Language (Cross Sector) Znglist",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Znglist",
      "Solution": "_ALL SOLUTIONS / USE CASES",
      "Industry": "_ALL INDUSTRIES",
      "Persona": null,
      "Pricing": null,
      "Internal Sharepoint": "https://resources.coherent.global/znglist/excel-as-a-programming-language-2/?c=cG9zdDo5OTE4Mzk=",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Digital Bank",
      "Resource Name": "Digibank Znglist",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Znglist",
      "Solution": "Finance, EUC (End User Computing)",
      "Industry": "Banking",
      "Persona": null,
      "Pricing": null,
      "Internal Sharepoint": "https://resources.coherent.global/znglist/digibank/?c=cG9zdDo5OTEzNTg=",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Actuarial Modelling",
      "Resource Name": "Actuarial 3.0 Znglist",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Znglist",
      "Solution": "Actuarial Modelling",
      "Industry": "Insurance: P&C, Insurance: Life & Retirement/Annuity",
      "Persona": null,
      "Pricing": null,
      "Internal Sharepoint": "https://resources.coherent.global/znglist/actuary3-0-ebook/?c=cG9zdDo5OTE4OTI=",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "BCM",
      "Resource Name": "BCM Znglist",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Znglist",
      "Solution": "EUC (End User Computing), Finance, Legacy Modernisation, Loan Origination , Reconciliation, Securities Services",
      "Industry": "Banking, Capital Markets",
      "Persona": null,
      "Pricing": null,
      "Internal Sharepoint": "https://resources.coherent.global/znglist/banking-and-capital-markets/?c=cG9zdDo5OTE4OTY=",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Insurance",
      "Resource Name": "Insurance Znglist",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Znglist",
      "Solution": "Actuarial Modelling, Legacy Modernisation, Modular Product , Rating / Quotation / Pricing",
      "Industry": "Insurance: Life & Retirement/Annuity, Insurance: P&C",
      "Persona": null,
      "Pricing": null,
      "Internal Sharepoint": "https://resources.coherent.global/znglist/insurance/?c=cG9zdDo5OTE5MjA=",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Modular",
      "Resource Name": "Modular Insurance with Spark Znglist",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Znglist",
      "Solution": "Modular Product ",
      "Industry": "Insurance: Life & Retirement/Annuity, Insurance: P&C",
      "Persona": null,
      "Pricing": null,
      "Internal Sharepoint": "https://resources.coherent.global/znglist/modular-insurance-with-spark/?c=cG9zdDo5OTE4MjA=",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Securities",
      "Resource Name": "Secure 2.0 Znglist",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Znglist",
      "Solution": "Pensions | Secure 2.0",
      "Industry": "Wealth & Asset Management",
      "Persona": null,
      "Pricing": null,
      "Internal Sharepoint": "https://resources.coherent.global/znglist/secure-2-0-update/?c=cG9zdDo5OTEzNjM=",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "References",
      "Resource Name": "Onboarding Series Znglist",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Znglist",
      "Solution": "_ALL SOLUTIONS / USE CASES",
      "Industry": "_ALL INDUSTRIES",
      "Persona": null,
      "Pricing": null,
      "Internal Sharepoint": "https://resources.coherent.global/znglist/onboarding-series/?c=cG9zdDo5OTE2OTg=",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Legacy",
      "Resource Name": "Legacy Modernization Znglist",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Znglist",
      "Solution": "Legacy Modernisation",
      "Industry": "Insurance: Life & Retirement/Annuity, Insurance: P&C, Banking",
      "Persona": null,
      "Pricing": null,
      "Internal Sharepoint": "https://resources.coherent.global/znglist/legacy-modernization/?c=cG9zdDo5OTE0NzY=",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Data Mgt",
      "Resource Name": "Data Management Znglist",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Znglist",
      "Solution": "Data Management",
      "Industry": "_ALL INDUSTRIES",
      "Persona": null,
      "Pricing": null,
      "Internal Sharepoint": "https://resources.coherent.global/znglist/data-management-with-spark/?c=cG9zdDo5OTIwMjc=",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Legacy",
      "Resource Name": "Cognizant co-branded Legacy Modernization Video",
      "Description / Notes": "Co-branded with Cognizant",
      "Sensitivity": "External",
      "Resource Type": "Video",
      "Solution": "Legacy Modernisation",
      "Industry": "_ALL INDUSTRIES, Banking, Insurance: Life & Retirement/Annuity, Capital Markets, Insurance: P&C, Other Industries, Wealth & Asset Management",
      "Persona": "CTO, CIO (Information), COO, CDO (Digital), CPO (Product)",
      "Pricing": "API Services",
      "Internal Sharepoint": "https://onedrive.live.com/?authkey=%21ADEf41vv1KMOpyI&id=C7DD9FC33EDA6791%21442&cid=C7DD9FC33EDA6791&parId=root&parQt=sharedby&o=OneUp",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Banking Stress Test",
      "Resource Name": "Bank Stress Testing Demo - Spark UI",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Demo Model",
      "Solution": "Finance",
      "Industry": "Banking",
      "Persona": null,
      "Pricing": null,
      "Internal Sharepoint": "https://spark.uat.us.coherent.global/coherent/products/Spark%20FE%20Demos/banking-stress-test/serviceDocumentation/uploadSummary",
      "External": null,
      "Video": null,
      "Features": "'Complex Modelling', 'xCall', 'Data Consolidation', 'Data Illustration', 'Interactive Front End'",
      "Group ID": 7
    },
    {
      "Topic Group": "Banking Stress Test",
      "Resource Name": "Bank Stress Testing Demo - Front End",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Demo Front-End",
      "Solution": "Finance",
      "Industry": "Banking",
      "Persona": null,
      "Pricing": null,
      "Internal Sharepoint": "coherent-demos-fs-cmb-stresstest-streamlit-app-13rqyd.streamlit.app/",
      "External": null,
      "Video": null,
      "Features": "'Complex Modelling', 'xCall', 'Data Consolidation', 'Data Illustration', 'Interactive Front End'",
      "Group ID": 7
    },
    {
      "Topic Group": "Banking Stress Test",
      "Resource Name": "Bank Stress Testing Demo - PPT Guide",
      "Description / Notes": null,
      "Sensitivity": "Internal",
      "Resource Type": "PPT Deck",
      "Solution": "Finance",
      "Industry": "Banking",
      "Persona": null,
      "Pricing": null,
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/SalesEngineering/EezWnGZNq9xGqfKghcSHmLsBDnKLV51Nshg7bJsmm27Zgg?e=wj7fzk",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "Digital Bank",
      "Resource Name": "Digital Bank Embedded Insurance Demo - Spark UI",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Demo Model",
      "Solution": "Finance",
      "Industry": "Banking",
      "Persona": null,
      "Pricing": null,
      "Internal Sharepoint": "https://spark.staging.coherent.global/coherentflex/products/Bill%",
      "External": null,
      "Video": null,
      "Features": "'Complex Modelling', 'xCall', 'Interactive Front End'",
      "Group ID": 8
    },
    {
      "Topic Group": "Digital Bank",
      "Resource Name": "Digital Bank Embedded Insurance Demo - Front End",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Demo Front-End",
      "Solution": "Finance",
      "Industry": "Banking",
      "Persona": null,
      "Pricing": null,
      "Internal Sharepoint": "https://coherentdemos.com/",
      "External": null,
      "Video": null,
      "Features": "'Complex Modelling', 'xCall', 'Interactive Front End'",
      "Group ID": 8
    },
    {
      "Topic Group": "Digital Bank",
      "Resource Name": "Personalized Embedded Insurance Use Case with mock-up screens",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "PPT Deck",
      "Solution": "Finance",
      "Industry": "Insurance: P&C",
      "Persona": "CCO (Customer), CDO (Digital), CPO (Product)",
      "Pricing": "API Calls",
      "Internal Sharepoint": "https://coherentcapital.sharepoint.com/:p:/s/GTMPlanning/ERmSsslGGuROih_H9vDIZqsBZ6rrfr14gVtNeIrp9m8H9g?e=SIn6KY",
      "External": null,
      "Video": null,
      "Features": null,
      "Group ID": null
    },
    {
      "Topic Group": "ECL",
      "Resource Name": "Expected Credit Loss Calculator - Demo",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Demo Front-End",
      "Solution": "Finance",
      "Industry": "Banking",
      "Persona": null,
      "Pricing": null,
      "Internal Sharepoint": "https://expectedcreditlosscalc.showcase.coherent.global/",
      "External": null,
      "Video": null,
      "Features": "'Complex Modelling', 'Data Illustration', 'Interactive Front End'",
      "Group ID": 9
    },
    {
      "Topic Group": "ECL",
      "Resource Name": "Expected Credit Loss Calculator - Spark UI",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Demo Model",
      "Solution": "Finance",
      "Industry": "Banking",
      "Persona": null,
      "Pricing": null,
      "Internal Sharepoint": "https://spark.uat.us.coherent.global/coherent/products/Agilno%20Powered%20by%20Spark/ECL%20model_Revolving%20Calculation%20and%20ECL%20Model_PR/apiTester/test",
      "External": null,
      "Video": null,
      "Features": "'Complex Modelling', 'Data Illustration', 'Interactive Front End'",
      "Group ID": 9
    },
    {
      "Topic Group": "Insurance",
      "Resource Name": "Cyber Insurance Rater - Demo",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Demo Front-End",
      "Solution": "Finance",
      "Industry": "Insurance: P&C",
      "Persona": null,
      "Pricing": null,
      "Internal Sharepoint": "https://cyberinsurancerater.demo.coherent.global/",
      "External": null,
      "Video": null,
      "Features": "'Interactive Front End'",
      "Group ID": 10
    },
    {
      "Topic Group": "Insurance",
      "Resource Name": "Cyber Insurance Rater - Spark UI",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Demo Model",
      "Solution": "Finance",
      "Industry": "Insurance: P&C",
      "Persona": null,
      "Pricing": null,
      "Internal Sharepoint": "https://spark.uat.us.coherent.global/coherent/products/Agilno%20Powered%20by%20Spark/DEMOS_Agilno_CyberRater/apiTester/test",
      "External": null,
      "Video": null,
      "Features": "'Interactive Front End'",
      "Group ID": 10
    },
    {
      "Topic Group": "Finance",
      "Resource Name": "Bond Valuation Calculator - Demo",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Demo Front-End",
      "Solution": "Finance",
      "Industry": "Banking",
      "Persona": null,
      "Pricing": null,
      "Internal Sharepoint": "https://bondvaluecalc.showcase.coherent.global/",
      "External": null,
      "Video": null,
      "Features": "'Complex Modelling', 'Interactive Front End'",
      "Group ID": 11
    },
    {
      "Topic Group": "Finance",
      "Resource Name": "Bond Valuation Calculator - Spark UI",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Demo Model",
      "Solution": "Finance",
      "Industry": "Banking",
      "Persona": null,
      "Pricing": null,
      "Internal Sharepoint": "https://spark.uat.us.coherent.global/coherent/products/Agilno%20Powered%20by%20Spark/Bond%20valuation%20calculator_Bond%20MV%20Calc%20(2)/apiTester/test",
      "External": null,
      "Video": null,
      "Features": "'Complex Modelling', 'Interactive Front End'",
      "Group ID": 11
    },
    {
      "Topic Group": "Loan",
      "Resource Name": "Home Affordability Calculator - Demo",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Demo Front-End",
      "Solution": "Loan Origination ",
      "Industry": "Banking",
      "Persona": null,
      "Pricing": null,
      "Internal Sharepoint": "https://homeaffordabilitycalc.showcase.coherent.global/",
      "External": null,
      "Video": null,
      "Features": "'Interactive Front End'",
      "Group ID": 12
    },
    {
      "Topic Group": "Loan",
      "Resource Name": "Home Affordability Calculator - Spark UI",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Demo Model",
      "Solution": "Loan Origination ",
      "Industry": "Banking",
      "Persona": null,
      "Pricing": null,
      "Internal Sharepoint": "https://spark.uat.us.coherent.global/coherent/products/Agilno%20Powered%20by%20Spark/DEMOS_home_affordability/apiTester/test",
      "External": null,
      "Video": null,
      "Features": "'Interactive Front End'",
      "Group ID": 12
    },
    {
      "Topic Group": "Finance",
      "Resource Name": "401k Calculator - Demo",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Demo Front-End",
      "Solution": "Pensions",
      "Industry": "Insurance: P&C",
      "Persona": null,
      "Pricing": null,
      "Internal Sharepoint": "https://401calc.showcase.coherent.global/",
      "External": null,
      "Video": null,
      "Features": "'Complex Modelling', 'Interactive Front End'",
      "Group ID": 13
    },
    {
      "Topic Group": "Finance",
      "Resource Name": "401k Calculator - Spark UI",
      "Description / Notes": null,
      "Sensitivity": "External",
      "Resource Type": "Demo Model",
      "Solution": "Pensions",
      "Industry": "Insurance: P&C",
      "Persona": null,
      "Pricing": null,
      "Internal Sharepoint": "https://spark.uat.us.coherent.global/coherent/products/Agilno%20Powered%20by%20Spark/DEMOS_Spark_401k_Pricing_Model/apiTester/test",
      "External": null,
      "Video": null,
      "Features": "'Complex Modelling', 'Interactive Front End'",
      "Group ID": 13
    }
  ],
        "apikey": "2277565c-9fad-4bf4-ad2b-1efe5748dd11",
        "tenant": "coherent",
        "url": "https://excel.uat.us.coherent.global/coherent/api/v3/folders/Spark FE Demos/services/demo-catalog/Execute"
      }
    }
  }
})();



"use strict";

(function () {
  'use strict';

  angular.module('CoherentDemos').controller('CatalogLandingController', CatalogLandingController);
  /** @ngInject */

  function CatalogLandingController($http, CatalogService, $stateParams, $location, $state) {
    var vm = this;

    vm.prioritizeList = function(jsonData) {
      // Create an object to track the order of each group ID
      var groupOrder = {};

      jsonData.sort(function(a, b) {
        if (a["Group ID"] === null && b["Group ID"] === null) {
          return 0;
        }
        if (a["Group ID"] === null) {
          return 1;
        }
        if (b["Group ID"] === null) {
          return -1;
        }

        // Update the group order if it doesn't exist
        if (!groupOrder[a["Group ID"]]) {
          groupOrder[a["Group ID"]] = 1;
        }
        if (!groupOrder[b["Group ID"]]) {
          groupOrder[b["Group ID"]] = 1;
        }

        // Compare group IDs
        if (a["Group ID"] !== b["Group ID"]) {
          return a["Group ID"] - b["Group ID"];
        }

        // Update orderInGroup based on group order
        if (groupOrder[a["Group ID"]] === 1) {
          a.orderInGroup = "last";
          b.orderInGroup = "first";
        } else {
          a.orderInGroup = "last";
          b.orderInGroup = "first";
        }
        groupOrder[a["Group ID"]] += 2; // Increment by 2 for "first" and "last"

        return 0;
      });
      return jsonData;
    };

    vm.coreSolutions = CatalogService.coreSolutions
    vm.Features = CatalogService.Features

    vm.quickFilter = function(item) {
      var element = document.getElementById('materials-list');
      vm.searchTerm = item.keywords
      element.scrollIntoView({ behavior: 'smooth' });
      var keywords = item.keywords.replace(/\//g, ' ').replace(/  /g, '');
      if (vm.isCoreSolutions) {
        $state.go('catalog-search', { urlSearchTerm: keywords }, { notify: false });
      } else {
        $state.go('catalog-search-features', { urlSearchTerm: keywords }, { notify: false });
      }
    }

    vm.scrollTo = function(id) {
      var element = document.getElementById(id);
      element.scrollIntoView({ behavior: 'smooth' });
    }

    vm.searchFilter = function(item) {
      if (!vm.searchTerm) {
        return true; // No search term provided, show all items
      }

      var searchTerm = vm.searchTerm.toLowerCase();
      var searchTerms = [];
      var regex = /[^\s"]+|"([^"]*)"/gi;

      var match;
      while ((match = regex.exec(searchTerm)) !== null) {
        // Add non-empty matches or content inside double quotes to the search terms array
        if (match[1] !== undefined) {
          searchTerms.push(match[1]);
        } else if (match[0].trim() !== "") {
          searchTerms.push(match[0]);
        }
      }

      if (item['Resource Name']) {
        var itemName = item['Resource Name'].toLowerCase();
      } else {
        var itemName = "";
      }

      if (item['Topic Group']) {
        var itemTopic = item['Topic Group'].toLowerCase();
      } else {
        var itemTopic = "";
      }

      if (item['Features']) {
        var itemFeatures = item['Features'].toLowerCase();
      } else {
        var itemFeatures = "";
      }

      // Check if any search term matches any of the fields
      for (var i = 0; i < searchTerms.length; i++) {
        var term = searchTerms[i];
        if (vm.isCoreSolutions&&(itemName.includes(term) || itemTopic.includes(term))) {
          return true; // Show the item if any term matches
        } else if(vm.isFeatures&&itemFeatures.includes(term)) {
          return true; // Show the item if any term matches
        }
      }

      return false; // No matching terms found
    };

    vm.formatFeatures = function(inputString) {
      if (inputString) {
        // Remove square brackets and any trailing comma
        var trimmedString = inputString.replace(/^\[|\]$/g, '').trim();

        // Split the string into an array, remove single quotes, and add spaces after commas
        var arrayItems = trimmedString.split(',').map(function(item) {
          return item.trim().replace(/'/g, '');
        });
        for (var i = arrayItems.length - 1; i >= 0; i--) {
            if (arrayItems[i] === '') {
                arrayItems.splice(i, 1);
            }
        }
        var result = arrayItems.join(', ');
        return result
      } else {
        return ""
      }
    }

    vm.isImportant = function(type) {if (type=='Demo Front-End') {return true} else {return false}}
    vm.isZnglist = function(type) {if (type=='Znglist') {return true} else {return false}}
    vm.isModel = function(type) {if (type=='Demo Model') {return true} else {return false}}
    vm.isPPT = function(type) {if (type=='PPT Deck') {return true} else {return false}}
    vm.isGong = function(type) {if (type=='Gong Call') {return true} else {return false}}

    vm.isCoreSolutions = true;
    vm.isFeatures = false;
    vm.tileList = vm.coreSolutions;

    vm.tileMenu = function(selection) {
      if (selection=='Features') {
        vm.isFeatures = true; vm.isCoreSolutions = false;
        vm.tileList = vm.Features;
      } else {
        vm.isFeatures = false; vm.isCoreSolutions = true;
        vm.tileList = vm.coreSolutions;
      }
    }

    vm.isFirstInBundle = function (item) {
      var i = vm.filteredData.indexOf(item)
      if (item['Group ID']) {
        return true
      } else {
        return false
      }
    }

    vm.clearSearch = function() {
      vm.searchTerm = "";
      vm.filteredData = vm.originalData;
      $state.go('catalog-landing', { urlSearchTerm: '' }, { notify: false });
    }

    vm.catalogAPIInput = JSON.parse(CatalogService.apiConstants.catalog.inputTemplate)

    // CatalogService.getCatalog(vm.catalogAPIInput)
    //   .then(function(outputs) {
    //     vm.catalogData = outputs.catalog
    //   })
    //   .catch(function(error) {
    //     console.error("API call error:", error);
    //   });

    function replaceNameErrorWithNull(obj) {
      for (var key in obj) {
          if (obj[key] === "#NAME?") {
              obj[key] = null;
          } else if (typeof obj[key] === 'object' && obj[key] !== null) {
              replaceNameErrorWithNull(obj[key]);
          }
      }
      return obj;
  }

    vm.authenticate = function(pw) {
      vm.isLoading = true 
      var req = {
        method: 'POST',
        url: 'https://excel.uat.us.coherent.global/coherent/api/v3/folders/Spark%20FE%20Demos/services/demo-catalog-v2/execute',
        headers: {
          'SecretKey': '2277565c-9fad-4bf4-ad2b-1efe5748dd11',
          'x-tenant-name': 'coherent'
        },
        data: {"request_data":{"inputs":{ "authenticate.PW":pw}},"request_meta":{"service_category":"#Default#,authenticate","compiler_type":"Neuron"}}
      };
      $http(req).then(function (response) {
        vm.isLoading = false
        if(response.data.response_data.outputs["authenticate.Validate"]==true)  {
          vm.authenticated = true
          vm.ProcessStep1 = replaceNameErrorWithNull(response.data.response_data.outputs)
          vm.originalData = vm.prioritizeList(vm.ProcessStep1["authenticate.catalog"]);
          vm.filteredData = vm.originalData;
          if($stateParams.urlSearchTerm) {
            vm.searchTerm = $stateParams.urlSearchTerm;
            if($state.current.name=='catalog-search-features') {
              vm.tileMenu('Features')  
            }
            setTimeout(function() {
              vm.scrollTo('materials-list');
            }, 1);
          }
        }
      }, function () {});
    }

    vm.getCatalog = function(pw) {
      vm.isLoading = true 
      var req = {
        method: 'POST',
        url: 'https://excel.uat.us.coherent.global/coherent/api/v3/folders/Spark%20FE%20Demos/services/demo-catalog-v2/execute',
        headers: {
          'SecretKey': '2277565c-9fad-4bf4-ad2b-1efe5748dd11',
          'x-tenant-name': 'coherent'
        },
        data: {"request_data":{"inputs":{ "authenticate.PW":pw}},"request_meta":{"service_category":"#Default#,authenticate","compiler_type":"Neuron"}}
      };
      $http(req).then(function (response) {
        vm.isLoading = false
        if(response.data.response_data.outputs["authenticate.Validate"]==true)  {
          vm.authenticated = true
          vm.originalData = vm.prioritizeList(response.data.response_data.outputs["authenticate.catalog"]);
          vm.filteredData = vm.originalData;
          if($stateParams.urlSearchTerm) {
            vm.searchTerm = $stateParams.urlSearchTerm;
            if($state.current.name=='catalog-search-features') {
              vm.tileMenu('Features')  
            }
            setTimeout(function() {
              vm.scrollTo('materials-list');
            }, 1);
          }
        }
      }, function () {});
    }

    // //search function
    // vm.filterData = function(item) {
    //   vm.originalData = originalData
    //   for(var i=0;i<originalData.length;i++) {
    //     if(originalData[i]["Resource Name"].includes || )
    //   }
    // };

    vm.authenticated = false
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('CoherentDemos').controller('ScanToPay3Controller', ScanToPay3Controller);
  /** @ngInject */

  function ScanToPay3Controller($state, EmbeddedService, $http) {
    var vm = this;

    vm.merchantObject = EmbeddedService.merchantObject

    vm.go = function() {
      $state.go('embedded-landing');
    }

    vm.txn = EmbeddedService.txn

  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('CoherentDemos').controller('ScanToPay2Controller', ScanToPay2Controller);
  /** @ngInject */

  function ScanToPay2Controller($state, EmbeddedService, $http) {
    var vm = this;    
    
    vm.merchants = EmbeddedService.merchants;
    vm.checkbox = true;
    vm.productRotationInput = EmbeddedService.productRotationInput;
    vm.billType = EmbeddedService.billType;
    
    if(EmbeddedService.merchant == "") {
      vm.merchant = vm.merchants[0].name
      EmbeddedService.merchant = vm.merchant
    } else {
      vm.merchant = EmbeddedService.merchant
    }

    function getObjectByParameter(objectsArray, paramName, paramValue) {
      for (var i=0;i<objectsArray.length;i++) {
        if (objectsArray[i][paramName] === paramValue) {
          return objectsArray[i];
        }
      }
      return null; // Return null if no matching object is found
    }

    vm.setMode = function(mode) {
      vm.priceMode = mode
      if(mode=='multi') {
        vm.premium = vm.billAmount * 0.1
      } else {
        vm.premium = vm.merchantObject.basePremium
      }
    }
    vm.billAmount = getObjectByParameter(vm.merchants, 'name', vm.merchant).amount
    vm.merchantObject = getObjectByParameter(vm.merchants, 'name', vm.merchant)
    EmbeddedService.merchantObject = vm.merchantObject
    vm.setMode('fixed')

    vm.txn = {}
    
    vm.go = function() {
      vm.txn.amount = vm.billAmount + vm.premium
      vm.txn.source = "Deposit Account"
      vm.txn.destination = vm.merchant

      EmbeddedService.txn = vm.txn

      $state.go('scan-to-pay-3');
    }

  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('CoherentDemos').controller('ScanToPay1Controller', ScanToPay1Controller);
  /** @ngInject */

  function ScanToPay1Controller($state, EmbeddedService, $http) {
    var vm = this;

    vm.goback = function() {
      $state.go('embedded-landing');
    }

    vm.go = function() {
      $state.go('scan-to-pay-2');
    }

    vm.merchants = EmbeddedService.merchants
    
    if(EmbeddedService.merchant == "") {
      vm.merchant = vm.merchants[0].name
      EmbeddedService.merchant = vm.merchant
    } else {
      vm.merchant = EmbeddedService.merchant
    }

    vm.setMerchant = function(name) {
      vm.merchant = name
      EmbeddedService.merchant = vm.merchant
    }

  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('CoherentDemos').controller('PayBills4Controller', PayBills4Controller);
  /** @ngInject */

  function PayBills4Controller($state, EmbeddedService, $http) {
    var vm = this;

    vm.go = function() {
      $state.go('pay-bills-1');
    }

  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('CoherentDemos').controller('PayBills3Controller', PayBills3Controller);
  /** @ngInject */

  function PayBills3Controller($state, EmbeddedService, $http) {
    var vm = this;

    vm.biller = EmbeddedService.biller;
    vm.checkbox = true;
    vm.productRotationInput = EmbeddedService.productRotationInput;
    vm.billType = EmbeddedService.billType;
    vm.checkbox = false;

    function getObjectByParameter(objectsArray, paramName, paramValue) {
      for (var i=0;i<objectsArray.length;i++) {
        if (objectsArray[i][paramName] === paramValue) {
          return objectsArray[i];
        }
      }
      return null; // Return null if no matching object is found
    }

    vm.getProduct = function() {
      vm.productRotationInput.request_data.inputs.BillType = EmbeddedService.billType;
      vm.productRotationInput.request_data.inputs.Amount = vm.billAmount;
      var req = {
        method: 'POST',
        url: 'https://excel.uat.us.coherent.global/coherent/api/v3/folders/Spark FE Demos/services/Product Rotation/Execute',
        headers: {
          'SecretKey': '2277565c-9fad-4bf4-ad2b-1efe5748dd11',
          'x-tenant-name': 'coherent'
        },
        data: vm.productRotationInput
      };
      $http(req).then(function (response) {
        vm.data = response.data.response_data.outputs;
        vm.product = getObjectByParameter(vm.data.ProductDetails, 'Product', vm.data.NextOffer);
        vm.product.ProductTrim = vm.product.Product.toLowerCase().replace(/ /g, '-');
        vm.productName = vm.data.NextOffer;
        vm.cover = vm.billAmount * vm.product.Cover;
        vm.premium = vm.cover * 1.5;
        vm.activeRule = getObjectByParameter(vm.data.RuleResults, "Apply", true);
      }, function () {});
    }

    vm.go = function() {
      EmbeddedService.productRotationInput.request_data.inputs.FirstBill = false;
      EmbeddedService.productRotationInput.request_data.inputs.LastViewed = vm.productName;
      $state.go('pay-bills-4');
    }

    vm.snooze = function() {
      vm.productRotationInput.request_data.inputs.FirstBill = false;
      vm.productRotationInput.request_data.inputs.LastViewed = vm.productName;
      vm.getProduct();
    }

    if(vm.billType=='') {
      $state.go('pay-bills-1');
    }
    vm.getProduct();


  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('CoherentDemos').controller('PayBills2Controller', PayBills2Controller);
  /** @ngInject */

  function PayBills2Controller($state, EmbeddedService, $http) {
    var vm = this;

    vm.billType = EmbeddedService.billType;
    vm.billers = EmbeddedService.billers;

    vm.payBiller = function(biller) {
      EmbeddedService.biller = biller;
      $state.go('pay-bills-3');
    }

  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('CoherentDemos').controller('PayBills1Controller', PayBills1Controller);
  /** @ngInject */

  function PayBills1Controller($state, EmbeddedService, $http) {
    var vm = this;

    vm.seeBillers = function(biller) {
      EmbeddedService.billType = biller;
      $state.go('pay-bills-2');
    }

  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('CoherentDemos').controller('AddMoneyController', AddMoneyController);
  /** @ngInject */

  function AddMoneyController($state, EmbeddedService) {
    var vm = this;

    vm.AddMoney = function(biller) {
      EmbeddedService.billType = biller;
      $state.go('embedded-landing');
    }

  }
})();
(function() {
  'use strict';

  angular
    .module('CoherentDemos')
    .controller('LandingController', ctrl);

  /** @ngInject */
  function ctrl($state,
                EmbeddedService,
                EmbeddedFactory,
                $http) {
    var vm = this;
    vm.data = {};
    vm.allPlans = [];
    vm.recommendedPlans = [];
    vm.planObject = {
      premium: 0,
      name: ''
    };
    vm.discount = 1;
    vm.personas = EmbeddedService.personas
    vm.activePersona = ""
    vm.purchased = EmbeddedService.purchased
    vm.modules = EmbeddedService.recommendedPlans

    vm.resetPurchase = function() {
      EmbeddedService.purchased = false
      vm.purchased = EmbeddedService.purchased
      vm.setPersona(1)
    }

    vm.landing = true
    vm.spending = false

    vm.clickTab = function (tabName) {
      vm.landing = false
      vm.spending = false
      vm[tabName] = true
    }

    vm.RewardsModal = false

    vm.setPersona = function (index) {
      EmbeddedService.reset()
      EmbeddedService.PFInput.request_data.inputs["Prm_Age"] = EmbeddedService.personas[index-1]["Prm_Age"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Gender"] = EmbeddedService.personas[index-1]["Prm_Gender"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Income"] = EmbeddedService.personas[index-1]["Prm_Income"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Postcode"] = EmbeddedService.personas[index-1]["Prm_Postcode"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Occupation"] = EmbeddedService.personas[index-1]["Prm_Occupation"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Industry"] = EmbeddedService.personas[index-1]["Prm_Industry"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Marital_Status"] = EmbeddedService.personas[index-1]["Prm_Marital_Status"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Dependents"] = EmbeddedService.personas[index-1]["Prm_Dependents"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Education"] = EmbeddedService.personas[index-1]["Prm_Education"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Residency"] = EmbeddedService.personas[index-1]["Prm_Residency"]
      EmbeddedService.PFInput.request_data.inputs["Prm_CreditBalance"] = EmbeddedService.personas[index-1]["Prm_CreditBalance"]
      EmbeddedService.PFInput.request_data.inputs["Prm_CreditArrear"] = EmbeddedService.personas[index-1]["Prm_CreditArrear"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Loan"] = EmbeddedService.personas[index-1]["Prm_Loan"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Health"] = EmbeddedService.personas[index-1]["Prm_Health"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Child"] = EmbeddedService.personas[index-1]["Prm_Child"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Insurance"] = EmbeddedService.personas[index-1]["Prm_Insurance"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Travel"] = EmbeddedService.personas[index-1]["Prm_Travel"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Luxury"] = EmbeddedService.personas[index-1]["Prm_Luxury"]
      EmbeddedService.PFInput.request_data.inputs["Prm_E-commerce"] = EmbeddedService.personas[index-1]["Prm_E-commerce"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Active_Lifestyle"] = EmbeddedService.personas[index-1]["Prm_Active_Lifestyle"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Grocery"] = EmbeddedService.personas[index-1]["Prm_Grocery"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Home"] = EmbeddedService.personas[index-1]["Prm_Home"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Currency"] = EmbeddedService.personas[index-1]["Prm_Currency"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Automotive"] = EmbeddedService.personas[index-1]["Prm_Automotive"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Bar"] = EmbeddedService.personas[index-1]["Prm_Bar"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Food"] = EmbeddedService.personas[index-1]["Prm_Food"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Gaming"] = EmbeddedService.personas[index-1]["Prm_Gaming"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Hair"] = EmbeddedService.personas[index-1]["Prm_Hair"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Helper"] = EmbeddedService.personas[index-1]["Prm_Helper"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Movies"] = EmbeddedService.personas[index-1]["Prm_Movies"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Petrol"] = EmbeddedService.personas[index-1]["Prm_Petrol"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Rent"] = EmbeddedService.personas[index-1]["Prm_Rent"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Retail_shopping"] = EmbeddedService.personas[index-1]["Prm_Retail_shopping"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Transport"] = EmbeddedService.personas[index-1]["Prm_Transport"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Utility"] = EmbeddedService.personas[index-1]["Prm_Utility"]
      EmbeddedService.PFInput.request_data.inputs["Prm_AMZNPRIMESG"] = EmbeddedService.personas[index-1]["Prm_AMZNPRIMESG"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Mortgage"] = EmbeddedService.personas[index-1]["Prm_Mortgage"]
      EmbeddedService.PFInput.request_data.inputs["Prm_CreditScore"] = EmbeddedService.personas[index-1]["Prm_CreditScore"]
      EmbeddedService.PFInput.request_data.inputs["Prm_LateSleeper"] = EmbeddedService.personas[index-1]["Prm_LateSleeper"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Location"] = EmbeddedService.personas[index-1]["Prm_Location"]
      vm.balance = Math.round(EmbeddedService.personas[index-1]["Prm_Income"] * 0.112)
      vm.txn1 = EmbeddedService.PFInput.request_data.inputs["Prm_Health"]
      vm.txn2 = EmbeddedService.PFInput.request_data.inputs["Prm_Child"]
      vm.txn3 = EmbeddedService.PFInput.request_data.inputs["Prm_Retail_shopping"]
      vm.txn4 = EmbeddedService.PFInput.request_data.inputs["Prm_Automotive"]
      vm.txn5 = EmbeddedService.PFInput.request_data.inputs["Prm_Rent"]
      vm.txn6 = EmbeddedService.PFInput.request_data.inputs["Prm_Travel"]
      vm.txn7 = EmbeddedService.PFInput.request_data.inputs["Prm_Currency"]
      vm.bankBalance = EmbeddedService.personas[index-1]["Prm_Deposits"]
      vm.activePersona = EmbeddedService.personas[index-1].Name
      EmbeddedService.activePersonaID = index
      getPlan();
      setSpending();
      vm.getBankingRewards(index)
    }

    function getPlan() {
      vm.recommendedPlans = []
      EmbeddedService.recommendedPlans =[]
      EmbeddedService.PFInput.request_data.inputs.Selection = "Recommended"
      var req = {
        method: 'POST',
        url: 'https://excel.staging.coherent.global/coherentflex/api/v3/folders/Flex/services/Controller File/Execute',
        headers: {
          'x-synthetic-key': EmbeddedService.PFToken,
          'x-tenant-name': 'coherentflex'
        },
        data: EmbeddedService.PFInput
      };
      $http(req).then(function (response) {
        vm.data = response.data.response_data.outputs;
        var rc = vm.data.Recommended_Products;
        EmbeddedService.PFOutput = response.data.response_data.outputs;

        var _loop = function _loop(i) {
          a = {};
          a.premium = vm.data.Premium_Detail.find(function (x) {
            return x.ID === rc[i].ID;
          }).Gross_Premium_before_Discount;
          a.cover = vm.data.Recommended_Products.find(function (x) {
            return x.ID === rc[i].ID;
          })["Recommend Coverage"];
          a.name = vm.data.UI_Options.find(function (x) {
            return x.ID === rc[i].ID;
          }).Product;
          a.Default = vm.data.UI_Options.find(function (x) {
            return x.ID === rc[i].ID;
          }).Default;
          a.Min = vm.data.UI_Options.find(function (x) {
            return x.ID === rc[i].ID;
          }).Min;
          a.Max = vm.data.UI_Options.find(function (x) {
            return x.ID === rc[i].ID;
          }).Max;
          a.Step = vm.data.UI_Options.find(function (x) {
            return x.ID === rc[i].ID;
          }).Step;
          a.ID = vm.data.UI_Options.find(function (x) {
            return x.ID === rc[i].ID;
          }).ID;
          vm.recommendedPlans.push(a);
          vm.discount = Math.round(EmbeddedService.PFOutput["02a_Discount_Multi_Pct"] * 100);
          EmbeddedService.activePersona = vm.activePersona;
          EmbeddedService.recommendedPlans = vm.recommendedPlans;
        }

        for (var i = 0; i < rc.length; i++) {
          var a;

          _loop(i);
        }
      }, function () {});
    }


    function setSpending() {
      vm.totalTransactions = 0
      vm.index = EmbeddedService.activePersonaID-1
      
      vm.txn1 = Math.abs(parseInt(vm.personas[vm.index]["Prm_Health"])) 
      vm.txn2 = Math.abs(parseInt(vm.personas[vm.index]["Prm_Child"])) 
      vm.txn3 = Math.abs(parseInt(vm.personas[vm.index]["Prm_Retail_shopping"])) 
      vm.txn4 = Math.abs(parseInt(vm.personas[vm.index]["Prm_Automotive"])) 
      vm.txn5 = Math.abs(parseInt(vm.personas[vm.index]["Prm_Rent"])) 
      vm.txn6 = Math.abs(parseInt(vm.personas[vm.index]["Prm_Travel"])) 
      vm.txn7 = Math.abs(parseInt(vm.personas[vm.index]["Prm_Currency"])) 

      vm.totalTransactions = Math.abs(vm.txn1 + vm.txn2  + vm.txn3 + vm.txn4 + vm.txn5 + vm.txn6 + vm.txn7)

      vm.txn1Pct = Math.round(vm.txn1 / vm.totalTransactions  * 100)
      vm.txn2Pct = Math.round(vm.txn2 / vm.totalTransactions  * 100)
      vm.txn3Pct = Math.round(vm.txn3 / vm.totalTransactions  * 100)
      vm.txn4Pct = Math.round(vm.txn4 / vm.totalTransactions  * 100)
      vm.txn5Pct = Math.round(vm.txn5 / vm.totalTransactions  * 100)
      vm.txn6Pct = Math.round(vm.txn6 / vm.totalTransactions  * 100)
      vm.txn7Pct = Math.round(vm.txn7 / vm.totalTransactions  * 100)

      vm.txn1Count = Math.round(vm.txn1 / 100)
      vm.txn2Count = Math.round(vm.txn2 / 100)
      vm.txn3Count = Math.round(vm.txn3 / 100)
      vm.txn4Count = Math.round(vm.txn4 / 100)
      vm.txn5Count = Math.round(vm.txn5 / 100)
      vm.txn6Count = Math.round(vm.txn6 / 100)
      vm.txn7Count = Math.round(vm.txn7 / 100)


      vm.arclength1 = vm.txn1 / vm.totalTransactions * 565
      vm.arclength2 = vm.txn2 / vm.totalTransactions * 565
      vm.arclength3 = vm.txn3 / vm.totalTransactions * 565
      vm.arclength4 = vm.txn4 / vm.totalTransactions * 565
      vm.arclength5 = vm.txn5 / vm.totalTransactions * 565
      vm.arclength6 = vm.txn6 / vm.totalTransactions * 565
      vm.arclength7 = vm.txn7 / vm.totalTransactions * 565
      
      vm.offset1 = -1 * (0)
      vm.offset2 = -1 * (vm.arclength1)
      vm.offset3 = -1 * (vm.arclength1 + vm.arclength2)
      vm.offset4 = -1 * (vm.arclength1 + vm.arclength2 + vm.arclength3)
      vm.offset5 = -1 * (vm.arclength1 + vm.arclength2 + vm.arclength3 + vm.arclength4)
      vm.offset6 = -1 * (vm.arclength1 + vm.arclength2 + vm.arclength3 + vm.arclength4 + vm.arclength5)
      vm.offset7 = -1 * (vm.arclength1 + vm.arclength2 + vm.arclength3 + vm.arclength4 + vm.arclength5 + vm.arclength6)

      vm.dasharray1 = Math.round(vm.txn1 / vm.totalTransactions * 565) + ' 565'
      vm.dasharray2 = Math.round(vm.txn2 / vm.totalTransactions * 565) + ' 565'
      vm.dasharray3 = Math.round(vm.txn3 / vm.totalTransactions * 565) + ' 565'
      vm.dasharray4 = Math.round(vm.txn4 / vm.totalTransactions * 565) + ' 565'
      vm.dasharray5 = Math.round(vm.txn5 / vm.totalTransactions * 565) + ' 565'
      vm.dasharray6 = Math.round(vm.txn6 / vm.totalTransactions * 565) + ' 565'
      vm.dasharray7 = Math.round(vm.txn7 / vm.totalTransactions * 565) + ' 565'
    }

    vm.AddMoney = function () {
      vm.bankBalance += 1000
    }

    vm.MonthlyProcessing = function () {
      vm.getBankingRewards(EmbeddedService.activePersonaID)
    }

    vm.getRewardScheme = function (tier) {
      for (var i = 0; i < vm.rewardsScheme.length; i++) {
          if (vm.rewardsScheme[i].Tier === tier) {
              return vm.rewardsScheme[i];
          }
      }
      return null; // Return null if no matching tier is found
    }

    vm.getBankingRewards = function (index) {
      EmbeddedService.RewardsInput.request_data.inputs["deposits"] = vm.bankBalance
      EmbeddedService.RewardsInput.request_data.inputs["transfers"] = EmbeddedService.personas[index-1]["Prm_Transfers"]
      EmbeddedService.RewardsInput.request_data.inputs["billspayed"] = EmbeddedService.personas[index-1]["Prm_BillsPayed"]
      EmbeddedService.RewardsInput.request_data.inputs["spending"] = EmbeddedService.personas[index-1]["Prm_Spending"]

      var req = {
        method: 'POST',
        url: 'https://excel.uat.us.coherent.global/coherent/api/v3/folders/Spark FE Demos/services/Muamalat Rewards Platform/Execute',
        headers: {
          'SecretKey': '2277565c-9fad-4bf4-ad2b-1efe5748dd11',
          'x-tenant-name': 'coherent'
        },
        data: EmbeddedService.RewardsInput
      };
      $http(req).then(function (response) {
        vm.RewardsData = response.data.response_data.outputs;
        vm.rewardsScheme = vm.RewardsData["rewardsScheme"]
        console.log(vm.RewardsData)
        
        vm.currentReward = vm.getRewardScheme(vm.RewardsData.tier)
        console.log(vm.currentReward)

      }, function () {});

    }

    EmbeddedService.rewards = 
    vm.setPersona(EmbeddedService.activePersonaID)

    return vm;
  }
})();

"use strict";

(function () {
  'use strict';

  angular.module('CoherentDemos').controller('InsUpsell5Controller', InsUpsell5Controller);
  /** @ngInject */

  function InsUpsell5Controller($state, EmbeddedService, $http) {
    var vm = this;

    vm.go = function() {
      $state.go('embedded-landing');
    }

  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('CoherentDemos').controller('InsUpsell4Controller', InsUpsell4Controller);
  /** @ngInject */

  function InsUpsell4Controller($state, EmbeddedService, $http) {
    var vm = this;

    vm["Family PA"] = false;
    vm["Cyber Cover"] = false;
    vm["Mobile Guard"] = false;
    vm["Valuables"] = false;
    vm.totalPrice = 0;
    vm.activeProducts = 0;
    vm.discountedPrice = 0;
    vm.effectiveDiscount = 0;

    vm.getProducts = function() {
      var req = {
        method: 'POST',
        url: 'https://excel.staging.coherent.global/coherentflex/api/v3/folders/Bill Embedded/services/Product Upsell/Execute',
        headers: {
          'x-synthetic-key': EmbeddedService.PFToken,
          'x-tenant-name': 'coherentflex'
        },
        data: EmbeddedService.productUpsellInput
      };
      $http(req).then(function (response) {
        vm.data = response.data.response_data.outputs;
        for(var i=0;i<vm.data.Products.length;i++) {
          vm[vm.data.Products[i].Products] = true
        }

      }, function () {});
    }

    vm.updatePrice = function(product, index) {

      console.log(vm.activeProducts)
      if (vm[product]) { vm.totalPrice += vm.data.ProductDetails[index].Premium; vm.activeProducts += 1; } else { vm.totalPrice -= vm.data.ProductDetails[index].Premium; vm.activeProducts -= 1; }
      vm.effectiveDiscount = 0;
      vm.discountedPrice = vm.totalPrice;
      for(var i=0;i<vm.data.Discount.length;i++) {
        if(vm.activeProducts>=vm.data.Discount[i]["Basket Size"]) {
          vm.effectiveDiscount = vm.data.Discount[i]["Discount"] / 100;
          vm.discountedPrice = vm.totalPrice * (1 - vm.effectiveDiscount);
        }  
      }
    }

    vm.go = function() {
      $state.go('ins-upsell-5');
    }

    vm.getProducts();

  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('CoherentDemos').controller('InsUpsell3Controller', InsUpsell3Controller);
  /** @ngInject */

  function InsUpsell3Controller($state, EmbeddedService, $http) {
    var vm = this;

    vm.go = function() {
      $state.go('ins-upsell-4');
    }

  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('CoherentDemos').controller('InsUpsell2Controller', InsUpsell2Controller);
  /** @ngInject */

  function InsUpsell2Controller($state, EmbeddedService, $http) {
    var vm = this;
    vm.age = 24
    vm.children = 0
    vm.adults = 1
    vm.personaleffects = false
    vm.lifeevent = false
    vm.lifestyle = false
    vm.valuables = false

    vm.productUpsellInput = EmbeddedService.productUpsellInput.request_data

    vm.go = function() {
      vm.productUpsellInput.inputs.Age = vm.age;
      if(vm.adults > 1 || vm.children > 0) {vm.productUpsellInput.inputs.Family = true;} else {vm.productUpsellInput.inputs.Family = false;};
      vm.productUpsellInput.inputs.HighNet = vm.valuables;
      vm.productUpsellInput.inputs.LifeStyle = vm.lifestyle;
      vm.productUpsellInput.inputs.PersonalEffects = vm.personaleffects;
      vm.productUpsellInput.inputs.Spouse = vm.lifeevent;
      vm.productUpsellInput.inputs.Passengers = parseInt(vm.adults) + parseInt(vm.children);
      EmbeddedService.productUpsellInput.request_data = vm.productUpsellInput;
      $state.go('ins-upsell-3');
    }

  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('CoherentDemos').controller('InsUpsell1Controller', InsUpsell1Controller);
  /** @ngInject */

  function InsUpsell1Controller($state, EmbeddedService, $http) {
    var vm = this;

    vm.biller = EmbeddedService.biller;

  }
})();
(function() {
  'use strict';

  angular
    .module('CoherentDemos')
    .service('EmbeddedService', EmbeddedService);

  /** @ngInject */
  function EmbeddedService() {
    var vm = this;

    vm.activeRewards = {}
    vm.bankingActivity = {}
    vm.activePersonaID = 1;
    vm.purchased = false
    vm.reset = function() {
      vm.recommendedPlans = [{"premium":"","cover":200,"name":"Item","Default":200,"Min":0,"Max":10000,"Step":1000,"ID":8},{"premium":"","cover":100,"name":"Hospital Cash","Default":100,"Min":0,"Max":200,"Step":20,"ID":7},{"premium":10.11,"cover":200,"name":"Travel","Default":200,"Min":0,"Max":2000,"Step":200,"ID":10},{"premium":"","cover":400,"name":"Home Contents","Default":400,"Min":0,"Max":10000,"Step":1000,"ID":6}];
      vm.PFInput = {"request_data":{"inputs":{"Discount_Code":null,"Limit1":null,"Limit10":null,"Limit2":null,"Limit3":null,"Limit4":null,"Limit5":null,"Limit6":null,"Limit7":null,"Limit8":null,"Limit9":null,"No_Products":4,"Prm_Active_Lifestyle":"NA","Prm_Age":30,"Prm_AMZNPRIMESG":-1,"Prm_Automotive":-628,"Prm_Bar":-71,"Prm_Child":-472,"Prm_CreditArrear":0,"Prm_CreditBalance":8302,"Prm_CreditScore":"NA","Prm_Currency":"NA","Prm_Dependents":0,"Prm_E_commerce":-528,"Prm_Education":"A Levels","Prm_Food":-1999,"Prm_Gaming":-7,"Prm_Gender":"Female","Prm_Grocery":-535,"Prm_Hair":-66,"Prm_Health":-161,"Prm_Helper":-444,"Prm_Home":"NA","Prm_Income":27000,"Prm_Industry":"Insurance","Prm_Insurance":"NA","Prm_LateSleeper":"NA","Prm_Loan":0,"Prm_Location":"NA","Prm_Luxury":"NA","Prm_Marital_Status":"Single","Prm_Mortgage":"NA","Prm_Movies":-29,"Prm_Occupation":"I.T.","Prm_Petrol":-99,"Prm_Postcode":300821,"Prm_Rent":-5156,"Prm_Residency":"Employment Pass","Prm_Retail_shopping":-473,"Prm_Transport":-366,"Prm_Travel":-345,"Prm_Utility":-218,"Selection":"Recommended","UW_Response":[{"ID":2,"Response":"N"},{"ID":3,"Response":"N"},{"ID":4,"Response":"N"}]}},"request_meta":{"version_id":"55303ac9-2a03-42ee-9c85-4808b8e1064f","transaction_date":"2022-06-27T23:43:40.011Z","call_purpose":"Spark - API Tester","source_system":"SPARK","correlation_id":"","requested_output":"","service_category":""}};
      vm.customCoverages = []
      vm.activePersona = vm.personas[vm.activePersonaID-1].Name
    }

    vm.billType = ""
    vm.biller = ""
    vm.merchant = ""

    vm.merchants = [
      {
        name: "Travel Club Inc",
        type: "Travel",
        match: "Travel",
        image: "travelclub.png",
        amount: 45.80,
        intro: "TRAVEL: Travelling soon? Get Yearly Travel Coverage",
        productIcon: "travel.svg",
        style: "travel",
        basePremium: 17
      },
      {
        name: "Digital Walker Pte",
        type: "Gadget",
        match: "Gadget",
        image: "digitalwalker.png",
        amount: 33.90,
        intro: "GADGET GUARD: Don't Let Your Investment Go To Waste",
        productIcon: "gadget.svg",
        style: "bill-protect",
        basePremium: 32
      },
      {
        name: "North Face Co",
        type: "Outdoor",
        match: "Accident",
        image: "northface.png",
        amount: 129.00,
        intro: "PA+: Go adventure with peace of mind",
        productIcon: "accident.svg",
        style: "cyber",
        basePremium: 25
      }
    ]

    vm.billers = [
      {
        name: "Meralco",
        type: "electric",
        image: "meralco.png"
      },
      {
        name: "Tenaga Nasional",
        type: "electric",
        image: "tenaganasional.png"
      },
      {
        name: "Aboitiz Power",
        type: "electric",
        image: "aboitiz.png"
      },
      {
        name: "Manila Water",
        type: "water",
        image: "manilawater.png"
      },
      {
        name: "Globe",
        type: "telco",
        image: "globe.png"
      },
      {
        name: "Sky",
        type: "cable",
        image: "sky.png"
      },
      {
        name: "Medicard",
        type: "healthcare",
        image: "medicard.png"
      },
      {
        name: "Priority Pass",
        type: "transpo",
        image: "pioritypass.png"
      },
      {
        name: "BPI",
        type: "creditcard",
        image: "bpi.png"
      }
    ]

    vm.controllerPayload = {
      "response_data": {
        "outputs": {
          "01_Gross_Prem_before_discount": 120.13,
          "02a_Discount_Multi_Pct": 0.02,
          "02b_Code_Discount_Pct": 0,
          "02c_Code_Discount_amt": 0,
          "02d_Code_Discount_Product": "null",
          "02e_Code_Discount_Error_Msg": "null",
          "02g_Gross_Prem_after_discount": 117.73,
          "02h_Total_Discount": 2.40000000000001,
          "03_Comm": 26.8,
          "04_Tax": 5.88,
          "05_Net_Prem": 90.93,
          "06_Gross_Prem_inc_Tax": 123.61,
          "API_Discount": "{\"message\":null,\"data\":{\"Inputs\":{\"Discount_Code\":null,\"Product_cnt\":4},\"Outputs\":{\"02a_Discount_Multi_Pct\":0.02,\"02b_Code_Discount_Pct\":null,\"02c_Code_Discount_Amt\":null,\"02d_Code_Discount_Product\":null,\"02e_Code_Discount_Error_Msg\":null},\"Errors\":[],\"FetchTimeUTC\":\"2022-01-23T17:22:34.7794676Z\",\"EngineID\":\"9e42502e-c827-4a6a-97dd-e24fd1e7234e\",\"ServiceName\":\"Discount Table\",\"EngineType\":\"Type3\",\"Revision\":\"1.0.0\",\"Version\":\"0aef11c7-466b-4011-83e2-c6b5e92238ab\",\"ReleaseDate\":\"2022-01-12 09:11:11\",\"Description\":null,\"EngineHash\":\"BC267AFC560050E1D3738C3B22FBA794\",\"CalcTime\":2.0,\"TotalTime\":29,\"SolveInputs\":[],\"SolveOutputs\":[],\"ProductName\":\"Embedded\",\"EffectiveStartDate\":\"2010-01-01T00:00:00Z\",\"EffectiveEndDate\":\"2120-01-01T00:00:00Z\",\"CallGUID\":\"2c250e48-17c2-47ce-b8a5-73cdebb7e0ac\"},\"errorCode\":null,\"status\":\"Success\"}",
          "API_Postcode": "{\"IsSuccess\":false,\"ErrorCode\":\"-21\",\"ErrorDetails\":\"Unauthorized postcode for demo plan.\",\"Postcodes\":[]}",
          "API_Recommender": "{\"message\":null,\"data\":{\"Inputs\":{\"Factors\":[{\"Variables\":\"Age\",\"Value\":30},{\"Variables\":\"Gender\",\"Value\":\"Female\"},{\"Variables\":\"Income\",\"Value\":27000},{\"Variables\":\"Postcode\",\"Value\":300821},{\"Variables\":\"Occupation\",\"Value\":\"I.T.\"},{\"Variables\":\"Industry\",\"Value\":\"Insurance\"},{\"Variables\":\"Marital Status\",\"Value\":\"Single\"},{\"Variables\":\"Dependents\",\"Value\":0},{\"Variables\":\"Education\",\"Value\":\"A Levels\"},{\"Variables\":\"Residency\",\"Value\":\"Employment Pass\"},{\"Variables\":\"CreditBalance\",\"Value\":8302},{\"Variables\":\"CreditArrear\",\"Value\":0},{\"Variables\":\"Loan\",\"Value\":0},{\"Variables\":\"Health\",\"Value\":-161},{\"Variables\":\"Child\",\"Value\":-472},{\"Variables\":\"Insurance\",\"Value\":\"NA\"},{\"Variables\":\"Travel\",\"Value\":-345},{\"Variables\":\"Luxury\",\"Value\":\"NA\"},{\"Variables\":\"E-commerce\",\"Value\":-528},{\"Variables\":\"Active Lifestyle\",\"Value\":\"NA\"},{\"Variables\":\"Grocery\",\"Value\":-535},{\"Variables\":\"Home\",\"Value\":\"NA\"},{\"Variables\":\"Currency\",\"Value\":\"NA\"},{\"Variables\":\"Automotive\",\"Value\":-628},{\"Variables\":\"Bar\",\"Value\":-71},{\"Variables\":\"Food\",\"Value\":-1999},{\"Variables\":\"Gaming\",\"Value\":-7},{\"Variables\":\"Hair\",\"Value\":-66},{\"Variables\":\"Helper\",\"Value\":-444},{\"Variables\":\"Movies\",\"Value\":-29},{\"Variables\":\"Petrol\",\"Value\":-99},{\"Variables\":\"Rent\",\"Value\":-5156},{\"Variables\":\"Retail shopping\",\"Value\":-473},{\"Variables\":\"Transport\",\"Value\":-366},{\"Variables\":\"Utility\",\"Value\":-218},{\"Variables\":\"AMZNPRIMESG\",\"Value\":-1},{\"Variables\":\"Mortgage\",\"Value\":\"NA\"},{\"Variables\":\"CreditScore\",\"Value\":\"NA\"},{\"Variables\":\"LateSleeper\",\"Value\":\"NA\"},{\"Variables\":\"Location\",\"Value\":\"NA\"}]},\"Outputs\":{\"Results\":[{\"ID\":1,\"Model\":\"Term Life\",\"Prob\":0.0022378485212763335,\"Offer_Flag\":\"Y\",\"Rank\":9},{\"ID\":2,\"Model\":\"Accidental PPD\",\"Prob\":0.768524783499018,\"Offer_Flag\":\"Y\",\"Rank\":7},{\"ID\":3,\"Model\":\"Critical Illness\",\"Prob\":0.574442516811659,\"Offer_Flag\":\"Y\",\"Rank\":8},{\"ID\":4,\"Model\":\"Medical Expenses\",\"Prob\":0,\"Offer_Flag\":\"Y\",\"Rank\":11},{\"ID\":5,\"Model\":\"Hospital Cash\",\"Prob\":0.995033198349943,\"Offer_Flag\":\"Y\",\"Rank\":3},{\"ID\":6,\"Model\":\"Travel\",\"Prob\":0.930861579656653,\"Offer_Flag\":\"Y\",\"Rank\":6},{\"ID\":7,\"Model\":\"Home Emergency Assistance\",\"Prob\":0,\"Offer_Flag\":\"Y\",\"Rank\":12},{\"ID\":8,\"Model\":\"Cyber\",\"Prob\":0.999647462162129,\"Offer_Flag\":\"Y\",\"Rank\":2},{\"ID\":9,\"Model\":\"Home Contents\",\"Prob\":0.994779874306442,\"Offer_Flag\":\"Y\",\"Rank\":4},{\"ID\":10,\"Model\":\"Unemployment*\",\"Prob\":0,\"Offer_Flag\":\"N\",\"Rank\":13},{\"ID\":11,\"Model\":\"Event Cancellation\",\"Prob\":0,\"Offer_Flag\":\"Y\",\"Rank\":14},{\"ID\":12,\"Model\":\"Item\",\"Prob\":0.999981542106704,\"Offer_Flag\":\"Y\",\"Rank\":1},{\"ID\":13,\"Model\":\"Shipping Insurance\",\"Prob\":0,\"Offer_Flag\":null,\"Rank\":15},{\"ID\":14,\"Model\":\"Sports coverage for physical injury\",\"Prob\":0,\"Offer_Flag\":\"Y\",\"Rank\":16},{\"ID\":15,\"Model\":\"Competition / Race coverage\",\"Prob\":0,\"Offer_Flag\":\"Y\",\"Rank\":17},{\"ID\":16,\"Model\":\"Gimmicky \\\"prize\\\" insurance\",\"Prob\":0,\"Offer_Flag\":\"Y\",\"Rank\":18},{\"ID\":17,\"Model\":\"Education\",\"Prob\":0.0021930915508508067,\"Offer_Flag\":\"Y\",\"Rank\":10},{\"ID\":18,\"Model\":\"Crypto\",\"Prob\":0.993940198508416,\"Offer_Flag\":\"Y\",\"Rank\":5}]},\"Errors\":[],\"FetchTimeUTC\":\"2022-01-23T17:22:32.2092966Z\",\"EngineID\":\"e28a656f-310d-44ae-a56c-ba65012cca7a\",\"ServiceName\":\"Recommender\",\"EngineType\":\"Type3\",\"Revision\":\"1.0.0\",\"Version\":\"e0fa9c4f-9081-439e-bd3f-3e17685bc221\",\"ReleaseDate\":\"2022-01-12 09:10:49\",\"Description\":null,\"EngineHash\":\"078330208EA652991F08C052BE222CFC\",\"CalcTime\":183.0,\"TotalTime\":19597,\"SolveInputs\":[],\"SolveOutputs\":[],\"ProductName\":\"Embedded\",\"EffectiveStartDate\":\"2010-01-01T00:00:00Z\",\"EffectiveEndDate\":\"2120-01-01T00:00:00Z\",\"CallGUID\":\"78e0932a-34eb-496b-81e0-f3db8ee62fe9\"},\"errorCode\":null,\"status\":\"Success\"}",
          "API_Res1": null,
          "API_Res10": null,
          "API_Res2": null,
          "API_Res3": null,
          "API_Res4": "{\"message\":null,\"data\":{\"Inputs\":{\"Promotion_Code\":null,\"Quote_Date\":null,\"Sum_Assured\":1},\"Outputs\":{\"Commission\":0,\"Commission_Rate\":0.2,\"Decline_Flag\":null,\"Decline_Reason\":null,\"Gross_Premium\":3.51,\"Net_Premium\":3.51,\"Tax\":0,\"Tax_Rate\":0},\"Errors\":[],\"Warnings\":[{\"Key\":\"Default Values\",\"Value\":[\"Input parameter(s) missing. API request using the Default Values.\"]}],\"FetchTimeUTC\":\"2022-01-23T17:22:33.0100391Z\",\"EngineID\":\"c744135e-6fc8-4115-a6b8-597984977fe5\",\"ServiceName\":\"04_Cyber Product Engine\",\"EngineType\":\"Type3\",\"Revision\":\"1.0.0\",\"Version\":\"09a6bdfc-7a0d-4d12-8b86-7df0993588b2\",\"ReleaseDate\":\"2022-01-12 09:09:23\",\"Description\":null,\"EngineHash\":\"98E5C7318E7E52789E01175354783037\",\"CalcTime\":4.0,\"TotalTime\":69,\"SolveInputs\":[],\"SolveOutputs\":[],\"ProductName\":\"Embedded\",\"EffectiveStartDate\":\"2010-01-01T00:00:00Z\",\"EffectiveEndDate\":\"2120-01-01T00:00:00Z\",\"CallGUID\":\"c458c37c-e500-4aa6-b53a-2434b8b68b8d\"},\"errorCode\":null,\"status\":\"Success\"}",
          "API_Res5": null,
          "API_Res6": "{\"message\":null,\"data\":{\"Inputs\":{\"Content_SI\":400,\"Floor_Size\":1999,\"Payment_Options\":null,\"Postal_Code\":18979,\"Promotion_Code\":null,\"Property_Type\":\"Flat\",\"Quote_Date\":\"2021-11-23 T03:00:00Z\",\"Year_Built\":1980},\"Outputs\":{\"Commission\":20,\"Commission_Rate\":0.2,\"Decline_Flag\":0,\"Decline_Reason\":null,\"Gross_Premium\":100,\"Net_Premium\":80,\"Tax\":6,\"Tax_Rate\":0.06},\"Errors\":[],\"Warnings\":[{\"Key\":\"Default Values\",\"Value\":[\"Input parameter(s) missing. API request using the Default Values.\"]}],\"FetchTimeUTC\":\"2022-01-23T17:22:33.4711202Z\",\"EngineID\":\"50cd5041-3d6f-48c8-89d2-c0d06b9306cc\",\"ServiceName\":\"06_Home Content Product Engine Details\",\"EngineType\":\"Type3\",\"Revision\":\"1.0.0\",\"Version\":\"d175d039-1c15-4c87-9548-5177b5cda93f\",\"ReleaseDate\":\"2022-01-12 09:09:40\",\"Description\":null,\"EngineHash\":\"BB05CC34C615575782FE2CA68AC4EB66\",\"CalcTime\":25.0,\"TotalTime\":89,\"SolveInputs\":[],\"SolveOutputs\":[],\"ProductName\":\"Embedded\",\"EffectiveStartDate\":\"2010-01-01T00:00:00Z\",\"EffectiveEndDate\":\"2120-01-01T00:00:00Z\",\"CallGUID\":\"3b8aa8bd-9c59-4b6b-b3b7-ec99310383f2\"},\"errorCode\":null,\"status\":\"Success\"}",
          "API_Res7": "{\"message\":null,\"data\":{\"Inputs\":{\"Promotion_Code\":null,\"Quote_Date\":null,\"Sum_Assured\":100},\"Outputs\":{\"Commission\":0,\"Commission_Rate\":0.4,\"Decline_Flag\":null,\"Decline_Reason\":null,\"Gross_Premium\":16.55,\"Net_Premium\":16.55,\"Tax\":0,\"Tax_Rate\":0},\"Errors\":[],\"Warnings\":[{\"Key\":\"Default Values\",\"Value\":[\"Input parameter(s) missing. API request using the Default Values.\"]}],\"FetchTimeUTC\":\"2022-01-23T17:22:33.9939716Z\",\"EngineID\":\"e0910ed9-5604-4232-bfd8-3402c0a723fc\",\"ServiceName\":\"07_Hospital Cash Product Engine\",\"EngineType\":\"Type3\",\"Revision\":\"1.0.0\",\"Version\":\"a56c7fae-e10c-4b03-811e-3c9e10d33787\",\"ReleaseDate\":\"2022-01-12 09:09:48\",\"Description\":null,\"EngineHash\":\"77E31DA771334DD9A4A77F2645A9FA57\",\"CalcTime\":0.0,\"TotalTime\":41,\"SolveInputs\":[],\"SolveOutputs\":[],\"ProductName\":\"Embedded\",\"EffectiveStartDate\":\"2010-01-01T00:00:00Z\",\"EffectiveEndDate\":\"2120-01-01T00:00:00Z\",\"CallGUID\":\"1da84606-af59-4857-9061-4d373385f8cb\"},\"errorCode\":null,\"status\":\"Success\"}",
          "API_Res8": "{\"message\":null,\"data\":{\"Inputs\":{\"Promotion_Code\":null,\"Quote_Date\":null,\"Sum_Assured\":200},\"Outputs\":{\"Commission\":0,\"Commission_Rate\":0.3,\"Decline_Flag\":null,\"Decline_Reason\":null,\"Gross_Premium\":0.07,\"Net_Premium\":0.07,\"Tax\":0,\"Tax_Rate\":0},\"Errors\":[],\"Warnings\":[{\"Key\":\"Default Values\",\"Value\":[\"Input parameter(s) missing. API request using the Default Values.\"]}],\"FetchTimeUTC\":\"2022-01-23T17:22:34.3150226Z\",\"EngineID\":\"0e6974d4-c448-4b25-a0ca-e5745b312d35\",\"ServiceName\":\"08_Item Product Engine\",\"EngineType\":\"Type3\",\"Revision\":\"1.0.0\",\"Version\":\"71e7becc-5a64-4a94-af5d-812d77d9878a\",\"ReleaseDate\":\"2022-01-12 09:09:55\",\"Description\":null,\"EngineHash\":\"723386664DB6BE4C3C8CECEEFEEC6033\",\"CalcTime\":1.0,\"TotalTime\":25,\"SolveInputs\":[],\"SolveOutputs\":[],\"ProductName\":\"Embedded\",\"EffectiveStartDate\":\"2010-01-01T00:00:00Z\",\"EffectiveEndDate\":\"2120-01-01T00:00:00Z\",\"CallGUID\":\"d8f0e068-2f45-40db-a705-524c019eabb0\"},\"errorCode\":null,\"status\":\"Success\"}",
          "API_Res9": null,
          "API_UWQ": "{\"message\":null,\"data\":{\"Inputs\":{\"Selected_Products\":[{\"ID\":1,\"Selected\":\"N\"},{\"ID\":2,\"Selected\":\"N\"},{\"ID\":3,\"Selected\":\"N\"},{\"ID\":4,\"Selected\":\"Y\"},{\"ID\":5,\"Selected\":\"N\"},{\"ID\":6,\"Selected\":\"Y\"},{\"ID\":7,\"Selected\":\"Y\"},{\"ID\":8,\"Selected\":\"Y\"},{\"ID\":9,\"Selected\":\"N\"},{\"ID\":10,\"Selected\":\"N\"}],\"UW_Response\":[{\"ID\":2,\"Response\":\"N\"},{\"ID\":3,\"Response\":\"N\"},{\"ID\":4,\"Response\":\"N\"}]},\"Outputs\":{\"Question_Sets\":[{\"ID\":1,\"Value\":\"Has any of your life insurance application been declined before?\",\"Response\":\"Yes;No;\",\"Referral_Response\":\"Yes\",\"Display\":\"N\"},{\"ID\":2,\"Value\":\"Have you had a home insurance policy cancelled, declined, refused to renew or had special terms and conditions imposed upon a policy, or have made or reported a home insurance claim in the past 3 years ?\",\"Response\":\"Yes;No;\",\"Referral_Response\":\"Yes\",\"Display\":\"Y\"},{\"ID\":3,\"Value\":\"Have you ever had, or been told that you have, or are you currently under investigation for diabetes, cancer, heart attack, stroke, AIDS or HIV infection, carcinoma in situ, tumour, lump or polyp?\",\"Response\":\"Yes;No;\",\"Referral_Response\":\"Yes\",\"Display\":\"Y\"},{\"ID\":4,\"Value\":\"In the past 2  years, have you had any abnormal results in a pap smear, mammogram, breast ultrasound, prostate examinination or tumour market blood test?\",\"Response\":\"Yes;No;\",\"Referral_Response\":\"Yes\",\"Display\":\"Y\"},{\"ID\":5,\"Value\":\"In the last 12 months, has the proposed insured smoked any cigarette, cigars, electronic cigarettes, vaporizers or waterpipe tobacco?\",\"Response\":\"Yes;No;\",\"Referral_Response\":\"\",\"Display\":\"Y\"}],\"Referral_Flag\":\"Quote\"},\"Errors\":[],\"FetchTimeUTC\":\"2022-01-23T17:22:35.1440014Z\",\"EngineID\":\"5c5c375e-6059-4a80-bd6a-e8ba7c91fa4c\",\"ServiceName\":\"UW Questions\",\"EngineType\":\"Type3\",\"Revision\":\"1.0.0\",\"Version\":\"78ed5a03-83eb-40a3-9f1a-1a1b43898826\",\"ReleaseDate\":\"2022-01-12 09:11:19\",\"Description\":null,\"EngineHash\":\"A0D046FD13D0D2135F6C3FA9D82CB7B5\",\"CalcTime\":4.0,\"TotalTime\":43,\"SolveInputs\":[],\"SolveOutputs\":[],\"ProductName\":\"Embedded\",\"EffectiveStartDate\":\"2010-01-01T00:00:00Z\",\"EffectiveEndDate\":\"2120-01-01T00:00:00Z\",\"CallGUID\":\"1afb7255-9697-4aaf-b140-064cfe16c806\"},\"errorCode\":null,\"status\":\"Success\"}",
          "Postcode_Out1": "ErrValue",
          "Postcode_Out2": "ErrValue",
          "Postcode_Out3": "ErrValue",
          "Postcode_Out4": "ErrValue",
          "Premium_Detail": [
            {
              "ID": 1,
              "Gross_Premium_before_Discount": "",
              "Gross_Premium_after_Discount": "",
              "Commission": "",
              "Tax": "",
              "Net_Premium": "",
              "Gross_Premium_inc_Tax": ""
            },
            {
              "ID": 2,
              "Gross_Premium_before_Discount": "",
              "Gross_Premium_after_Discount": "",
              "Commission": "",
              "Tax": "",
              "Net_Premium": "",
              "Gross_Premium_inc_Tax": ""
            },
            {
              "ID": 3,
              "Gross_Premium_before_Discount": "",
              "Gross_Premium_after_Discount": "",
              "Commission": "",
              "Tax": "",
              "Net_Premium": "",
              "Gross_Premium_inc_Tax": ""
            },
            {
              "ID": 4,
              "Gross_Premium_before_Discount": 3.51,
              "Gross_Premium_after_Discount": 3.44,
              "Commission": 0.69,
              "Tax": 0,
              "Net_Premium": 2.75,
              "Gross_Premium_inc_Tax": 3.44
            },
            {
              "ID": 5,
              "Gross_Premium_before_Discount": "",
              "Gross_Premium_after_Discount": "",
              "Commission": "",
              "Tax": "",
              "Net_Premium": "",
              "Gross_Premium_inc_Tax": ""
            },
            {
              "ID": 6,
              "Gross_Premium_before_Discount": 100,
              "Gross_Premium_after_Discount": 98,
              "Commission": 19.6,
              "Tax": 5.88,
              "Net_Premium": 78.4,
              "Gross_Premium_inc_Tax": 103.88
            },
            {
              "ID": 7,
              "Gross_Premium_before_Discount": 16.55,
              "Gross_Premium_after_Discount": 16.22,
              "Commission": 6.49,
              "Tax": 0,
              "Net_Premium": 9.73,
              "Gross_Premium_inc_Tax": 16.22
            },
            {
              "ID": 8,
              "Gross_Premium_before_Discount": 0.07,
              "Gross_Premium_after_Discount": 0.07,
              "Commission": 0.02,
              "Tax": 0,
              "Net_Premium": 0.05,
              "Gross_Premium_inc_Tax": 0.07
            },
            {
              "ID": 9,
              "Gross_Premium_before_Discount": "",
              "Gross_Premium_after_Discount": "",
              "Commission": "",
              "Tax": "",
              "Net_Premium": "",
              "Gross_Premium_inc_Tax": ""
            },
            {
              "ID": 10,
              "Gross_Premium_before_Discount": "",
              "Gross_Premium_after_Discount": "",
              "Commission": "",
              "Tax": "",
              "Net_Premium": "",
              "Gross_Premium_inc_Tax": ""
            }
          ],
          "Question_Sets": [
            {
              "ID": 1,
              "Value": "Has any of your life insurance application been declined before?",
              "Response": "Yes;No;",
              "Referral_Response": "Yes",
              "Display": "N"
            },
            {
              "ID": 2,
              "Value": "Have you had a home insurance policy cancelled, declined, refused to renew or had special terms and conditions imposed upon a policy, or have made or reported a home insurance claim in the past 3 years ?",
              "Response": "Yes;No;",
              "Referral_Response": "Yes",
              "Display": "Y"
            },
            {
              "ID": 3,
              "Value": "Have you ever had, or been told that you have, or are you currently under investigation for diabetes, cancer, heart attack, stroke, AIDS or HIV infection, carcinoma in situ, tumour, lump or polyp?",
              "Response": "Yes;No;",
              "Referral_Response": "Yes",
              "Display": "Y"
            },
            {
              "ID": 4,
              "Value": "In the past 2  years, have you had any abnormal results in a pap smear, mammogram, breast ultrasound, prostate examinination or tumour market blood test?",
              "Response": "Yes;No;",
              "Referral_Response": "Yes",
              "Display": "Y"
            },
            {
              "ID": 5,
              "Value": "In the last 12 months, has the proposed insured smoked any cigarette, cigars, electronic cigarettes, vaporizers or waterpipe tobacco?",
              "Response": "Yes;No;",
              "Referral_Response": "",
              "Display": "Y"
            }
          ],
          "Recommended_Products": [
            {
              "ID": 8,
              "Product": "Item",
              "Recommend Coverage": 200
            },
            {
              "ID": 4,
              "Product": "Cyber",
              "Recommend Coverage": 1
            },
            {
              "ID": 7,
              "Product": "Hospital Cash",
              "Recommend Coverage": 100
            },
            {
              "ID": 6,
              "Product": "Home Contents",
              "Recommend Coverage": 400
            }
          ],
          "Referral_Flag": "Quote",
          "UI_Options": [
            {
              "ID": 1,
              "Product": "Accidental PPD",
              "Eligibility": "Y",
              "Default": 40000,
              "Min": 0,
              "Max": 200000,
              "Step": 20000
            },
            {
              "ID": 2,
              "Product": "Critical Illness",
              "Eligibility": "Y",
              "Default": 20000,
              "Min": 0,
              "Max": 200000,
              "Step": 20000
            },
            {
              "ID": 3,
              "Product": "Crypto",
              "Eligibility": "Y",
              "Default": 2000,
              "Min": 0,
              "Max": 20000,
              "Step": 2000
            },
            {
              "ID": 4,
              "Product": "Cyber",
              "Eligibility": "Y",
              "Default": 1,
              "Min": 0,
              "Max": 1,
              "Step": 1
            },
            {
              "ID": 5,
              "Product": "Education",
              "Eligibility": "Y",
              "Default": 200,
              "Min": 0,
              "Max": 20000,
              "Step": 2000
            },
            {
              "ID": 6,
              "Product": "Home Contents",
              "Eligibility": "Y",
              "Default": 400,
              "Min": 0,
              "Max": 10000,
              "Step": 1000
            },
            {
              "ID": 7,
              "Product": "Hospital Cash",
              "Eligibility": "Y",
              "Default": 100,
              "Min": 0,
              "Max": 200,
              "Step": 20
            },
            {
              "ID": 8,
              "Product": "Item",
              "Eligibility": "Y",
              "Default": 200,
              "Min": 0,
              "Max": 10000,
              "Step": 1000
            },
            {
              "ID": 9,
              "Product": "Term Life",
              "Eligibility": "Y",
              "Default": 100000,
              "Min": 0,
              "Max": 200000,
              "Step": 20000
            },
            {
              "ID": 10,
              "Product": "Travel",
              "Eligibility": "Y",
              "Default": 200,
              "Min": 0,
              "Max": 2000,
              "Step": 200
            }
          ]
        },
        "warnings": [],
        "errors": [],
        "service_chain": []
      },
      "response_meta": {
        "service_id": "4b59e498-b6dd-492f-a27b-f3f5dca4c1cc",
        "version_id": "19dbe817-d620-4fe4-b2b1-996591077eb4",
        "version": "1.8.0",
        "process_time": 20,
        "call_id": "c5e43978-5052-45f1-888b-c8f1231b4b57",
        "compiler_type": "Type3",
        "compiler_version": "1.0.0",
        "source_hash": null,
        "engine_id": "D751AA0B8417648EAFC14A7AAB34A4C5",
        "correlation_id": "",
        "system": "SPARK",
        "request_timestamp": "2022-01-23, 17:24:18 GMT+00:00"
      }
    }

    vm.RewardsInput = {"request_data":{"inputs":{"aml":"Active","billspayed":500,"civilstatus":"Married","deposits":3000,"fna1":"Moderate","fna2":"Certain","fna3":"Excellent","fna4":"Fast","fna5":6,"gender":"Male","location":"Hong Kong","logins":51,"name":"Poovan","spending":1000,"transactiondate":"2023-12-31","transactionsperweek":11,"transfers":500}},"request_meta":{"call_purpose":"Front End","requested_output":null,"service_category":"#Default#"}}

    vm.investInput = {
      "request_data": {
        "inputs": {
          "Discount_Code": null,
          "Limit1": null,
          "Limit10": null,
          "Limit2": null,
          "Limit3": null,
          "Limit4": null,
          "Limit5": null,
          "Limit6": null,
          "Limit7": null,
          "Limit8": null,
          "Limit9": null,
          "No_Products": 9,
          "Prm_Active_Lifestyle": "NA",
          "Prm_Age": 30,
          "Prm_AMZNPRIMESG": -1,
          "Prm_Automotive": -628,
          "Prm_Bar": -71,
          "Prm_Child": -472,
          "Prm_CreditArrear": 0,
          "Prm_CreditBalance": 8302,
          "Prm_CreditScore": "NA",
          "Prm_Currency": "NA",
          "Prm_Dependents": 0,
          "Prm_E_commerce": -528,
          "Prm_Education": "A Levels",
          "Prm_Food": -1999,
          "Prm_Gaming": -7,
          "Prm_Gender": "Female",
          "Prm_Grocery": -535,
          "Prm_Hair": -66,
          "Prm_Health": -161,
          "Prm_Helper": -444,
          "Prm_Home": "NA",
          "Prm_Income": 27000,
          "Prm_Industry": "Insurance",
          "Prm_Insurance": "NA",
          "Prm_LateSleeper": "NA",
          "Prm_Loan": 0,
          "Prm_Location": "NA",
          "Prm_Luxury": "NA",
          "Prm_Marital_Status": "Single",
          "Prm_Mortgage": "NA",
          "Prm_Movies": -29,
          "Prm_Occupation": "I.T.",
          "Prm_Petrol": -99,
          "Prm_Postcode": 560727,
          "Prm_ProfileName": "Cassandra",
          "Prm_Rent": -5156,
          "Prm_Residency": "Employment Pass",
          "Prm_Retail_shopping": -473,
          "Prm_Transport": -366,
          "Prm_Travel": -345,
          "Prm_Utility": -218,
          "Selection": "Customise",
          "UW_Response": [
            {
              "ID": 2,
              "Response": "N"
            },
            {
              "ID": 3,
              "Response": "N"
            },
            {
              "ID": 4,
              "Response": "N"
            }
          ]
        }
      },
      "request_meta": {
        "version_id": "dbdb14e5-6314-4287-95e1-6cff1942039c",
        "transaction_date": "2022-03-21T14:57:11.051Z",
        "call_purpose": "Spark - API Tester",
        "source_system": "SPARK",
        "correlation_id": "",
        "requested_output": "",
        "service_category": "",
        "compiler_type": "Type3"
      }
    }

    vm.PFInput = {
      "request_data": {
        "inputs": {
          "Discount_Code": null,
          "Limit1": null,
          "Limit10": null,
          "Limit2": null,
          "Limit3": null,
          "Limit4": null,
          "Limit5": null,
          "Limit6": null,
          "Limit7": null,
          "Limit8": null,
          "Limit9": null,
          "No_Products": 4,
          "Prm_Active_Lifestyle": "NA",
          "Prm_Age": 30,
          "Prm_AMZNPRIMESG": -1,
          "Prm_Automotive": -628,
          "Prm_Bar": -71,
          "Prm_Child": -472,
          "Prm_CreditArrear": 0,
          "Prm_CreditBalance": 8302,
          "Prm_CreditScore": "NA",
          "Prm_Currency": "NA",
          "Prm_Dependents": 0,
          "Prm_E_commerce": -528,
          "Prm_Education": "A Levels",
          "Prm_Food": -1999,
          "Prm_Gaming": -7,
          "Prm_Gender": "Female",
          "Prm_Grocery": -535,
          "Prm_Hair": -66,
          "Prm_Health": -161,
          "Prm_Helper": -444,
          "Prm_Home": "NA",
          "Prm_Income": 27000,
          "Prm_Industry": "Insurance",
          "Prm_Insurance": "NA",
          "Prm_LateSleeper": "NA",
          "Prm_Loan": 0,
          "Prm_Location": "NA",
          "Prm_Luxury": "NA",
          "Prm_Marital_Status": "Single",
          "Prm_Mortgage": "NA",
          "Prm_Movies": -29,
          "Prm_Occupation": "I.T.",
          "Prm_Petrol": -99,
          "Prm_Postcode": 300821,
          "Prm_Rent": -5156,
          "Prm_Residency": "Employment Pass",
          "Prm_Retail_shopping": -473,
          "Prm_Transport": -366,
          "Prm_Travel": -345,
          "Prm_Utility": -218,
          "Selection": "Recommended",
          "UW_Response": [
            {
              "ID": 2,
              "Response": "N"
            },
            {
              "ID": 3,
              "Response": "N"
            },
            {
              "ID": 4,
              "Response": "N"
            }
          ]
        }
      },
      "request_meta": {
        "version_id": "55303ac9-2a03-42ee-9c85-4808b8e1064f",
        "transaction_date": "2022-06-27T23:43:40.011Z",
        "call_purpose": "Spark - API Tester",
        "source_system": "SPARK",
        "correlation_id": "",
        "requested_output": "",
        "service_category": ""
      }
    }

    vm.PFOutput = {
      "response_data": {
        "outputs": {
          "01_Gross_Prem_before_discount": 89.35,
          "02a_Discount_Multi_Pct": 0.16,
          "02b_Code_Discount_Pct": 0,
          "02c_Code_Discount_amt": 0,
          "02d_Code_Discount_Product": "null",
          "02e_Code_Discount_Error_Msg": "null",
          "02g_Gross_Prem_after_discount": 75.05,
          "02h_Total_Discount": 14.3,
          "03_Comm": 18.65,
          "04_Tax": 3.16,
          "05_Net_Prem": 56.4,
          "06_Gross_Prem_inc_Tax": 78.21,
          "API_Discount": "{\"metadata\":{\"name\":\"EMBBEDED_Discount\",\"calltype\":\"EXTERNALXMLAPIBYNAME\",\"status\":\"200\",\"error_code\":\"\",\"response_time\":\"637\"},\"data\":{\"message\":null,\"data\":{\"Inputs\":{\"Discount_Code\":null,\"Product_cnt\":4,\"DateTime\":44621.02690667824},\"Outputs\":{\"02a_Discount_Multi_Pct\":0.16,\"02b_Code_Discount_Pct\":null,\"02c_Code_Discount_Amt\":null,\"02d_Code_Discount_Product\":null,\"02e_Code_Discount_Error_Msg\":null,\"DateTime\":44621.02690667824},\"Errors\":[],\"FetchTimeUTC\":\"2022-03-01T00:38:45.3731048Z\",\"EngineID\":\"ca9671c9-13ef-4d7c-8a84-19d43aa5e62d\",\"ServiceName\":\"Discount Table\",\"EngineType\":\"Type3\",\"Revision\":\"1.54.0\",\"Version\":\"4b807af6-7084-4422-b8fd-28628972fb56\",\"ReleaseDate\":\"2022-02-17 06:12:31\",\"Description\":null,\"EngineHash\":\"C737DF30DF5B3455C0A81841599819AB\",\"CalcTime\":0.0,\"TotalTime\":28,\"SolveInputs\":[],\"SolveOutputs\":[],\"ProductName\":\"Flex\",\"EffectiveStartDate\":\"2010-01-01T00:00:00Z\",\"EffectiveEndDate\":\"2120-01-01T00:00:00Z\",\"CallGUID\":\"c473a4a7-dca5-41e5-8de0-4a6a1b19a073\"},\"errorCode\":null,\"status\":\"Success\"}}",
          "API_Postcode": "{\"metadata\":{\"name\":\"SGLOCATE_POSTCODE\",\"calltype\":\"EXTERNALXMLAPIBYNAME\",\"status\":\"200\",\"error_code\":\"\",\"response_time\":\"0\"},\"data\":{\"metadata\":{\"name\":\"SGLOCATE_POSTCODE\",\"calltype\":\"EXTERNALXMLAPIBYNAME\",\"status\":\"200\",\"error_code\":\"\",\"response_time\":\"252\"},\"data\":{\"IsSuccess\":false,\"ErrorCode\":\"-21\",\"ErrorDetails\":\"Unauthorized postcode for demo plan.\",\"Postcodes\":[]}}}",
          "API_Recommender": "{\"metadata\":{\"name\":\"EMBBEDED_Recommender\",\"calltype\":\"EXTERNALXMLAPIBYNAME\",\"status\":\"200\",\"error_code\":\"\",\"response_time\":\"937\"},\"data\":{\"message\":null,\"data\":{\"Inputs\":{\"Factors\":[{\"Variables\":\"Age\",\"Value\":30},{\"Variables\":\"Gender\",\"Value\":\"Female\"},{\"Variables\":\"Income\",\"Value\":27000},{\"Variables\":\"Postcode\",\"Value\":300821},{\"Variables\":\"Occupation\",\"Value\":\"I.T.\"},{\"Variables\":\"Industry\",\"Value\":\"Insurance\"},{\"Variables\":\"Marital Status\",\"Value\":\"Single\"},{\"Variables\":\"Dependents\",\"Value\":0},{\"Variables\":\"Education\",\"Value\":\"A Levels\"},{\"Variables\":\"Residency\",\"Value\":\"Employment Pass\"},{\"Variables\":\"CreditBalance\",\"Value\":8302},{\"Variables\":\"CreditArrear\",\"Value\":0},{\"Variables\":\"Loan\",\"Value\":0},{\"Variables\":\"Health\",\"Value\":-161},{\"Variables\":\"Child\",\"Value\":-472},{\"Variables\":\"Insurance\",\"Value\":\"NA\"},{\"Variables\":\"Travel\",\"Value\":-345},{\"Variables\":\"Luxury\",\"Value\":\"NA\"},{\"Variables\":\"E-commerce\",\"Value\":-528},{\"Variables\":\"Active Lifestyle\",\"Value\":\"NA\"},{\"Variables\":\"Grocery\",\"Value\":-535},{\"Variables\":\"Home\",\"Value\":\"NA\"},{\"Variables\":\"Currency\",\"Value\":\"NA\"},{\"Variables\":\"Automotive\",\"Value\":-628},{\"Variables\":\"Bar\",\"Value\":-71},{\"Variables\":\"Food\",\"Value\":-1999},{\"Variables\":\"Gaming\",\"Value\":-7},{\"Variables\":\"Hair\",\"Value\":-66},{\"Variables\":\"Helper\",\"Value\":-444},{\"Variables\":\"Movies\",\"Value\":-29},{\"Variables\":\"Petrol\",\"Value\":-99},{\"Variables\":\"Rent\",\"Value\":-5156},{\"Variables\":\"Retail shopping\",\"Value\":-473},{\"Variables\":\"Transport\",\"Value\":-366},{\"Variables\":\"Utility\",\"Value\":-218},{\"Variables\":\"AMZNPRIMESG\",\"Value\":-1},{\"Variables\":\"Mortgage\",\"Value\":\"NA\"},{\"Variables\":\"CreditScore\",\"Value\":\"NA\"},{\"Variables\":\"LateSleeper\",\"Value\":\"NA\"},{\"Variables\":\"Location\",\"Value\":\"NA\"}],\"DateTime\":44621.02689101852},\"Outputs\":{\"Results\":[{\"ID\":1,\"Model\":\"Term Life\",\"Prob\":0.004496273160941,\"Manual Offer Flag\":\"Y\",\"Calc Offer Flag\":\"Y\",\"Offer_Flag\":\"Y\",\"Probability\":0.004496273160941,\"Rank\":8},{\"ID\":2,\"Model\":\"Accidental PPD\",\"Prob\":0.768524783499018,\"Manual Offer Flag\":\"Y\",\"Calc Offer Flag\":\"Y\",\"Offer_Flag\":\"Y\",\"Probability\":0.768524783499018,\"Rank\":5},{\"ID\":3,\"Model\":\"Critical Illness\",\"Prob\":0.574442516811659,\"Manual Offer Flag\":\"Y\",\"Calc Offer Flag\":\"Y\",\"Offer_Flag\":\"Y\",\"Probability\":0.574442516811659,\"Rank\":6},{\"ID\":4,\"Model\":\"Medical Expenses\",\"Prob\":0,\"Manual Offer Flag\":\"Y\",\"Calc Offer Flag\":\"Y\",\"Offer_Flag\":\"Y\",\"Probability\":0.0,\"Rank\":10},{\"ID\":5,\"Model\":\"Hospital Cash\",\"Prob\":0.995033198349943,\"Manual Offer Flag\":\"Y\",\"Calc Offer Flag\":\"Y\",\"Offer_Flag\":\"Y\",\"Probability\":0.995033198349943,\"Rank\":2},{\"ID\":6,\"Model\":\"Travel\",\"Prob\":0.930861579656653,\"Manual Offer Flag\":\"Y\",\"Calc Offer Flag\":\"Y\",\"Offer_Flag\":\"Y\",\"Probability\":0.930861579656653,\"Rank\":4},{\"ID\":7,\"Model\":\"Home Emergency Assistance\",\"Prob\":0,\"Manual Offer Flag\":\"Y\",\"Calc Offer Flag\":\"Y\",\"Offer_Flag\":\"Y\",\"Probability\":0.0,\"Rank\":11},{\"ID\":8,\"Model\":\"Cyber\",\"Prob\":0.999647462162129,\"Manual Offer Flag\":\"N\",\"Calc Offer Flag\":\"Y\",\"Offer_Flag\":\"N\",\"Probability\":0.0,\"Rank\":9},{\"ID\":9,\"Model\":\"Home Contents\",\"Prob\":0.994779874306442,\"Manual Offer Flag\":\"Y\",\"Calc Offer Flag\":\"Y\",\"Offer_Flag\":\"Y\",\"Probability\":0.994779874306442,\"Rank\":3},{\"ID\":10,\"Model\":\"Unemployment*\",\"Prob\":0,\"Manual Offer Flag\":\"Y\",\"Calc Offer Flag\":\"N\",\"Offer_Flag\":\"Y\",\"Probability\":0.0,\"Rank\":13},{\"ID\":11,\"Model\":\"Event Cancellation\",\"Prob\":0,\"Manual Offer Flag\":\"Y\",\"Calc Offer Flag\":\"N\",\"Offer_Flag\":\"Y\",\"Probability\":0.0,\"Rank\":14},{\"ID\":12,\"Model\":\"Item\",\"Prob\":0.999981542106704,\"Manual Offer Flag\":\"Y\",\"Calc Offer Flag\":\"Y\",\"Offer_Flag\":\"Y\",\"Probability\":0.999981542106704,\"Rank\":1},{\"ID\":13,\"Model\":\"Shipping Insurance\",\"Prob\":0,\"Manual Offer Flag\":\"Y\",\"Calc Offer Flag\":\"N\",\"Offer_Flag\":\"Y\",\"Probability\":0.0,\"Rank\":15},{\"ID\":14,\"Model\":\"Sports coverage for physical injury\",\"Prob\":0,\"Manual Offer Flag\":\"Y\",\"Calc Offer Flag\":\"N\",\"Offer_Flag\":\"Y\",\"Probability\":0.0,\"Rank\":16},{\"ID\":15,\"Model\":\"Competition / Race coverage\",\"Prob\":0,\"Manual Offer Flag\":\"Y\",\"Calc Offer Flag\":\"N\",\"Offer_Flag\":\"Y\",\"Probability\":0.0,\"Rank\":17},{\"ID\":16,\"Model\":\"Gimmicky \\\"prize\\\" insurance\",\"Prob\":0,\"Manual Offer Flag\":\"Y\",\"Calc Offer Flag\":\"N\",\"Offer_Flag\":\"Y\",\"Probability\":0.0,\"Rank\":18},{\"ID\":17,\"Model\":\"Education\",\"Prob\":0.004406347697722,\"Manual Offer Flag\":\"Y\",\"Calc Offer Flag\":\"Y\",\"Offer_Flag\":\"Y\",\"Probability\":0.004406347697722,\"Rank\":9},{\"ID\":18,\"Model\":\"Crypto\",\"Prob\":0.52497918747894,\"Manual Offer Flag\":\"Y\",\"Calc Offer Flag\":\"Y\",\"Offer_Flag\":\"Y\",\"Probability\":0.52497918747894,\"Rank\":7}],\"DateTime\":44621.02689101852},\"Errors\":[],\"FetchTimeUTC\":\"2022-03-01T00:38:44.315657Z\",\"EngineID\":\"149bc281-78cd-4a73-ae06-3f6954a558d8\",\"ServiceName\":\"Recommender\",\"EngineType\":\"Type3\",\"Revision\":\"1.13.0\",\"Version\":\"b64d1690-5e0b-4776-b21d-dcad5787c3b4\",\"ReleaseDate\":\"2022-02-24 03:18:06\",\"Description\":null,\"EngineHash\":\"DCF5F4F71650966C5FFC6B2ED7CA023D\",\"CalcTime\":243.0,\"TotalTime\":267,\"SolveInputs\":[],\"SolveOutputs\":[],\"ProductName\":\"Flex\",\"EffectiveStartDate\":\"2010-01-01T00:00:00Z\",\"EffectiveEndDate\":\"2120-01-01T00:00:00Z\",\"CallGUID\":\"f4e8a5a1-e7ae-4671-91f4-2b152033c46c\"},\"errorCode\":null,\"status\":\"Success\"}}",
          "API_Res1": null,
          "API_Res10": "{\"metadata\":{\"name\":\"EMBBEDED_10_Product\",\"calltype\":\"EXTERNALXMLAPIBYNAME\",\"status\":\"200\",\"error_code\":\"\",\"response_time\":\"0\"},\"data\":{\"metadata\":{\"name\":\"EMBBEDED_10_Product\",\"calltype\":\"EXTERNALXMLAPIBYNAME\",\"status\":\"200\",\"error_code\":\"\",\"response_time\":\"566\"},\"data\":{\"message\":null,\"data\":{\"Inputs\":{\"Promotion_Code\":null,\"Quote_Date\":null,\"Sum_Assured\":200},\"Outputs\":{\"Commission\":0,\"Commission_Rate\":0.3,\"Decline_Flag\":null,\"Decline_Reason\":null,\"Gross_Premium\":10.11,\"Net_Premium\":10.11,\"Tax\":0,\"Tax_Rate\":0},\"Errors\":[],\"Warnings\":[{\"Key\":\"Default Values\",\"Value\":[\"Input parameter(s) missing. API request using the Default Values.\"]}],\"FetchTimeUTC\":\"2022-03-01T00:34:34.4308968Z\",\"EngineID\":\"9479a708-ff71-45d0-9a21-5dab0258be7f\",\"ServiceName\":\"10_Travel Product Engine\",\"EngineType\":\"Type3\",\"Revision\":\"1.0.0\",\"Version\":\"2232627f-dbc1-43c2-9c8a-a0d5b069d451\",\"ReleaseDate\":\"2022-01-26 05:55:18\",\"Description\":null,\"EngineHash\":\"1E1C47AEE1D4A91AD1606DAD068712D5\",\"CalcTime\":0.0,\"TotalTime\":38,\"SolveInputs\":[],\"SolveOutputs\":[],\"ProductName\":\"Product Engine General Insurance\",\"EffectiveStartDate\":\"2010-01-01T00:00:00Z\",\"EffectiveEndDate\":\"2120-01-01T00:00:00Z\",\"CallGUID\":\"8b64f098-cb5f-4802-a6ab-e4ddf18a8a18\"},\"errorCode\":null,\"status\":\"Success\"}}}",
          "API_Res2": null,
          "API_Res3": null,
          "API_Res4": null,
          "API_Res5": null,
          "API_Res6": "{\"metadata\":{\"name\":\"EMBBEDED_06_Product\",\"calltype\":\"EXTERNALXMLAPIBYNAME\",\"status\":\"200\",\"error_code\":\"\",\"response_time\":\"403\"},\"data\":{\"message\":null,\"data\":{\"Inputs\":{\"Content_SI\":400,\"Floor_Size\":1999,\"Payment_Options\":null,\"Postal_Code\":18979,\"Promotion_Code\":null,\"Property_Type\":\"Flat\",\"Quote_Date\":\"2021-11-23 T03:00:00Z\",\"Year_Built\":1980,\"DateTime\":44621.02690193287},\"Outputs\":{\"Commission\":12.52,\"Commission_Rate\":0.2,\"Decline_Flag\":0,\"Decline_Reason\":null,\"Gross_Premium\":62.62,\"Net_Premium\":50.1,\"Tax\":3.76,\"Tax_Rate\":0.060044714148834,\"DateTime\":44621.02690193287},\"Errors\":[],\"Warnings\":[{\"Key\":\"Default Values\",\"Value\":[\"Input parameter(s) missing. API request using the Default Values.\"]}],\"FetchTimeUTC\":\"2022-03-01T00:38:44.7256002Z\",\"EngineID\":\"f2298058-60ee-44c7-ab68-6699527c9786\",\"ServiceName\":\"06_Home Content Product Engine Details\",\"EngineType\":\"Type3\",\"Revision\":\"1.6.0\",\"Version\":\"2112747e-b704-4f74-a2f6-360ef82a37dd\",\"ReleaseDate\":\"2022-02-17 02:25:40\",\"Description\":null,\"EngineHash\":\"A7B948C677A3B7C3F848043CA662C1B9\",\"CalcTime\":1.0,\"TotalTime\":40,\"SolveInputs\":[],\"SolveOutputs\":[],\"ProductName\":\"Product Engine General Insurance\",\"EffectiveStartDate\":\"2010-01-01T00:00:00Z\",\"EffectiveEndDate\":\"2120-01-01T00:00:00Z\",\"CallGUID\":\"4cfed0c5-c151-40d3-9859-b948d757c7ba\"},\"errorCode\":null,\"status\":\"Success\"}}",
          "API_Res7": "{\"metadata\":{\"name\":\"EMBBEDED_07_Product\",\"calltype\":\"EXTERNALXMLAPIBYNAME\",\"status\":\"200\",\"error_code\":\"\",\"response_time\":\"0\"},\"data\":{\"metadata\":{\"name\":\"EMBBEDED_07_Product\",\"calltype\":\"EXTERNALXMLAPIBYNAME\",\"status\":\"200\",\"error_code\":\"\",\"response_time\":\"518\"},\"data\":{\"message\":null,\"data\":{\"Inputs\":{\"Promotion_Code\":null,\"Quote_Date\":null,\"Sum_Assured\":100},\"Outputs\":{\"Commission\":0,\"Commission_Rate\":0.4,\"Decline_Flag\":null,\"Decline_Reason\":null,\"Gross_Premium\":16.55,\"Net_Premium\":16.55,\"Tax\":0,\"Tax_Rate\":0},\"Errors\":[],\"Warnings\":[{\"Key\":\"Default Values\",\"Value\":[\"Input parameter(s) missing. API request using the Default Values.\"]}],\"FetchTimeUTC\":\"2022-03-01T00:34:33.3378237Z\",\"EngineID\":\"4f01723c-7f63-4804-9a86-94f21e398e9a\",\"ServiceName\":\"07_Hospital Cash Product Engine\",\"EngineType\":\"Type3\",\"Revision\":\"1.0.0\",\"Version\":\"b96d92fd-c179-4ed4-bfff-20cf8e194b57\",\"ReleaseDate\":\"2022-01-26 05:47:05\",\"Description\":null,\"EngineHash\":\"9D41B7D38066D29C5B36DE6E010ECB6A\",\"CalcTime\":0.0,\"TotalTime\":36,\"SolveInputs\":[],\"SolveOutputs\":[],\"ProductName\":\"Product Engine Life and Health\",\"EffectiveStartDate\":\"2010-01-01T00:00:00Z\",\"EffectiveEndDate\":\"2120-01-01T00:00:00Z\",\"CallGUID\":\"139369a5-960b-460c-8bc6-1f65e739e61d\"},\"errorCode\":null,\"status\":\"Success\"}}}",
          "API_Res8": "{\"metadata\":{\"name\":\"EMBBEDED_08_Product\",\"calltype\":\"EXTERNALXMLAPIBYNAME\",\"status\":\"200\",\"error_code\":\"\",\"response_time\":\"0\"},\"data\":{\"metadata\":{\"name\":\"EMBBEDED_08_Product\",\"calltype\":\"EXTERNALXMLAPIBYNAME\",\"status\":\"200\",\"error_code\":\"\",\"response_time\":\"518\"},\"data\":{\"message\":null,\"data\":{\"Inputs\":{\"Promotion_Code\":null,\"Quote_Date\":null,\"Sum_Assured\":200},\"Outputs\":{\"Commission\":0,\"Commission_Rate\":0.3,\"Decline_Flag\":null,\"Decline_Reason\":null,\"Gross_Premium\":0.07,\"Net_Premium\":0.07,\"Tax\":0,\"Tax_Rate\":0},\"Errors\":[],\"Warnings\":[{\"Key\":\"Default Values\",\"Value\":[\"Input parameter(s) missing. API request using the Default Values.\"]}],\"FetchTimeUTC\":\"2022-03-01T00:34:33.8626535Z\",\"EngineID\":\"8ce8e4dc-6b85-46d7-98f3-1950da08141c\",\"ServiceName\":\"08_Item Product Engine\",\"EngineType\":\"Type3\",\"Revision\":\"1.0.0\",\"Version\":\"d6a0795d-75fd-45a8-9943-83b73a968f79\",\"ReleaseDate\":\"2022-01-26 05:55:06\",\"Description\":null,\"EngineHash\":\"FCDCEAA7E7903C94755673FA05A5AD0D\",\"CalcTime\":0.0,\"TotalTime\":21,\"SolveInputs\":[],\"SolveOutputs\":[],\"ProductName\":\"Product Engine General Insurance\",\"EffectiveStartDate\":\"2010-01-01T00:00:00Z\",\"EffectiveEndDate\":\"2120-01-01T00:00:00Z\",\"CallGUID\":\"b248d1a6-b42b-4907-b6ad-d65c5641a5ef\"},\"errorCode\":null,\"status\":\"Success\"}}}",
          "API_Res9": null,
          "API_UWQ": "{\"metadata\":{\"name\":\"EMBBEDED_UWQuestions\",\"calltype\":\"EXTERNALXMLAPIBYNAME\",\"status\":\"200\",\"error_code\":\"\",\"response_time\":\"731\"},\"data\":{\"message\":null,\"data\":{\"Inputs\":{\"Selected_Products\":[{\"ID\":1,\"Selected\":\"N\"},{\"ID\":2,\"Selected\":\"N\"},{\"ID\":3,\"Selected\":\"N\"},{\"ID\":4,\"Selected\":\"N\"},{\"ID\":5,\"Selected\":\"N\"},{\"ID\":6,\"Selected\":\"Y\"},{\"ID\":7,\"Selected\":\"Y\"},{\"ID\":8,\"Selected\":\"Y\"},{\"ID\":9,\"Selected\":\"N\"},{\"ID\":10,\"Selected\":\"Y\"}],\"UW_Response\":[{\"ID\":2,\"Response\":\"N\"},{\"ID\":3,\"Response\":\"N\"},{\"ID\":4,\"Response\":\"N\"}],\"DateTime\":44621.026914155096},\"Outputs\":{\"Question_Sets\":[{\"ID\":1,\"Value\":\"Has any of your life insurance application been declined before?\",\"Response\":\"Yes;No;\",\"Referral_Response\":\"Yes\",\"Display\":\"N\"},{\"ID\":2,\"Value\":\"Have you had a home insurance policy cancelled, declined, refused to renew or had special terms and conditions imposed upon a policy, or have made or reported a home insurance claim in the past 3 years ?\",\"Response\":\"Yes;No;\",\"Referral_Response\":\"Yes\",\"Display\":\"Y\"},{\"ID\":3,\"Value\":\"Have you ever had, or been told that you have, or are you currently under investigation for diabetes, cancer, heart attack, stroke, AIDS or HIV infection, carcinoma in situ, tumour, lump or polyp?\",\"Response\":\"Yes;No;\",\"Referral_Response\":\"Yes\",\"Display\":\"Y\"},{\"ID\":4,\"Value\":\"In the past 2  years, have you had any abnormal results in a pap smear, mammogram, breast ultrasound, prostate examinination or tumour market blood test?\",\"Response\":\"Yes;No;\",\"Referral_Response\":\"Yes\",\"Display\":\"Y\"},{\"ID\":5,\"Value\":\"In the last 12 months, has the proposed insured smoked any cigarette, cigars, electronic cigarettes, vaporizers or waterpipe tobacco?\",\"Response\":\"Yes;No;\",\"Referral_Response\":\"\",\"Display\":\"Y\"}],\"Referral_Flag\":\"Quote\",\"DateTime\":44621.026914155096},\"Errors\":[],\"FetchTimeUTC\":\"2022-03-01T00:38:46.1104987Z\",\"EngineID\":\"0e7ef5f8-af6f-465b-87b9-dd115fd83cbd\",\"ServiceName\":\"UW Questions\",\"EngineType\":\"Type3\",\"Revision\":\"1.15.0\",\"Version\":\"a6105790-ad39-4d97-9593-eee9b360b1a3\",\"ReleaseDate\":\"2022-02-23 13:11:40\",\"Description\":null,\"EngineHash\":\"6CCC083D2BA7398E655674B8814E5483\",\"CalcTime\":3.0,\"TotalTime\":35,\"SolveInputs\":[],\"SolveOutputs\":[],\"ProductName\":\"Flex\",\"EffectiveStartDate\":\"2010-01-01T00:00:00Z\",\"EffectiveEndDate\":\"2120-01-01T00:00:00Z\",\"CallGUID\":\"7c316d8b-d219-4430-b17d-0580fb3bde18\"},\"errorCode\":null,\"status\":\"Success\"}}",
          "Postcode_Out1": "ErrValue",
          "Postcode_Out2": "ErrValue",
          "Postcode_Out3": "ErrValue",
          "Postcode_Out4": "ErrValue",
          "Premium_Detail": [
            {
              "ID": 1,
              "Gross_Premium_before_Discount": "",
              "Gross_Premium_after_Discount": "",
              "Commission": "",
              "Tax": "",
              "Net_Premium": "",
              "Gross_Premium_inc_Tax": ""
            },
            {
              "ID": 2,
              "Gross_Premium_before_Discount": "",
              "Gross_Premium_after_Discount": "",
              "Commission": "",
              "Tax": "",
              "Net_Premium": "",
              "Gross_Premium_inc_Tax": ""
            },
            {
              "ID": 3,
              "Gross_Premium_before_Discount": "",
              "Gross_Premium_after_Discount": "",
              "Commission": "",
              "Tax": "",
              "Net_Premium": "",
              "Gross_Premium_inc_Tax": ""
            },
            {
              "ID": 4,
              "Gross_Premium_before_Discount": "",
              "Gross_Premium_after_Discount": "",
              "Commission": "",
              "Tax": "",
              "Net_Premium": "",
              "Gross_Premium_inc_Tax": ""
            },
            {
              "ID": 5,
              "Gross_Premium_before_Discount": "",
              "Gross_Premium_after_Discount": "",
              "Commission": "",
              "Tax": "",
              "Net_Premium": "",
              "Gross_Premium_inc_Tax": ""
            },
            {
              "ID": 6,
              "Gross_Premium_before_Discount": 62.62,
              "Gross_Premium_after_Discount": 52.6,
              "Commission": 10.52,
              "Tax": 3.16,
              "Net_Premium": 42.08,
              "Gross_Premium_inc_Tax": 55.76
            },
            {
              "ID": 7,
              "Gross_Premium_before_Discount": 16.55,
              "Gross_Premium_after_Discount": 13.9,
              "Commission": 5.56,
              "Tax": 0,
              "Net_Premium": 8.34,
              "Gross_Premium_inc_Tax": 13.9
            },
            {
              "ID": 8,
              "Gross_Premium_before_Discount": 0.07,
              "Gross_Premium_after_Discount": 0.06,
              "Commission": 0.02,
              "Tax": 0,
              "Net_Premium": 0.04,
              "Gross_Premium_inc_Tax": 0.06
            },
            {
              "ID": 9,
              "Gross_Premium_before_Discount": "",
              "Gross_Premium_after_Discount": "",
              "Commission": "",
              "Tax": "",
              "Net_Premium": "",
              "Gross_Premium_inc_Tax": ""
            },
            {
              "ID": 10,
              "Gross_Premium_before_Discount": 10.11,
              "Gross_Premium_after_Discount": 8.49,
              "Commission": 2.55,
              "Tax": 0,
              "Net_Premium": 5.94,
              "Gross_Premium_inc_Tax": 8.49
            }
          ],
          "Question_Sets": [
            {
              "ID": 1,
              "Value": "Has any of your life insurance application been declined before?",
              "Response": "Yes;No;",
              "Referral_Response": "Yes",
              "Display": "N"
            },
            {
              "ID": 2,
              "Value": "Have you had a home insurance policy cancelled, declined, refused to renew or had special terms and conditions imposed upon a policy, or have made or reported a home insurance claim in the past 3 years ?",
              "Response": "Yes;No;",
              "Referral_Response": "Yes",
              "Display": "Y"
            },
            {
              "ID": 3,
              "Value": "Have you ever had, or been told that you have, or are you currently under investigation for diabetes, cancer, heart attack, stroke, AIDS or HIV infection, carcinoma in situ, tumour, lump or polyp?",
              "Response": "Yes;No;",
              "Referral_Response": "Yes",
              "Display": "Y"
            },
            {
              "ID": 4,
              "Value": "In the past 2  years, have you had any abnormal results in a pap smear, mammogram, breast ultrasound, prostate examinination or tumour market blood test?",
              "Response": "Yes;No;",
              "Referral_Response": "Yes",
              "Display": "Y"
            },
            {
              "ID": 5,
              "Value": "In the last 12 months, has the proposed insured smoked any cigarette, cigars, electronic cigarettes, vaporizers or waterpipe tobacco?",
              "Response": "Yes;No;",
              "Referral_Response": "",
              "Display": "Y"
            }
          ],
          "Recommended_Products": [
            {
              "ID": 8,
              "Product": "Item",
              "Recommend Coverage": 200
            },
            {
              "ID": 7,
              "Product": "Hospital Cash",
              "Recommend Coverage": 100
            },
            {
              "ID": 6,
              "Product": "Home Contents",
              "Recommend Coverage": 400
            },
            {
              "ID": 10,
              "Product": "Travel",
              "Recommend Coverage": 200
            }
          ],
          "Referral_Flag": "Quote,DateTime:44621.026914155096",
          "UI_Options": [
            {
              "ID": 1,
              "Product": "Accidental PPD",
              "Eligibility": "Y",
              "Default": 40000,
              "Min": 0,
              "Max": 200000,
              "Step": 20000
            },
            {
              "ID": 2,
              "Product": "Critical Illness",
              "Eligibility": "Y",
              "Default": 20000,
              "Min": 0,
              "Max": 200000,
              "Step": 20000
            },
            {
              "ID": 3,
              "Product": "Crypto",
              "Eligibility": "Y",
              "Default": 2000,
              "Min": 0,
              "Max": 20000,
              "Step": 2000
            },
            {
              "ID": 4,
              "Product": "Cyber",
              "Eligibility": "Y",
              "Default": 1,
              "Min": 0,
              "Max": 1,
              "Step": 1
            },
            {
              "ID": 5,
              "Product": "Education",
              "Eligibility": "Y",
              "Default": 200,
              "Min": 0,
              "Max": 20000,
              "Step": 2000
            },
            {
              "ID": 6,
              "Product": "Home Contents",
              "Eligibility": "Y",
              "Default": 400,
              "Min": 0,
              "Max": 10000,
              "Step": 1000
            },
            {
              "ID": 7,
              "Product": "Hospital Cash",
              "Eligibility": "Y",
              "Default": 100,
              "Min": 0,
              "Max": 200,
              "Step": 20
            },
            {
              "ID": 8,
              "Product": "Item",
              "Eligibility": "Y",
              "Default": 200,
              "Min": 0,
              "Max": 10000,
              "Step": 1000
            },
            {
              "ID": 9,
              "Product": "Term Life",
              "Eligibility": "Y",
              "Default": 100000,
              "Min": 0,
              "Max": 200000,
              "Step": 20000
            },
            {
              "ID": 10,
              "Product": "Travel",
              "Eligibility": "Y",
              "Default": 200,
              "Min": 0,
              "Max": 2000,
              "Step": 200
            }
          ]
        },
        "warnings": [],
        "errors": [],
        "service_chain": []
      },
      "response_meta": {
        "service_id": null,
        "version_id": "0bdfbd7d-31b7-4821-8971-856110e180de",
        "version": "1.2.0",
        "process_time": 2747,
        "call_id": "261886fe-b2ff-4283-9d38-5ab2d20e2cce",
        "compiler_type": "Type3",
        "compiler_version": "1.0.0",
        "source_hash": null,
        "engine_id": "F5802C4B510681F7B6396B84B5B9E5F5",
        "correlation_id": "",
        "system": "SPARK",
        "request_timestamp": "2022-03-01, 00:38:43 GMT+00:00"
      }
    }

    vm.recommendedPlans = [
        {
            "premium": "",
            "cover": 200,
            "name": "Item",
            "Default": 200,
            "Min": 0,
            "Max": 10000,
            "Step": 1000,
            "ID": 8
        },
        {
            "premium": "",
            "cover": 100,
            "name": "Hospital Cash",
            "Default": 100,
            "Min": 0,
            "Max": 200,
            "Step": 20,
            "ID": 7
        },
        {
            "premium": 10.11,
            "cover": 200,
            "name": "Travel",
            "Default": 200,
            "Min": 0,
            "Max": 2000,
            "Step": 200,
            "ID": 10
        },
        {
            "premium": "",
            "cover": 400,
            "name": "Home Contents",
            "Default": 400,
            "Min": 0,
            "Max": 10000,
            "Step": 1000,
            "ID": 6
        }
    ]

    vm.productRotationInput = {"request_data":{"inputs":{"Amount":"10000","BillType":"electric","FirstBill":true,"LastViewed":"Ginsure Bill Protect","OfferType":"Single","OwnCyber":false,"OwnHome":false,"OwnProtect":false,"OwnTravel":false}},"request_meta":{}}
    vm.productUpsellInput = {"request_data":{"inputs":{"Age":"24","Family":false,"HighNet":false,"LifeStyle":false,"PersonalEffects":false,"Spouse":false, "Passengers": "0"}},"request_meta":{}}

    vm.PFToken = '302041c0-6c2b-4567-8b3a-ae21cbf9671c'

    vm.activeProduct = ''
    vm.productData = []

    vm.setActiveProduct = function (activeProduct) {
      vm.activeProduct = activeProduct;
    }
    vm.setProductData = function (productData) {
      vm.productData = productData;
    }

    vm.plansSamples = [
        {
            "premium": 3.44,
            "name": "Cyber",
            "Default": 1,
            "Min": 0,
            "Max": 1,
            "Step": 1,
            "ID": 4
        },
        {
            "premium": 98,
            "name": "Home Contents",
            "Default": 400,
            "Min": 0,
            "Max": 10000,
            "Step": 1000,
            "ID": 6
        },
        {
            "premium": 16.22,
            "name": "Hospital Cash",
            "Default": 100,
            "Min": 0,
            "Max": 200,
            "Step": 20,
            "ID": 7
        },
        {
            "premium": 0.07,
            "name": "Item",
            "Default": 200,
            "Min": 0,
            "Max": 10000,
            "Step": 1000,
            "ID": 8
        }
    ];
    vm.customCoverages = []

    vm.personas = [
     {
       "Persona_ID": 1,
       "Name": "Cassandra",
       "Prm_Age": 30,
       "Prm_Gender": "Female",
       "Prm_Income": 999,
       "Prm_Postcode": 300821,
       "Prm_Occupation": "I.T.",
       "Prm_Industry": "Insurance",
       "Prm_Marital_Status": "Single",
       "Prm_Dependents": 0,
       "Prm_Education": "A Levels",
       "Prm_Residency": "Employment Pass",
       "Prm_CreditBalance": 8302,
       "Prm_CreditArrear": 0,
       "Prm_Loan": 0,
       "Prm_Health": 0,
       "Prm_Child": -470,
       "Prm_Insurance": "NA",
       "Prm_Travel": -345,
       "Prm_Luxury": "NA",
       "Prm_E-commerce": -200,
       "Prm_Active_Lifestyle": "NA",
       "Prm_Grocery": -535,
       "Prm_Home": "NA",
       "Prm_Currency": 0,
       "Prm_Automotive": -600,
       "Prm_Bar": 0,
       "Prm_Food": 0,
       "Prm_Gaming": 0,
       "Prm_Hair": 0,
       "Prm_Helper": 0,
       "Prm_Movies": 0,
       "Prm_Petrol": 0,
       "Prm_Rent": -3000,
       "Prm_Retail_shopping": -555,
       "Prm_Transport": 0,
       "Prm_Utility": 0,
       "Prm_AMZNPRIMESG": 0,
       "Prm_Mortgage": "NA",
       "Prm_CreditScore": "NA",
       "Prm_LateSleeper": "NA",
       "Prm_Location": "NA",
       "Prm_Deposits": 1000,
       "Prm_Transfers": 100,
       "Prm_BillsPayed": 100,
       "Prm_Spending": 200
     },
     {
       "Persona_ID": 2,
       "Name": "Cristine",
       "Prm_Age": 23,
       "Prm_Gender": "Female",
       "Prm_Income": 2000,
       "Prm_Postcode": 768100,
       "Prm_Occupation": "Lawyer",
       "Prm_Industry": "Insurance",
       "Prm_Marital_Status": "Single",
       "Prm_Dependents": 0,
       "Prm_Education": "Bachelor Degree",
       "Prm_Residency": "Singaporean/ PR",
       "Prm_CreditBalance": 0,
       "Prm_CreditArrear": 0,
       "Prm_Loan": "NA",
       "Prm_Health": 0,
       "Prm_Child": 0,
       "Prm_Insurance": "NA",
       "Prm_Travel": -7447,
       "Prm_Luxury": "NA",
       "Prm_E-commerce": -319,
       "Prm_Active_Lifestyle": "NA",
       "Prm_Grocery": "NA",
       "Prm_Home": "NA",
       "Prm_Currency": 0,
       "Prm_Automotive": 0,
       "Prm_Bar": "NA",
       "Prm_Food": -52.8840975,
       "Prm_Gaming": "NA",
       "Prm_Hair": "NA",
       "Prm_Helper": "NA",
       "Prm_Movies": "NA",
       "Prm_Petrol": "NA",
       "Prm_Rent": -7000,
       "Prm_Retail_shopping": -271,
       "Prm_Transport": -42,
       "Prm_Utility": "NA",
       "Prm_AMZNPRIMESG": 0,
       "Prm_Mortgage": "NA",
       "Prm_CreditScore": "NA",
       "Prm_LateSleeper": "NA",
       "Prm_Location": "NA",
       "Prm_Deposits": 3000,
       "Prm_Transfers": 500,
       "Prm_BillsPayed": 500,
       "Prm_Spending": 1000
     },
     {
       "Persona_ID": 3,
       "Name": "Charlie",
       "Prm_Age": 30,
       "Prm_Gender": "Male",
       "Prm_Income": 12000,
       "Prm_Postcode": 428975,
       "Prm_Occupation": "Business owner",
       "Prm_Industry": "Education",
       "Prm_Marital_Status": "Married",
       "Prm_Dependents": 1,
       "Prm_Education": "Bachelor Degree",
       "Prm_Residency": "Singaporean/ PR",
       "Prm_CreditBalance": 5100,
       "Prm_CreditArrear": 0,
       "Prm_Loan": "NA",
       "Prm_Health": -120,
       "Prm_Child": -712,
       "Prm_Insurance": "NA",
       "Prm_Travel": 0,
       "Prm_Luxury": 0,
       "Prm_E-commerce": -20,
       "Prm_Active_Lifestyle": -255,
       "Prm_Grocery": "NA",
       "Prm_Home": "NA",
       "Prm_Currency": -19845,
       "Prm_Automotive": 0,
       "Prm_Bar": "NA",
       "Prm_Food": "NA",
       "Prm_Gaming": 0,
       "Prm_Hair": "NA",
       "Prm_Helper": "NA",
       "Prm_Movies": "NA",
       "Prm_Petrol": "NA",
       "Prm_Rent": -100,
       "Prm_Retail_shopping": 0,
       "Prm_Transport": -10,
       "Prm_Utility": "NA",
       "Prm_AMZNPRIMESG": -1,
       "Prm_Mortgage": 0,
       "Prm_CreditScore": "Grade A",
       "Prm_LateSleeper": "Y",
       "Prm_Location": "Local",
       "Prm_Deposits": 5000,
       "Prm_Transfers": 100,
       "Prm_BillsPayed": 90,
       "Prm_Spending": 200
     },
     {
       "Persona_ID": 4,
       "Name": "Casey",
       "Prm_Age": 30,
       "Prm_Gender": "Male",
       "Prm_Income": 20500,
       "Prm_Postcode": 428975,
       "Prm_Occupation": "Business owner",
       "Prm_Industry": "Education",
       "Prm_Marital_Status": "Married",
       "Prm_Dependents": 1,
       "Prm_Education": "Bachelor Degree",
       "Prm_Residency": "Singaporean/ PR",
       "Prm_CreditBalance": 5100,
       "Prm_CreditArrear": 0,
       "Prm_Loan": "NA",
       "Prm_Health": -120,
       "Prm_Child": -8712,
       "Prm_Insurance": "NA",
       "Prm_Travel": 0,
       "Prm_Luxury": -55,
       "Prm_E-commerce": -20,
       "Prm_Active_Lifestyle": -255,
       "Prm_Grocery": "NA",
       "Prm_Home": "NA",
       "Prm_Currency": -845,
       "Prm_Automotive": 0,
       "Prm_Bar": "NA",
       "Prm_Food": "NA",
       "Prm_Gaming": -630,
       "Prm_Hair": "NA",
       "Prm_Helper": "NA",
       "Prm_Movies": "NA",
       "Prm_Petrol": "NA",
       "Prm_Rent": -100,
       "Prm_Retail_shopping": -74,
       "Prm_Transport": -10,
       "Prm_Utility": "NA",
       "Prm_AMZNPRIMESG": -1,
       "Prm_Mortgage": 0,
       "Prm_CreditScore": "Grade A",
       "Prm_LateSleeper": "Y",
       "Prm_Location": "Local",
       "Prm_Deposits": 40000,
       "Prm_Transfers": 0,
       "Prm_BillsPayed": 0,
       "Prm_Spending": 0
     },
     {
       "Persona_ID": 5,
       "Name": "Cory",
       "Prm_Age": 30,
       "Prm_Gender": "Male",
       "Prm_Income": 20500,
       "Prm_Postcode": 428975,
       "Prm_Occupation": "Business owner",
       "Prm_Industry": "Education",
       "Prm_Marital_Status": "Married",
       "Prm_Dependents": 1,
       "Prm_Education": "Bachelor Degree",
       "Prm_Residency": "Singaporean/ PR",
       "Prm_CreditBalance": 5100,
       "Prm_CreditArrear": 0,
       "Prm_Loan": "NA",
       "Prm_Health": -120,
       "Prm_Child": -8712,
       "Prm_Insurance": "NA",
       "Prm_Travel": 0,
       "Prm_Luxury": -55,
       "Prm_E-commerce": -20,
       "Prm_Active_Lifestyle": -255,
       "Prm_Grocery": "NA",
       "Prm_Home": "NA",
       "Prm_Currency": -845,
       "Prm_Automotive": 0,
       "Prm_Bar": "NA",
       "Prm_Food": "NA",
       "Prm_Gaming": -630,
       "Prm_Hair": "NA",
       "Prm_Helper": "NA",
       "Prm_Movies": "NA",
       "Prm_Petrol": "NA",
       "Prm_Rent": -100,
       "Prm_Retail_shopping": -74,
       "Prm_Transport": -10,
       "Prm_Utility": "NA",
       "Prm_AMZNPRIMESG": -1,
       "Prm_Mortgage": 0,
       "Prm_CreditScore": "Grade A",
       "Prm_LateSleeper": "Y",
       "Prm_Location": "Local",
       "Prm_Deposits": 500000,
       "Prm_Transfers": 1000,
       "Prm_BillsPayed": 90,
       "Prm_Spending": 20000
     }
    ]

  }
})();

(function() {
  'use strict';

  angular
    .module('CoherentDemos')
    .factory('EmbeddedFactory', fctry);

  /** @ngInject */
  function fctry($http,
                 $q,
                 $timeout) {
    var vm = this;

    return vm;
  }
})();

(function() {
  'use strict';

  angular
    .module('CoherentDemos')

    .constant('ACCIDENT_TYPE', 'PA')
    .constant('ACCIDENT_PLANS_PAYLOAD', {"Description":"","EndPoint":"https://excel.sonic.dev.coherent.com.hk/api/v1/product/coherent/engines/Execute/PA","EngineType":"Type1","Inputs":{"Channel":"Agent_2","ClaimAmount":[{"Amount":7878,"Benefit":"A2","Claimant":null,"EventDate":null,"EventStart":null},{"Amount":null,"Benefit":null,"Claimant":null,"EventDate":null,"EventStart":null},{"Amount":null,"Benefit":null,"Claimant":null,"EventDate":null,"EventStart":null},{"Amount":null,"Benefit":null,"Claimant":null,"EventDate":null,"EventStart":null},{"Amount":null,"Benefit":null,"Claimant":null,"EventDate":null,"EventStart":null},{"Amount":null,"Benefit":null,"Claimant":null,"EventDate":null,"EventStart":null},{"Amount":null,"Benefit":null,"Claimant":null,"EventDate":null,"EventStart":null},{"Amount":null,"Benefit":null,"Claimant":null,"EventDate":null,"EventStart":null},{"Amount":null,"Benefit":null,"Claimant":null,"EventDate":null,"EventStart":null},{"Amount":null,"Benefit":null,"Claimant":null,"EventDate":null,"EventStart":null},{"Amount":null,"Benefit":null,"Claimant":null,"EventDate":null,"EventStart":null},{"Amount":null,"Benefit":null,"Claimant":null,"EventDate":null,"EventStart":null},{"Amount":null,"Benefit":null,"Claimant":null,"EventDate":null,"EventStart":null},{"Amount":null,"Benefit":null,"Claimant":null,"EventDate":null,"EventStart":null},{"Amount":null,"Benefit":null,"Claimant":null,"EventDate":null,"EventStart":null},{"Amount":null,"Benefit":null,"Claimant":null,"EventDate":null,"EventStart":null},{"Amount":null,"Benefit":null,"Claimant":null,"EventDate":null,"EventStart":null},{"Amount":null,"Benefit":null,"Claimant":null,"EventDate":null,"EventStart":null},{"Amount":null,"Benefit":null,"Claimant":null,"EventDate":null,"EventStart":null},{"Amount":null,"Benefit":null,"Claimant":null,"EventDate":null,"EventStart":null}],"ClaimHistory":[{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null}],"ClaimToDate":[{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null}],"Cover_Start_Date":"2028-07-09","Coverage":"Insured_1","DOB":"1980-01-01","Gender":"F","Optional_Benefits":[{"Included":"Y","Option":"Insured_1"}],"Plan":"Plan_1","Policy_Cover_QuoteDate":"2021-07-01","PostalCode":"064-0806","Promotion_Discount_Code":null,"Ratings":[{"RatingFactor":"RakutenPoints","Value":20},{"RatingFactor":null,"Value":null},{"RatingFactor":null,"Value":null},{"RatingFactor":null,"Value":null},{"RatingFactor":null,"Value":null},{"RatingFactor":null,"Value":null},{"RatingFactor":null,"Value":null},{"RatingFactor":null,"Value":null},{"RatingFactor":null,"Value":null},{"RatingFactor":null,"Value":null},{"RatingFactor":null,"Value":null},{"RatingFactor":null,"Value":null},{"RatingFactor":null,"Value":null},{"RatingFactor":null,"Value":null},{"RatingFactor":null,"Value":null}],"Term":1,"Underwriting_Response":[{"UWSurveyCode":"PA_UW_1","UWSurveyResponse":"Y"},{"UWSurveyCode":"PA_UW_2","UWSurveyResponse":"Y"},{"UWSurveyCode":"PA_UW_3","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_4","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_5","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_6","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_7","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_8","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_9","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_10","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_11","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_12","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_13","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_14","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_15","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_16","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_17","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_18","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_19","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_20","UWSurveyResponse":null}]},"IsRichJson":false,"RequestedOutPut":"","RequestedServiceCategory":"","ServiceCategories":["Claim","Options","Refund"],"ServiceName":"Bicycle_Product_v1.3","ShouldExecuteInputs":false,"Solves":[],"TransactionDate":"2021-07-24T09:47:26.499Z"});

})();

(function() {
  'use strict';

  angular
    .module('CoherentDemos')
    .controller('SpendingController', ctrl);

  /** @ngInject */
  function ctrl($state,
                EmbeddedService,
                EmbeddedFactory,
                $http) {
    var vm = this;
    vm.totalTransactions = 0
    vm.index = EmbeddedService.activePersonaID-1
    vm.personas = EmbeddedService.personas
    console.log(vm.index)
    console.log(vm.personas)

    vm.activePersona = EmbeddedService.activePersona
    vm.txn1 = Math.abs(parseInt(vm.personas[vm.index]["Prm_Health"])) 
    vm.txn2 = Math.abs(parseInt(vm.personas[vm.index]["Prm_Child"])) 
    vm.txn3 = Math.abs(parseInt(vm.personas[vm.index]["Prm_Retail_shopping"])) 
    vm.txn4 = Math.abs(parseInt(vm.personas[vm.index]["Prm_Automotive"])) 
    vm.txn5 = Math.abs(parseInt(vm.personas[vm.index]["Prm_Rent"])) 
    vm.txn6 = Math.abs(parseInt(vm.personas[vm.index]["Prm_Travel"])) 
    vm.txn7 = Math.abs(parseInt(vm.personas[vm.index]["Prm_Currency"])) 

    vm.totalTransactions = Math.abs(vm.txn1 + vm.txn2  + vm.txn3 + vm.txn4 + vm.txn5 + vm.txn6 + vm.txn7)

    vm.txn1Pct = Math.round(vm.txn1 / vm.totalTransactions  * 100)
    vm.txn2Pct = Math.round(vm.txn2 / vm.totalTransactions  * 100)
    vm.txn3Pct = Math.round(vm.txn3 / vm.totalTransactions  * 100)
    vm.txn4Pct = Math.round(vm.txn4 / vm.totalTransactions  * 100)
    vm.txn5Pct = Math.round(vm.txn5 / vm.totalTransactions  * 100)
    vm.txn6Pct = Math.round(vm.txn6 / vm.totalTransactions  * 100)
    vm.txn7Pct = Math.round(vm.txn7 / vm.totalTransactions  * 100)

    vm.txn1Count = Math.round(vm.txn1 / 100)
    vm.txn2Count = Math.round(vm.txn2 / 100)
    vm.txn3Count = Math.round(vm.txn3 / 100)
    vm.txn4Count = Math.round(vm.txn4 / 100)
    vm.txn5Count = Math.round(vm.txn5 / 100)
    vm.txn6Count = Math.round(vm.txn6 / 100)
    vm.txn7Count = Math.round(vm.txn7 / 100)


    vm.arclength1 = vm.txn1 / vm.totalTransactions * 565
    vm.arclength2 = vm.txn2 / vm.totalTransactions * 565
    vm.arclength3 = vm.txn3 / vm.totalTransactions * 565
    vm.arclength4 = vm.txn4 / vm.totalTransactions * 565
    vm.arclength5 = vm.txn5 / vm.totalTransactions * 565
    vm.arclength6 = vm.txn6 / vm.totalTransactions * 565
    vm.arclength7 = vm.txn7 / vm.totalTransactions * 565
    
    vm.offset1 = -1 * (0)
    vm.offset2 = -1 * (vm.arclength1)
    vm.offset3 = -1 * (vm.arclength1 + vm.arclength2)
    vm.offset4 = -1 * (vm.arclength1 + vm.arclength2 + vm.arclength3)
    vm.offset5 = -1 * (vm.arclength1 + vm.arclength2 + vm.arclength3 + vm.arclength4)
    vm.offset6 = -1 * (vm.arclength1 + vm.arclength2 + vm.arclength3 + vm.arclength4 + vm.arclength5)
    vm.offset7 = -1 * (vm.arclength1 + vm.arclength2 + vm.arclength3 + vm.arclength4 + vm.arclength5 + vm.arclength6)

    vm.dasharray1 = Math.round(vm.txn1 / vm.totalTransactions * 565) + ' 565'
    vm.dasharray2 = Math.round(vm.txn2 / vm.totalTransactions * 565) + ' 565'
    vm.dasharray3 = Math.round(vm.txn3 / vm.totalTransactions * 565) + ' 565'
    vm.dasharray4 = Math.round(vm.txn4 / vm.totalTransactions * 565) + ' 565'
    vm.dasharray5 = Math.round(vm.txn5 / vm.totalTransactions * 565) + ' 565'
    vm.dasharray6 = Math.round(vm.txn6 / vm.totalTransactions * 565) + ' 565'
    vm.dasharray7 = Math.round(vm.txn7 / vm.totalTransactions * 565) + ' 565'

    return vm;
  }
})();

(function () {
  'use strict';

  angular.module('CoherentDemos').controller('EmbeddedFlex4Controller', EmbeddedFlex4Controller);
  /** @ngInject */

  function EmbeddedFlex4Controller($state, EmbeddedService, $http) {
    var vm = this;
    
    vm.totalPrice = EmbeddedService.PFOutput["02g_Gross_Prem_after_discount"];
    vm.oldprice = EmbeddedService.PFOutput["01_Gross_Prem_before_discount"];
    vm.discount = Math.round(EmbeddedService.PFOutput["02a_Discount_Multi_Pct"] * 100);
    vm.UWquestions = EmbeddedService.PFOutput.Question_Sets
    vm.activePersona = EmbeddedService.activePersona
    vm.modules = EmbeddedService.recommendedPlans
    console.log(vm.modules)

    vm.proceed = function () {
      EmbeddedService.purchased = true
      $state.go('embedded-landing')
    }
  }
})();
(function () {
  'use strict';

  angular.module('CoherentDemos').controller('EmbeddedFlex3Controller', EmbeddedFlex3Controller);
  /** @ngInject */

  function EmbeddedFlex3Controller($state, EmbeddedService, $http) {
    var vm = this;
    
    vm.totalPrice = EmbeddedService.PFOutput["02g_Gross_Prem_after_discount"];
    vm.oldprice = EmbeddedService.PFOutput["01_Gross_Prem_before_discount"];
    vm.discount = Math.round(EmbeddedService.PFOutput["02a_Discount_Multi_Pct"] * 100);
    vm.UWquestions = EmbeddedService.PFOutput.Question_Sets
    vm.activePersona = EmbeddedService.activePersona

  }
})();
(function () {
  'use strict';

  angular.module('CoherentDemos').controller('EmbeddedFlex2Controller', EmbeddedFlex2Controller);
  
  /** @ngInject */
  function EmbeddedFlex2Controller($state, EmbeddedService, $http, $document) {
    var vm = this;
    vm.checkbox = {};
    vm.slider = {};
    vm.recommendedPlans = EmbeddedService.recommendedPlans;
    vm.activePersona = EmbeddedService.activePersona;
    vm.totalPrice = EmbeddedService.PFOutput["02g_Gross_Prem_after_discount"];
    vm.PFInput = EmbeddedService.PFInput;
    vm.oldprice = EmbeddedService.PFOutput["01_Gross_Prem_before_discount"];
    vm.discount = Math.round(EmbeddedService.PFOutput["02a_Discount_Multi_Pct"] * 100);
    
    for (var i = 0; i < vm.recommendedPlans.length; i++) {
      var aid = vm.recommendedPlans[i].ID;
      vm.checkbox[aid] = true;
      vm.slider[aid] = {};
      vm.slider[aid].cover = vm.recommendedPlans[i].cover;
      vm.slider[aid].convertedcover = vm.recommendedPlans[i].cover;
      vm.slider[aid].convertedmin = vm.recommendedPlans[i].Min;
      vm.slider[aid].convertedmax = vm.recommendedPlans[i].Max;
      vm.slider[aid].convertedstep = vm.recommendedPlans[i].Step;
    }

    vm.customize = function () {
      var ee = $document[0].getElementById("totprice-animate");
      ee.classList.remove("text-is-updated");
      var ff = $document[0].getElementById("discount-animate");
      ff.classList.remove("text-is-updated");
      vm.PFInput.request_data.inputs.Selection = "Customise";
      EmbeddedService.customCoverages = [];

      for (var i = 0; i < vm.recommendedPlans.length; i++) {
        var a = {};
        a.ID = vm.recommendedPlans[i].ID;

        if (vm.checkbox[vm.recommendedPlans[i].ID] === false) {
          a.value = null;
        } else {
          a.value = parseInt(vm.slider[vm.recommendedPlans[i].ID].convertedcover);
        }

        EmbeddedService.customCoverages.push(a);
        vm.PFInput.request_data.inputs["Limit" + vm.recommendedPlans[i].ID] = EmbeddedService.customCoverages.find(function (x) {
          return x.ID === vm.recommendedPlans[i].ID;
        }).value;

        vm.recommendedPlans[i].cover = EmbeddedService.customCoverages[i].value;
        vm.recommendedPlans[i].included = vm.checkbox[vm.recommendedPlans[i].ID];
      }

      var req = {
        method: 'POST',
        url: 'https://excel.staging.coherent.global/coherentflex/api/v3/folders/Flex/services/Controller File/Execute',
        headers: {
          'x-synthetic-key': EmbeddedService.PFToken,
          'x-tenant-name': 'coherentflex'
        },
        data: vm.PFInput
      };
      
      $http(req).then(function (response) {
        vm.data = response.data.response_data.outputs;
        if (vm.totalPrice != vm.data["02g_Gross_Prem_after_discount"]) {
          ee = $document[0].getElementById("totprice-animate");
          ee.classList.add("text-is-updated");
        }
        // if (vm.discount != vm.data["02a_Discount_Multi_Pct"]) {
        //   var ff = $document[0].getElementById("discount-animate");
        //   ff.classList.add("text-is-updated");
        // }
        vm.totalPrice = vm.data["02g_Gross_Prem_after_discount"];
        vm.oldprice = vm.data["01_Gross_Prem_before_discount"];
        vm.discount = vm.data["02a_Discount_Multi_Pct"] * 100;
        var rc = vm.recommendedPlans;
        EmbeddedService.PFOutput = response.data.response_data.outputs;

        for (var i = 0; i < rc.length; i++) {
          if (vm.checkbox[vm.recommendedPlans[i].ID] === true) {
            vm.slider[vm.recommendedPlans[i].ID].cover = EmbeddedService.customCoverages.find(function (x) {
              return x.ID === rc[i].ID;
            }).value;
            vm.recommendedPlans[i].premium = vm.data.Premium_Detail.find(function (x) {
              return x.ID === rc[i].ID;
            }).Gross_Premium_before_Discount;
          }
        }
        EmbeddedService.recommendedPlans = vm.recommendedPlans;
      });
    };
  }
})();

"use strict";

(function () {
  'use strict';

  angular.module('CoherentDemos').controller('EmbeddedFlex1Controller', EmbeddedFlex1Controller);
  /** @ngInject */

  function EmbeddedFlex1Controller($state, EmbeddedService, $http) {
    var vm = this;
    vm.data = {};
    vm.allPlans = [];
    vm.recommendedPlans = [];
    vm.planObject = {
      premium: 0,
      name: ''
    };
    vm.discount = 1;
    vm.personas = EmbeddedService.personas
    vm.activePersona = ""

    vm.setPersona = function (index) {
      EmbeddedService.PFInput.request_data = {"request_data":{"inputs":{"Discount_Code":null,"Limit1":null,"Limit10":null,"Limit2":null,"Limit3":null,"Limit4":null,"Limit5":null,"Limit6":null,"Limit7":null,"Limit8":null,"Limit9":null,"No_Products":4,"Prm_Active_Lifestyle":"NA","Prm_Age":30,"Prm_AMZNPRIMESG":-1,"Prm_Automotive":-628,"Prm_Bar":-71,"Prm_Child":-472,"Prm_CreditArrear":0,"Prm_CreditBalance":8302,"Prm_CreditScore":"NA","Prm_Currency":"NA","Prm_Dependents":0,"Prm_E_commerce":-528,"Prm_Education":"A Levels","Prm_Food":-1999,"Prm_Gaming":-7,"Prm_Gender":"Female","Prm_Grocery":-535,"Prm_Hair":-66,"Prm_Health":-161,"Prm_Helper":-444,"Prm_Home":"NA","Prm_Income":27000,"Prm_Industry":"Insurance","Prm_Insurance":"NA","Prm_LateSleeper":"NA","Prm_Loan":0,"Prm_Location":"NA","Prm_Luxury":"NA","Prm_Marital_Status":"Single","Prm_Mortgage":"NA","Prm_Movies":-29,"Prm_Occupation":"I.T.","Prm_Petrol":-99,"Prm_Postcode":300821,"Prm_Rent":-5156,"Prm_Residency":"Employment Pass","Prm_Retail_shopping":-473,"Prm_Transport":-366,"Prm_Travel":-345,"Prm_Utility":-218,"Selection":"Recommended","UW_Response":[{"ID":2,"Response":"N"},{"ID":3,"Response":"N"},{"ID":4,"Response":"N"}]}},"request_meta":{"version_id":"64f79261-1e6c-4f8b-992f-6a2ca947d76b","transaction_date":"2022-02-02T18:22:26.084Z","call_purpose":"Spark - API Tester","source_system":"SPARK","correlation_id":"","requested_output":"","service_category":"","compiler_type":"Type3"}}
      EmbeddedService.PFInput.request_data.inputs["Prm_Age"] = EmbeddedService.personas[index-1]["Prm_Age"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Gender"] = EmbeddedService.personas[index-1]["Prm_Gender"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Income"] = EmbeddedService.personas[index-1]["Prm_Income"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Postcode"] = EmbeddedService.personas[index-1]["Prm_Postcode"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Occupation"] = EmbeddedService.personas[index-1]["Prm_Occupation"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Industry"] = EmbeddedService.personas[index-1]["Prm_Industry"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Marital_Status"] = EmbeddedService.personas[index-1]["Prm_Marital_Status"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Dependents"] = EmbeddedService.personas[index-1]["Prm_Dependents"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Education"] = EmbeddedService.personas[index-1]["Prm_Education"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Residency"] = EmbeddedService.personas[index-1]["Prm_Residency"]
      EmbeddedService.PFInput.request_data.inputs["Prm_CreditBalance"] = EmbeddedService.personas[index-1]["Prm_CreditBalance"]
      EmbeddedService.PFInput.request_data.inputs["Prm_CreditArrear"] = EmbeddedService.personas[index-1]["Prm_CreditArrear"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Loan"] = EmbeddedService.personas[index-1]["Prm_Loan"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Health"] = EmbeddedService.personas[index-1]["Prm_Health"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Child"] = EmbeddedService.personas[index-1]["Prm_Child"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Insurance"] = EmbeddedService.personas[index-1]["Prm_Insurance"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Travel"] = EmbeddedService.personas[index-1]["Prm_Travel"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Luxury"] = EmbeddedService.personas[index-1]["Prm_Luxury"]
      EmbeddedService.PFInput.request_data.inputs["Prm_E-commerce"] = EmbeddedService.personas[index-1]["Prm_E-commerce"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Active_Lifestyle"] = EmbeddedService.personas[index-1]["Prm_Active_Lifestyle"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Grocery"] = EmbeddedService.personas[index-1]["Prm_Grocery"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Home"] = EmbeddedService.personas[index-1]["Prm_Home"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Currency"] = EmbeddedService.personas[index-1]["Prm_Currency"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Automotive"] = EmbeddedService.personas[index-1]["Prm_Automotive"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Bar"] = EmbeddedService.personas[index-1]["Prm_Bar"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Food"] = EmbeddedService.personas[index-1]["Prm_Food"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Gaming"] = EmbeddedService.personas[index-1]["Prm_Gaming"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Hair"] = EmbeddedService.personas[index-1]["Prm_Hair"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Helper"] = EmbeddedService.personas[index-1]["Prm_Helper"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Movies"] = EmbeddedService.personas[index-1]["Prm_Movies"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Petrol"] = EmbeddedService.personas[index-1]["Prm_Petrol"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Rent"] = EmbeddedService.personas[index-1]["Prm_Rent"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Retail_shopping"] = EmbeddedService.personas[index-1]["Prm_Retail_shopping"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Transport"] = EmbeddedService.personas[index-1]["Prm_Transport"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Utility"] = EmbeddedService.personas[index-1]["Prm_Utility"]
      EmbeddedService.PFInput.request_data.inputs["Prm_AMZNPRIMESG"] = EmbeddedService.personas[index-1]["Prm_AMZNPRIMESG"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Mortgage"] = EmbeddedService.personas[index-1]["Prm_Mortgage"]
      EmbeddedService.PFInput.request_data.inputs["Prm_CreditScore"] = EmbeddedService.personas[index-1]["Prm_CreditScore"]
      EmbeddedService.PFInput.request_data.inputs["Prm_LateSleeper"] = EmbeddedService.personas[index-1]["Prm_LateSleeper"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Location"] = EmbeddedService.personas[index-1]["Prm_Location"]
      vm.balance = Math.round(EmbeddedService.personas[index-1]["Prm_Income"] * 0.112)
      vm.txn1 = EmbeddedService.PFInput.request_data.inputs["Prm_Health"]
      vm.txn2 = EmbeddedService.PFInput.request_data.inputs["Prm_Child"]
      vm.txn3 = EmbeddedService.PFInput.request_data.inputs["Prm_Retail_shopping"]
      vm.txn4 = EmbeddedService.PFInput.request_data.inputs["Prm_Automotive"]
      vm.txn5 = EmbeddedService.PFInput.request_data.inputs["Prm_Rent"]
      vm.txn6 = EmbeddedService.PFInput.request_data.inputs["Prm_Travel"]

      vm.activePersona = EmbeddedService.personas[index-1].Name
      getPlan();
    }

    function getPlan() {
      vm.recommendedPlans = []
      EmbeddedService.recommendedPlans =[]
      var req = {
        method: 'POST',
        url: 'https://excel.sit.coherent.global/coherent/api/v3/folders/Flex/services/Controller',
        headers: {
          'SecretKey': EmbeddedService.PFToken,
          'x-tenant-name': 'coherent'
        },
        data: EmbeddedService.PFInput
      };
      $http(req).then(function (response) {
        vm.data = response.data.response_data.outputs;
        var rc = vm.data.Recommended_Products;
        EmbeddedService.PFOutput = response.data.response_data.outputs;

        var _loop = function _loop(i) {
          a = {};
          a.premium = vm.data.Premium_Detail.find(function (x) {
            return x.ID === rc[i].ID;
          }).Gross_Premium_before_Discount;
          a.cover = vm.data.Recommended_Products.find(function (x) {
            return x.ID === rc[i].ID;
          })["Recommend Coverage"];
          a.name = vm.data.UI_Options.find(function (x) {
            return x.ID === rc[i].ID;
          }).Product;
          a.Default = vm.data.UI_Options.find(function (x) {
            return x.ID === rc[i].ID;
          }).Default;
          a.Min = vm.data.UI_Options.find(function (x) {
            return x.ID === rc[i].ID;
          }).Min;
          a.Max = vm.data.UI_Options.find(function (x) {
            return x.ID === rc[i].ID;
          }).Max;
          a.Step = vm.data.UI_Options.find(function (x) {
            return x.ID === rc[i].ID;
          }).Step;
          a.ID = vm.data.UI_Options.find(function (x) {
            return x.ID === rc[i].ID;
          }).ID;
          vm.recommendedPlans.push(a);
          vm.discount = Math.round(EmbeddedService.PFOutput["02a_Discount_Multi_Pct"] * 100);
          EmbeddedService.recommendedPlans = vm.recommendedPlans;
        }

        for (var i = 0; i < rc.length; i++) {
          var a;

          _loop(i);
        }
      }, function () {});
    }

    vm.setPersona(1)

  }
})();
(function() {
  'use strict';

  angular
    .module('CoherentDemos')
    .controller('ActivationController', ctrl);

  /** @ngInject */
  function ctrl($state,
                EmbeddedService,
                EmbeddedFactory) {
    var vm = this;

    vm.activePersona = EmbeddedService.activePersona
    vm.totalPrice = EmbeddedService.PFOutput["02g_Gross_Prem_after_discount"];

    return vm;
  }
})();

(function() {
  'use strict';

  angular
    .module('CoherentDemos')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, $rootScope, $timeout, $translate, $window) {
    var unregisterStateChangeSuccess;
    var unregisterStateChangeTitle;

    unregisterStateChangeSuccess = $rootScope.$on('$stateChangeSuccess', function() {
      $timeout(function () {
        $window.scrollTo(0, 0);
      }, 10);
    });

    unregisterStateChangeTitle = $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams) {
      if (toState && toState.data && toState.data.pageTitle) {
        $rootScope.pageTitle = toState.data.pageTitle;
      }
    });

    $rootScope.$on('$destroy', function() {
      unregisterStateChangeSuccess();
      unregisterStateChangeTitle();
    });

    $log.debug('runBlock end');
  }

})();
(function() {
  'use strict';

  angular
    .module('CoherentDemos')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $locationProvider, $urlRouterProvider) {
    $locationProvider.html5Mode(true);

    $stateProvider
      .state('embedded-landing', {
        url: '/',
        templateUrl: 'app/embedded/landing.html',
        controller: 'LandingController',
        controllerAs: 'cont',
        data: {
          pageTitle: 'Digital Bank - Embedded Insurance'
        }
      })
      .state('pay-bills-1', {
        url: '/pay-bills-1',
        templateUrl: 'app/embedded/pay-bills-1.html',
        controller: 'PayBills1Controller',
        controllerAs: 'cont'
      })
      .state('pay-bills-2', {
        url: '/pay-bills-2',
        templateUrl: 'app/embedded/pay-bills-2.html',
        controller: 'PayBills2Controller',
        controllerAs: 'cont'
      })
      .state('pay-bills-3', {
        url: '/pay-bills-3',
        templateUrl: 'app/embedded/pay-bills-3.html',
        controller: 'PayBills3Controller',
        controllerAs: 'cont'
      })
      .state('pay-bills-4', {
        url: '/pay-bills-4',
        templateUrl: 'app/embedded/pay-bills-4.html',
        controller: 'PayBills4Controller',
        controllerAs: 'cont'
      })
      .state('ins-upsell-1', {
        url: '/ins-upsell-1',
        templateUrl: 'app/embedded/ins-upsell-1.html',
        controller: 'InsUpsell1Controller',
        controllerAs: 'cont'
      })
      .state('ins-upsell-2', {
        url: '/ins-upsell-2',
        templateUrl: 'app/embedded/ins-upsell-2.html',
        controller: 'InsUpsell2Controller',
        controllerAs: 'cont'
      })
      .state('ins-upsell-3', {
        url: '/ins-upsell-3',
        templateUrl: 'app/embedded/ins-upsell-3.html',
        controller: 'InsUpsell3Controller',
        controllerAs: 'cont'
      })
      .state('ins-upsell-4', {
        url: '/ins-upsell-4',
        templateUrl: 'app/embedded/ins-upsell-4.html',
        controller: 'InsUpsell4Controller',
        controllerAs: 'cont'
      })
      .state('ins-upsell-5', {
        url: '/ins-upsell-5',
        templateUrl: 'app/embedded/ins-upsell-5.html',
        controller: 'InsUpsell5Controller',
        controllerAs: 'cont'
      })
      .state('embedded-spending', {
        url: '/embedded/spending',
        templateUrl: 'app/embedded/embedded-spending.html',
        controller: 'SpendingController',
        controllerAs: 'cont'
      })
      .state('embedded-activation', {
        url: '/embedded/activation',
        templateUrl: 'app/embedded/activation.html',
        controller: 'ActivationController',
        controllerAs: 'cont'
      })
      .state('catalog-search', {
        url: '/catalog/:urlSearchTerm',
        templateUrl: 'app/catalog/catalog-landing.html',
        controller: 'CatalogLandingController',
        controllerAs: 'cont',
        data: {
          pageTitle: 'Search Demos - Coherent Demos'
        }
      })
      .state('catalog-search-features', {
        url: '/catalog-features/:urlSearchTerm',
        templateUrl: 'app/catalog/catalog-landing.html',
        controller: 'CatalogLandingController',
        controllerAs: 'cont',
        data: {
          pageTitle: 'Search Features - Coherent Demos'
        }
      })
      .state('catalog-landing', {
        url: '/catalog',
        templateUrl: 'app/catalog/catalog-landing.html',
        controller: 'CatalogLandingController',
        controllerAs: 'cont',
        data: {
          pageTitle: 'Coherent Demos'
        }
      })
      .state('solutions-search', {
        url: '/solutions/:urlSearchTerm',
        templateUrl: 'app/solutions/solutions-landing.html',
        controller: 'SolutionsLandingController',
        controllerAs: 'cont',
        data: {
          pageTitle: 'Search Demos - Coherent Demos'
        }
      })
      .state('solutions-search-features', {
        url: '/solutions-features/:urlSearchTerm',
        templateUrl: 'app/solutions/solutions-landing.html',
        controller: 'SolutionsLandingController',
        controllerAs: 'cont',
        data: {
          pageTitle: 'Search Features - Coherent Demos'
        }
      })
      .state('solutions-landing', {
        url: '/solutions',
        templateUrl: 'app/solutions/solutions-landing.html',
        controller: 'SolutionsLandingController',
        controllerAs: 'cont',
        data: {
          pageTitle: 'Coherent Demos'
        }
      })
      .state('life-uw-1', {
        url: '/underwriting-1',
        templateUrl: 'app/underwriting/life-uw-1.html',
        controller: 'LifeUW1Controller',
        controllerAs: 'cont',
        data: {
          pageTitle: 'Health Declaration'
        }
      })
      .state('life-uw-2', {
        url: '/underwriting-2',
        templateUrl: 'app/underwriting/life-uw-2.html',
        controller: 'LifeUW2Controller',
        controllerAs: 'cont',
        data: {
          pageTitle: 'Health Declaration'
        }
      })
      .state('life-uw-3', {
        url: '/underwriting-3',
        templateUrl: 'app/underwriting/life-uw-3.html',
        controller: 'LifeUW3Controller',
        controllerAs: 'cont',
        data: {
          pageTitle: 'Health Declaration'
        }
      })
      .state('life-uw-4', {
        url: '/underwriting-4',
        templateUrl: 'app/underwriting/life-uw-4.html',
        controller: 'LifeUW4Controller',
        controllerAs: 'cont',
        data: {
          pageTitle: 'Health Declaration'
        }
      })
      .state('embedded-flex-1', {
        url: '/embedded-flex-1',
        templateUrl: 'app/embedded/embedded-flex-1.html',
        controller: 'EmbeddedFlex1Controller',
        controllerAs: 'cont',
        data: {
          pageTitle: 'Customize Your Insurance'
        }
      })
      .state('embedded-flex-2', {
        url: '/embedded-flex-2',
        templateUrl: 'app/embedded/embedded-flex-2.html',
        controller: 'EmbeddedFlex2Controller',
        controllerAs: 'cont',
        data: {
          pageTitle: 'UW'
        }
      })
      .state('embedded-flex-3', {
        url: '/embedded-flex-3',
        templateUrl: 'app/embedded/embedded-flex-3.html',
        controller: 'EmbeddedFlex3Controller',
        controllerAs: 'cont',
        data: {
          pageTitle: 'UW'
        }
      })
      .state('embedded-flex-4', {
        url: '/embedded-flex-4',
        templateUrl: 'app/embedded/embedded-flex-4.html',
        controller: 'EmbeddedFlex4Controller',
        controllerAs: 'cont',
        data: {
          pageTitle: 'Payment'
        }
      })
      .state('loyalty-add-money', {
        url: '/add-money',
        templateUrl: 'app/embedded/loyalty-add-money.html',
        controller: 'AddMoneyController',
        controllerAs: 'cont',
        data: {
          pageTitle: 'Add Money'
        }
      })
      .state('scan-to-pay-1', {
        url: '/scan-to-pay-1',
        templateUrl: 'app/embedded/scan-to-pay-1.html',
        controller: 'ScanToPay1Controller',
        controllerAs: 'cont',
        data: {
          pageTitle: 'Scan QR Code'
        }
      })
      .state('scan-to-pay-2', {
        url: '/scan-to-pay-2',
        templateUrl: 'app/embedded/scan-to-pay-2.html',
        controller: 'ScanToPay2Controller',
        controllerAs: 'cont',
        data: {
          pageTitle: 'Payment Success'
        }
      })
      .state('scan-to-pay-3', {
        url: '/scan-to-pay-3',
        templateUrl: 'app/embedded/scan-to-pay-3.html',
        controller: 'ScanToPay3Controller',
        controllerAs: 'cont',
        data: {
          pageTitle: 'Payment Success'
        }
      });


    $stateProvider
      .state('404', {
        url: '/404',
        templateUrl: 'app/404.html'
      });

    $urlRouterProvider.otherwise('/404');
  }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('CoherentDemos')
    .constant('malarkey', malarkey)
    .constant('moment', moment)
    .constant('environment', 'eks')
    .constant('configUrls', {
      eks: {
        keyCloakTokenUrl: 'https://keycloak1.eks.sonic.sit.coherent.com.hk/auth/realms/quick-silver/apikey/token',
        keyCloakApiKey: '2ef30faf-6071-492a-8aaa-96ef207a863a',
        keyCloakPFClient: 'product-factory',
        PFUrl: 'https://excelengine.eks.sonic.sit.coherent.com.hk/api/v1/product/coherent/engines/Execute/',
        createPolicy: 'https://newbusiness.eks.sonic.sit.coherent.com.hk/v1/newpolicy',
        enquirePolicy: 'https://enquiry.eks.sonic.sit.coherent.com.hk/v1/policy/id/',
        fileUpload: 'https://newbusiness.eks.sonic.sit.coherent.com.hk/v1/s3/fileupload',
        claimInitiate: 'https://claims.eks.sonic.sit.coherent.com.hk/v1/claim/initiate',
        applyPremium: 'https://policyservicing.eks.sonic.sit.coherent.com.hk/v1/applypremium',
        topupPremium: 'https://policyservicing.eks.sonic.sit.coherent.com.hk/v1/topuppremium',
        cancelPolicy: 'https://policyservicing.eks.sonic.sit.coherent.com.hk/v1/cancelpolicy',
        updatePolicy: 'https://policyservicing.eks.sonic.sit.coherent.com.hk/v1/update/email',
        isAuthorizationNeeded: true,
        token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiZ3JvdXBzIjpbImFkbWluIiwiaGVhbHRoIl0sImlhdCI6MTUxNjIzOTAyMn0.CMEQlrAI3_MbWZJ1RF0qtvoZi6ZOHKduY3zyIXn8N-o'
      },
      demo: {
        keyCloakTokenUrl: 'https://keycloak.demo.sonic.dev.coherent.global/auth/realms/demo-sonic-global/apikey/token',
        keyCloakApiKey: '85e01b68-1c0b-417c-ae58-2078572f111f',
        keyCloakPFClient: 'product-factory',
        PFUrl: 'https://excelengine.demo.sonic.dev.coherent.global/api/v1/product/coherent/engines/Execute/',
        createPolicy: 'https://newbusiness.demo.sonic.dev.coherent.global/v1/newpolicy',
        enquirePolicy: 'https://enquiry.demo.sonic.dev.coherent.global/v1/policy/id/',
        fileUpload: 'https://newbusiness.demo.sonic.dev.coherent.global/v1/s3/fileupload',
        claimInitiate: 'https://claims.demo.sonic.dev.coherent.global/v1/claim/initiate',
        applyPremium: 'https://policyservicing.demo.sonic.dev.coherent.global/v1/applypremium',
        topupPremium: 'https://policyservicing.demo.sonic.dev.coherent.global/v1/topuppremium',
        cancelPolicy: 'https://policyservicing.demo.sonic.dev.coherent.global/v1/cancelpolicy',
        updatePolicy: 'https://policyservicing.demo.sonic.dev.coherent.global/v1/update/email',
        isAuthorizationNeeded: true,
        token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiZ3JvdXBzIjpbImFkbWluIiwiaGVhbHRoIl0sImlhdCI6MTUxNjIzOTAyMn0.CMEQlrAI3_MbWZJ1RF0qtvoZi6ZOHKduY3zyIXn8N-o'
      }
    });
})();

(function() {
  'use strict';

  angular
    .module('CoherentDemos')
    .config(config);

  /** @ngInject */
  function config($httpProvider, $logProvider, $translateProvider, toastrConfig) {

    var reqs = {};
    var rejected = 0;

    // Apply interceptors for loader
    $httpProvider.interceptors.push(function($q, $rootScope) {
      return {
        request: function(config) {
          reqs[config.url] = true;

          $rootScope.loading = true;

          return config;
        },

        requestError: function(rejection) {
          rejected++;

          var reqsLeft = Object.keys(reqs).length;
          if (reqsLeft === 0 || reqsLeft === rejected) {
            reqs = {};
            $rootScope.loading = false;
          }

          return $q.reject(rejection);
        },

        response: function(response) {
          if (reqs[response.config.url]) {
            delete reqs[response.config.url];
          }

          var reqsLeft = Object.keys(reqs).length;
          if (reqsLeft === 0 || reqsLeft === rejected) {
            reqs = {};
            $rootScope.loading = false;
          }

          return response;
        },

        responseError: function(rejection) {
          rejected++;

          var reqsLeft = Object.keys(reqs).length;
          if (reqsLeft === 0 || reqsLeft === rejected) {
            reqs = {};
            $rootScope.loading = false;
          }

          return $q.reject(rejection);
        }
      };
    });

    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;

    $translateProvider
      .useStaticFilesLoader({
        prefix: '/assets/translations/locale-',
        suffix: '.json'
      })
      .useLoaderCache(true)
      .forceAsyncReload(true)
      .preferredLanguage('jp');
  }

})();

angular.module("CoherentDemos").run(["$templateCache", function($templateCache) {$templateCache.put("app/404.html","404");
$templateCache.put("app/catalog/catalog-landing.html","<div ng-if=!cont.authenticated><div style=\"height: 100vh; width: 100vw\" class=\"d-flex flex-column\"><div class=flex-fill></div><div class=\"d-flex flex-row\"><div class=flex-fill></div><div style=\"min-width: 300px\" class=\"border p16\"><label class=\"text-copy-2 text-300 w-100\">Enter Password</label><input type=text ng-model=cont.pw class=w-100><div class=\"btn btn-d-purple mt8 w-100\" ng-model=cont.pw ng-click=cont.authenticate(cont.pw)>Enter</div></div><div class=flex-fill></div></div><div class=flex-fill></div></div></div><div id=loader-container ng-class=\"{\'active\': cont.isLoading}\" ng-if=cont.authenticated><section id=navbar class=bg-white><div class=\"container pt24 pb24\"><div class=row><div class=col-12><img src=assets/images/coherent-logo-new.svg style=\"height: 32px\"></div></div></div></section><section class=bg-n-purple style=\"margin-bottom: -88px\"><div class=\"container pt64\"><div class=row><div class=col-12><div class=\"text-white text-200\">Demo Library</div><div class=\"text-white text-200 font-48 pt16 pb64\">What demo do you need?</div></div></div><div class=row><div class=\"col-lg-4 mb16\"><div class=\"bg-white p24 card-float\" ng-click=\"cont.tileMenu(\'Core Solutions\');cont.clearSearch();cont.scrollTo(\'tile-selector\')\"><div class=\"text-700 font-16\">Core Solutions</div><center><img src=assets/images/coherent-graphic-1.svg class=\"mt48 mb40\"></center></div></div><div class=\"col-lg-4 mb16\"><div class=\"bg-white p24 card-float\" ng-click=\"cont.tileMenu(\'Features\');cont.clearSearch();cont.scrollTo(\'tile-selector\')\"><div class=\"text-700 font-16\">Features</div><center><img src=assets/images/coherent-graphic-2.svg class=\"mt48 mb40\"></center></div></div><div class=\"col-lg-4 mb16\"><div class=\"bg-white p24 card-float\" ng-click=\"cont.tileMenu(\'Core Solutions\');cont.clearSearch();cont.scrollTo(\'materials-list\')\"><div class=\"text-700 font-16\">Browse All Materials</div><center><img src=assets/images/coherent-graphic-3.svg class=\"mt48 mb40\"></center></div></div></div></div></section><section class=bg-n-dpurple style=\"padding-top: 88px\"><div class=\"container pt40 pb40\"><div class=row><div class=col-12><center><a class=\"link-white text-300 opacity-50\" href=\"\">I need a run through (contact mark.banaria@coherent.global)</a></center></div></div></div></section><section class=bg-white id=tile-selector><div class=\"container pt56\"><div class=row><div class=col-12><div class=\"text-200 text-copy-0 font-24 border-bottom pb16\"><span ng-class=\"{\'text-copy-2\': cont.isCoreSolutions}\" ng-click=\"cont.tileMenu(\'Core Solutions\');cont.clearSearch()\">Core Solutions </span><span>&nbsp;&nbsp;/&nbsp;&nbsp;</span> <span ng-class=\"{\'text-copy-2\': cont.isFeatures}\" ng-click=\"cont.tileMenu(\'Features\');cont.clearSearch()\">Features</span></div></div></div><div class=\"row mt40\"><div class=\"col-lg-3 col-md-6 mb24\" ng-repeat=\"item in cont.tileList\"><div class=\"border pt64 pb64 flex-column\" ng-click=cont.quickFilter(item)><center class=\"text-700 font-21\" ng-bind=item.name></center></div></div></div></div></section><section class=bg-white id=materials-list><div class=\"container pt56\" style=min-height:70vh><div class=row><div class=col-12><div class=\"d-flex flex-row border-bottom\"><div ng-if=cont.isFeatures class=\"text-200 font-24 text-copy-0\">Features:</div><input class=\"flex-fill text-200 font-24 border-bottom pb16 w-100\" id=catalog-search placeholder=\"All Materials (Type to search)\" ng-model=cont.searchTerm onclick=this.select()> <img src=assets/images/search-icon.svg ng-if=!cont.searchTerm> <img src=assets/images/close-icon.svg ng-if=cont.searchTerm ng-click=cont.clearSearch()></div></div></div><div class=\"row mt40\"><div class=\"col-12 mb16 material-card\" ng-repeat=\"item in cont.filteredData | filter: cont.searchFilter\" ng-class=\"{\n            \'bundle-first\': item[\'orderInGroup\']==\'first\',\n            \'bundle-last\': item[\'orderInGroup\']==\'last\'\n          }\"><div class=\"bg-gray-1 border border-radius-md p16 font-16 text-300 d-flex flex-row material-card-content\"><div class=flex-fill><span ng-if=cont.isCoreSolutions ng-bind=\"item[\'Topic Group\'] + \'  /  \'\" class=\"text-300 text-copy-0\"></span> <span ng-bind=\"item[\'Resource Name\']\" class=text-700></span><div ng-if=\"cont.isFeatures&&item[\'Features\']\" ng-bind=\"cont.formatFeatures(item[\'Features\'])\" class=\"text-300 text-copy-0\"></div></div><div><div ng-class=\"{\n                \'label-purple\': cont.isImportant(item[\'Resource Type\']),\n                \'label-pink\': cont.isZnglist(item[\'Resource Type\']),\n                \'label-dpurple\': cont.isModel(item[\'Resource Type\']),\n                \'label-teal\': cont.isPPT(item[\'Resource Type\']),\n                \'label-moss\': cont.isGong(item[\'Resource Type\'])\n              }\" class=card-label ng-if=\"item[\'Resource Type\']\" ng-bind=\"item[\'Resource Type\']\"></div></div><a class=\"pl24 material-card-arrow\" href=\"{{item[\'Internal Sharepoint\']}}\" target=_blank><img src=assets/images/icon-arrow-right.svg></a></div></div></div></div></section><section class=pb64></section></div><!-- <input type=\"text\" ng-model=\"cont.searchText\" placeholder=\"Search...\">\n<ul>\n  <li ng-repeat=\"item in cont.items | filter: cont.customFilter\">{{ item.name }} - {{ item.description }}</li>\n</ul> -->");
$templateCache.put("app/catalog/catalog-page.html","");
$templateCache.put("app/main/main.html","<div class=container><div class=row><div class=col-xs-12></div></div></div>");
$templateCache.put("app/embedded/activation.html","<div class=embedded><div id=embedded-flex-outer-container class=\"pt64 pb64 d-flex flex-column\" style=\"background: black\"><div class=flex-fill></div><div id=embedded-flex-inner-container><section class=\"bg-white w-100\"><div class=container-fluid><div class=\"row pt16 pb16 pl8 pr8 border-bottom\"><div class=\"col-xs-12 font-21\"><div class=\"d-flex flex-row pb24\"><img src=assets/images/embedded-flex/notif-icon.svg><div class=\"dropdown mr16 flex-fill\"><button style=\"padding: 16 0 0 0; background: transparent\" class=\"btn btn-secondary dropdown-toggle font-16\" type=button id=dropdownMenuButton data-toggle=dropdown aria-haspopup=true aria-expanded=false><span ng-bind=cont.activePersona class=text-700></span></button><div class=\"dropdown-menu p16 w-100 dropdown-menu-left\" aria-labelledby=dropdownMenuButton style=\"width: 332px; margin-left: -24px\"><a class=\"w-100 dropdown-item inline-block text-copy-2\" ng-repeat=\"persona in cont.personas\" ng-click=\"console.log(\'a-clicked\');cont.setPersona(persona.Persona_ID)\"><div class=\"border border-radius-md bg-gray-1 w-100 p16 pt8 pb8 mb16\"><div class=\"d-flex flex-row\"><img src=assets/images/avatars/{{persona.Name.toLowerCase()}}.png height=80px><div class=\"flex-fill ml16\"><div class=font-21 ng-bind=persona.Name><strong>Vander</strong></div><div class=\"d-flex flex-row\"><div><div><strong>Age: </strong><span ng-bind=persona.Prm_Age></span></div><div><strong>Gender: </strong><span ng-bind=persona.Prm_Gender></span></div><div><strong>M.Status: </strong><span ng-bind=persona.Prm_Marital_Status></span></div><div><strong>Income: </strong><span ng-bind=persona.Prm_Income></span></div></div></div></div></div></div></a></div></div><img src=/assets/images/avatars/{{cont.activePersona.toLowerCase()}}.png style=\"border-radius: 50%; height: 32px; width: 32px; margin-left: auto; margin-right: auto\"><!-- <a ui-sref=\"embedded-flex-1\" class=\"flex-fill text-copy-2\">Digibank</a> --><!-- <img src=\"assets/images/user-icon.svg\" width=\"32\"> --></div><div class=\"font-32 text-700 mt40 w-100\">Activate <span class=text-purple>MyFlex</span></div><div class=\"font-14 text-copy-0\">Simple Personalized Protection</div><div style=\"border: 4px solid #DEFA3D\" class=\"p24 w-100 border-radius-md mt40\"><div class=\"font-32 text-700 text-center\" ng-bind=cont.totalPrice>$73.9</div></div><img src=assets/images/embedded-flex/what-you-are-getting.png class=\"w-100 mt40\"> <a ui-sref=embedded-flex-2><img src=assets/images/embedded-flex/activate-cta.png class=\"w-100 mt40\"></a></div></div></div></section></div><div class=flex-fill></div></div></div>");
$templateCache.put("app/embedded/embedded-flex-1.html","<div class=embedded><section><div class=container><div class=\"row pt16 pb16 border-bottom\"><div class=\"col-xs-12 font-21\"><div class=\"d-flex flex-row\"><a ui-sref=embedded-flex-1 class=\"flex-fill text-copy-2\">Digibank</a><div class=\"dropdown mr16\"><button class=\"btn btn-secondary dropdown-toggle\" type=button id=dropdownMenuButton data-toggle=dropdown aria-haspopup=true aria-expanded=false ng-bind=cont.activePersona></button><div class=\"dropdown-menu p16 w-100 dropdown-menu-right\" aria-labelledby=dropdownMenuButton style=\"width: 256px\"><a class=\"dropdown-item display-block mb16 text-copy-2 pt16\" ng-repeat=\"persona in cont.personas\" ng-click=\"console.log(\'a-clicked\');cont.setPersona(persona.Persona_ID)\"><div class=\"font-21 pt16\" ng-bind=persona.Name><strong>Vander</strong></div><div><strong>Age: </strong><span ng-bind=persona.Prm_Age></span></div><div><strong>Gender: </strong><span ng-bind=persona.Prm_Gender></span></div><div><strong>Marital Status: </strong><span ng-bind=persona.Prm_Marital_Status></span></div><div><strong>Income: </strong><span ng-bind=persona.Prm_Income></span></div></a></div></div><img src=assets/images/user-icon.svg width=32></div></div></div></div></section><section><div class=container><div class=\"row pt16 pb16 border-bottom bg-gray-1\" ui-sref=embedded-flex-2><div class=\"col-xs-12 font-16\"><div class=\"badge font-14 text-copy-2 bg-white border\">Get a <span ng-bind=cont.discount></span>% Discount</div></div><div class=\"col-xs-12 font-21 mt16\">My Flex Insurance</div><div class=\"col-xs-12 font-14\">Starting at $50/month</div></div><div class=row><div class=\"col-xs-12 font-16\"><div class=\"font-14 mt32\">Balance</div></div><div class=\"col-xs-12 font-40 mt8\" ng-bind=cont.balance></div></div><div class=row><div class=\"col-xs-12 font-16\"><div class=\"font-14 mt32\">Transactions</div></div></div><div class=\"border d-flex flex-row p16 mt32\"><span class=flex-fill>Healthcare</span> <span ng-bind=cont.txn1></span></div><div class=\"border d-flex flex-row p16 mt16\"><span class=flex-fill>Child</span> <span ng-bind=cont.txn2></span></div><div class=\"border d-flex flex-row p16 mt16\"><span class=flex-fill>Retail</span> <span ng-bind=cont.txn3></span></div><div class=\"border d-flex flex-row p16 mt16\"><span class=flex-fill>Auto</span> <span ng-bind=cont.txn4></span></div><div class=\"border d-flex flex-row p16 mt16\"><span class=flex-fill>Rent</span> <span ng-bind=cont.txn5></span></div><div class=\"border d-flex flex-row p16 mt16\"><span class=flex-fill>Travel</span> <span ng-bind=cont.txn6></span></div></div></section></div>");
$templateCache.put("app/embedded/embedded-flex-2.html","<div class=embedded><div id=embedded-flex-outer-container class=\"pt24 pb24 d-flex flex-column\" style=\"background: black\"><div class=flex-fill></div><div id=embedded-flex-inner-container class=bg-white><section><div class=container-fluid><div class=\"row pt16\"><div class=col-xs-12><div class=\"d-flex flex-row pb24\"><div class=flex-fill></div><img ui-sref=embedded-landing src=assets/images/embedded-flex/close-icon.svg></div></div></div><div class=row><div class=col-xs-12><div class=\"font-32 text-700\">Activate <span class=text-purple>MyFlex</span></div><div class=\"font-14 text-300 text-copy-1\">Customise your recommended plans</div></div></div></div></section><section><div class=container-fluid><div class=row><div class=col-xs-12><div class=\"border border-radius-md p16 p8 mt16\" ng-repeat=\"plan in cont.recommendedPlans\"><div class=\"checkbox mt0 mb24\" ng-class=\"{ selected: cont.checkbox[plan.ID] }\" ng-click=\"cont.checkbox[plan.ID] = !cont.checkbox[plan.ID];cont.customize()\"><div class=form-check><input type=checkbox class=form-check-input ng-model=cont.checkbox[plan.ID]> <span class=checkmark></span><label class=form-check-label ng-bind=plan.name></label></div></div><div><range model=cont.slider[plan.ID].convertedcover min=cont.slider[plan.ID].convertedmin max=cont.slider[plan.ID].convertedmax disabled change=cont.customize()></range><div class=\"d-flex flex-row mt16 font-14\"><label for=\"\" class=flex-fill><span class=\"text-300 text-copy-1\">Cover: </span><span class=\"text-700 text-copy-2\" ng-bind=cont.slider[plan.ID].cover></span></label><div><span class=\"text-300 text-copy-1\">Premium: </span><span class=\"text-700 text-copy-2\" ng-class=\"{ strike: !cont.checkbox[plan.ID] }\" ng-bind=plan.premium></span></div></div></div></div></div></div></div></section><section style=\"padding-bottom: 224px\"></section></div><div id=embedded-navbar-container class=\"bg-white pb-24 bg-white\"><div class=container-fluid id=productflow-nav-container><div class=row><div class=col-xs-12><div class=\"font-14 text-copy-1 text-300\">Total Premium</div><div class=\"font-32 text-copy-1 text-300 mb8\">$ <span class=\"text-copy-2 text-700\" ng-bind=cont.totalPrice id=totprice-animate></span></div><div class=\"mb24 font-14 text-300 text-copy-1\">(Bundle Discount <span id=discount-animate ng-bind=cont.discount></span>%) <strike>$ <span ng-bind=cont.oldprice></span></strike></div><div></div><a class=\"btn btn-black w-100 pt8 pb8\" ui-sref=embedded-flex-3>Next: Declaration</a></div></div></div></div><div class=flex-fill></div></div></div>");
$templateCache.put("app/embedded/embedded-flex-3.html","<div class=embedded><div id=embedded-flex-outer-container class=\"pt24 pb24 d-flex flex-column\" style=\"background: black\"><div class=flex-fill></div><div id=embedded-flex-inner-container class=bg-white><section><div class=container-fluid><div class=\"row pt16\"><div class=col-xs-12><div class=\"d-flex flex-row pb24\"><img ui-sref=embedded-flex-2 src=assets/images/embedded-flex/arrow-icon.svg><div class=flex-fill></div><img ui-sref=embedded-landing src=assets/images/embedded-flex/close-icon.svg></div></div></div><div class=row><div class=col-xs-12><div class=\"font-32 text-700\">Please help us with <span class=text-purple>a few questions</span></div></div></div></div></section><section><div class=container-fluid><div class=\"row mt16\"><div class=col-xs-12><div ng-repeat=\"question in cont.UWquestions\"><div class=\"border-top mt16 pt16\" ng-if=\"question.Display == \'Y\'\"><div class=text-300 ng-bind=question.Value></div><div class=\"d-flex flex-row mt32\"><div class=\"flex-fill btn btn-ghost\">YES</div><div class=p8></div><div class=\"flex-fill btn btn-ghost-purple\">NO</div></div></div></div></div></div></div></section><section style=\"padding-bottom: 224px\"></section></div><div id=embedded-navbar-container class=\"bg-white pb-24 bg-white\"><div class=container-fluid id=productflow-nav-container><div class=row><div class=col-xs-12><div class=\"font-14 text-copy-1 text-300\">Total Premium</div><div class=\"font-32 text-copy-1 text-300 mb8\">$ <span class=\"text-copy-2 text-700\" ng-bind=cont.totalPrice id=totprice-animate></span></div><div class=\"mb24 font-14 text-300 text-copy-1\">(Bundle Discount <span id=discount-animate ng-bind=cont.discount></span>%) <strike>$ <span ng-bind=cont.oldprice></span></strike></div><div></div><a class=\"btn btn-black w-100 pt8 pb8\" ui-sref=embedded-flex-4>Next: Checkout</a></div></div></div></div><div class=flex-fill></div></div></div>");
$templateCache.put("app/embedded/embedded-flex-4.html","<div class=embedded><div id=embedded-flex-outer-container class=\"pt24 pb24 d-flex flex-column\" style=\"background: black\"><div class=flex-fill></div><div id=embedded-flex-inner-container class=bg-white><section><div class=container-fluid><div class=\"row pt16\"><div class=col-xs-12><div class=\"d-flex flex-row pb24\"><img ui-sref=embedded-flex-3 src=assets/images/embedded-flex/arrow-icon.svg><div class=flex-fill></div><img ui-sref=embedded-landing src=assets/images/embedded-flex/close-icon.svg></div></div></div><div class=row><div class=col-xs-12><div class=\"font-32 text-700\">Checkout</div><div class=\"font-14 text-300 text-copy-1\">How would you like to pay?</div></div></div></div></section><section><div class=container-fluid><div class=\"row mt16\"><div class=col-xs-12><img src=assets/images/embedded-flex/flex-card.png class=\"w-100 pt24\"><div class=\"mt32 font-16 font-700\">What you are getting</div><div class=mt16><div ng-repeat=\"module in cont.modules\" class=\"border-radius border p16 d-flex flex-row mb16\" ng-if=\"module.included==true\"><div class=flex-fill><div class=text-700>{{module.name}}</div><div class=\"text-300 text-copy-1\">Cover: $ {{module.cover}}</div></div><div class=text-right></div></div></div></div></div></div></section><section style=\"margin-bottom: 224px\"></section></div><div id=embedded-navbar-container class=\"bg-white pb-24 bg-white\"><div class=container-fluid id=productflow-nav-container><div class=container-fluid><div class=row><div class=col-xs-12><div class=\"font-16 text-copy-1 text-300\">The following amount will be deducted</div><div class=\"font-48 text-copy-1 text-300 mb32\">$ <span class=\"text-copy-2 text-700\" ng-bind=cont.totalPrice id=totprice-animate></span></div><div></div><a class=\"btn btn-black w-100 pt8 pb8\" ng-click=cont.proceed()>Pay</a></div></div></div></div></div><div class=flex-fill></div></div></div>");
$templateCache.put("app/embedded/embedded-spending.html","<div class=embedded><div id=embedded-flex-outer-container class=\"pt24 pb24 d-flex flex-column\" style=\"background: black\"><div class=flex-fill></div><div id=embedded-flex-inner-container class=bg-white><section class=\"bg-white w-100\"><div class=container-fluid><div class=\"row pt16 pb16 pl8 pr8 border-bottom\"><div class=\"col-xs-12 font-21\"><div class=\"d-flex flex-row pb24\"><img src=assets/images/embedded-flex/notif-icon.svg><div class=\"dropdown mr16 flex-fill\"><button style=\"padding: 16 0 0 0; background: transparent\" class=\"btn btn-secondary dropdown-toggle font-16\" type=button id=dropdownMenuButton data-toggle=dropdown aria-haspopup=true aria-expanded=false><span ng-bind=cont.activePersona class=text-700></span></button></div><img src=/assets/images/avatars/{{cont.activePersona.toLowerCase()}}.png style=\"border-radius: 50%; height: 32px; width: 32px; margin-left: auto; margin-right: auto\"><!-- <a ui-sref=\"embedded-flex-1\" class=\"flex-fill text-copy-2\">Digibank</a> --><!-- <img src=\"assets/images/user-icon.svg\" width=\"32\"> --></div></div><div class=col-xs-12><div class=\"font-32 text-700\">Spending</div><div class=\"text-center mt32\"><svg width=256 height=256><rect width=180 height=180 fill=none rx=100 ry=100 stroke=#3ECB0C stroke-width=40 stroke-dasharray=\"{{ cont.dasharray1}}\" stroke-dashoffset={{cont.offset1}} stroke-linecap=butt x=30 y=30 /><rect width=180 height=180 fill=none rx=100 ry=100 stroke=#24C4CC stroke-width=40 stroke-dasharray=\"{{ cont.dasharray2}}\" stroke-dashoffset={{cont.offset2}} stroke-linecap=butt x=30 y=30 /><rect width=180 height=180 fill=none rx=100 ry=100 stroke=#9C43FF stroke-width=40 stroke-dasharray=\"{{ cont.dasharray3}}\" stroke-dashoffset={{cont.offset3}} stroke-linecap=butt x=30 y=30 /><rect width=180 height=180 fill=none rx=100 ry=100 stroke=#D533A3 stroke-width=40 stroke-dasharray=\"{{ cont.dasharray4}}\" stroke-dashoffset={{cont.offset4}} stroke-linecap=butt x=30 y=30 /><rect width=180 height=180 fill=none rx=100 ry=100 stroke=#E87722 stroke-width=40 stroke-dasharray=\"{{ cont.dasharray5}}\" stroke-dashoffset={{cont.offset5}} stroke-linecap=butt x=30 y=30 /><rect width=180 height=180 fill=none rx=100 ry=100 stroke=#3B8CFF stroke-width=40 stroke-dasharray=\"{{ cont.dasharray6}}\" stroke-dashoffset={{cont.offset6}} stroke-linecap=butt x=30 y=30 /><rect width=180 height=180 fill=none rx=100 ry=100 stroke=#FFDB1D stroke-width=40 stroke-dasharray=\"{{ cont.dasharray7}}\" stroke-dashoffset={{cont.offset7}} stroke-linecap=butt x=30 y=30 /></svg></div><div class=\"border-top d-flex flex-row p16 mt16\"><img src=assets/images/embedded-flex/shopping.svg><div class=\"ml16 flex-fill\"><div>Shopping</div><div class=\"text-300 font-12 text-copy-1\"><span ng-bind=cont.txn3Count></span> transactions</div></div><div><div class=text-right><span class=\"text-copy-1 text-300\">$</span> <span ng-bind=cont.txn3></span></div><div class=\"text-300 font-12 text-copy-1 text-right\"><span ng-bind=cont.txn3Pct></span>%</div></div></div><div class=\"border-top d-flex flex-row p16 mt16\"><img src=assets/images/embedded-flex/healthcare.svg><div class=\"ml16 flex-fill\"><div>Healthcare</div><div class=\"text-300 font-12 text-copy-1\"><span ng-bind=cont.txn1Count></span> transactions</div></div><div><div class=text-right><span class=\"text-copy-1 text-300\">$</span> <span ng-bind=cont.txn1></span></div><div class=\"text-300 font-12 text-copy-1 text-right\"><span ng-bind=cont.txn1Pct></span>%</div></div></div><div class=\"border-top d-flex flex-row p16 mt16\"><img src=assets/images/embedded-flex/child.svg><div class=\"ml16 flex-fill\"><div>Child</div><div class=\"text-300 font-12 text-copy-1\"><span ng-bind=cont.txn2Count></span> transactions</div></div><div><div class=text-right><span class=\"text-copy-1 text-300\">$</span> <span ng-bind=cont.txn2></span></div><div class=\"text-300 font-12 text-copy-1 text-right\"><span ng-bind=cont.txn2Pct></span>%</div></div></div><div class=\"border-top d-flex flex-row p16 mt16\"><img src=assets/images/embedded-flex/transport.svg><div class=\"ml16 flex-fill\"><div>Transport</div><div class=\"text-300 font-12 text-copy-1\"><span ng-bind=cont.txn4Count></span> transactions</div></div><div><div class=text-right><span class=\"text-copy-1 text-300\">$</span> <span ng-bind=cont.txn4></span></div><div class=\"text-300 font-12 text-copy-1 text-right\"><span ng-bind=cont.txn4Pct></span>%</div></div></div><div class=\"border-top d-flex flex-row p16 mt16\"><img src=assets/images/embedded-flex/rent.svg><div class=\"ml16 flex-fill\"><div>Rent</div><div class=\"text-300 font-12 text-copy-1\"><span ng-bind=cont.txn5Count></span> transactions</div></div><div><div class=text-right><span class=\"text-copy-1 text-300\">$</span> <span ng-bind=cont.txn5></span></div><div class=\"text-300 font-12 text-copy-1 text-right\"><span ng-bind=cont.txn5Pct></span>%</div></div></div><div class=\"border-top d-flex flex-row p16 mt16\"><img src=assets/images/embedded-flex/travel.svg><div class=\"ml16 flex-fill\"><div>Travel</div><div class=\"text-300 font-12 text-copy-1\"><span ng-bind=cont.txn6Count></span> transactions</div></div><div><div class=text-right><span class=\"text-copy-1 text-300\">$</span> <span ng-bind=cont.txn6></span></div><div class=\"text-300 font-12 text-copy-1 text-right\"><span ng-bind=cont.txn6Pct></span>%</div></div></div><div class=\"border-top d-flex flex-row p16 mt16\"><img src=assets/images/embedded-flex/crypto.svg><div class=\"ml16 flex-fill\"><div>Crypto</div><div class=\"text-300 font-12 text-copy-1\"><span ng-bind=cont.txn7Count></span> transactions</div></div><div><div class=text-right><span class=\"text-copy-1 text-300\">$</span> <span ng-bind=cont.txn7></span></div><div class=\"text-300 font-12 text-copy-1 text-right\"><span ng-bind=cont.txn7Pct></span>%</div></div></div></div></div></div></section><section style=\"padding-bottom: 120px\"></section></div><div id=embedded-navbar-container class=\"bg-white pb-24\"><div id=bank-nav-container class=\"d-flex flex-row\" ng-if=!cont.purchased><div class=flex-fill></div><div class=\"bg-black bank-nav border-radius-md pl24 pr24 pt8 pb8\"><a ui-sref=embedded-landing><img src=assets/images/embedded-flex/home.svg height=32></a><a><img src=assets/images/embedded-flex/wallet.svg height=32></a><a><img src=assets/images/embedded-flex/spending-fill.svg height=32></a></div><div class=flex-fill></div></div></div><div class=flex-fill></div></div></div>");
$templateCache.put("app/embedded/ins-upsell-1.html","<div class=embedded><div id=embedded-flex-outer-container class=\"pt24 pb24 d-flex flex-column\" style=\"background: black\"><div class=flex-fill></div><div id=embedded-flex-inner-container class=bg-white style=\"min-height: 748px\"><section class=\"bg-d-purple pl24 pr24 pt56 pb16 d-flex flex-row\"><img ui-sref=embedded-landing src=assets/images/embedded-flex/arrow-icon-white.svg><div class=\"text-white text-center font-16 flex-fill pr24\">Insurance</div></section><section class=bg-gray-2><a ui-sref=ins-upsell-2><img src=assets/images/embedded-flex/insurance-pages/page-1.png class=w-100></a></section></div><div class=flex-fill></div></div></div>");
$templateCache.put("app/embedded/ins-upsell-2.html","<div class=embedded><div id=embedded-flex-outer-container class=\"pt24 pb24 d-flex flex-column\" style=\"background: black\"><div class=flex-fill></div><div id=embedded-flex-inner-container class=bg-white style=\"min-height: 748px\"><section class=\"bg-d-purple pl24 pr24 pt56 pb16 d-flex flex-row\"><img ui-sref=ins-upsell-1 src=assets/images/embedded-flex/arrow-icon-white.svg><div class=\"text-white text-center font-16 flex-fill pr24\">Travel Insurance</div></section><section class=bg-white><a><img src=assets/images/embedded-flex/insurance-pages/page-2.png class=w-100></a><div class=container-fluid><div class=\"form-group mt16 mb48\"><label class=\"text-300 mb8\" for=adults>Number of Adults</label><input type=text id=adults class=\"form-control text-300 mb8\" placeholder=\"Enter a Number\" ng-model=cont.adults><label class=\"text-300 mb8 pt8\" for=children>Number of Children</label><input type=text id=children class=\"form-control text-300 mb8\" placeholder=\"Enter a Number\" ng-model=cont.children><label class=\"text-300 mb8 pt8\" for=age>Age of Policy Owner</label><input type=text id=age class=\"form-control text-300 mb8\" placeholder=\"Enter a Number (not date of birth)\" ng-model=cont.age><div class=\"text-700 pt32\">Select Add Ons</div><div class=\"checkbox mt24 border p8 border-radius bg-gray-2\" ng-class=\"{ selected: cont.lifeevent }\" ng-click=\"cont.lifeevent=!cont.lifeevent\"><div class=form-check><input type=checkbox class=form-check-input ng-model=cont.lifeevent> <span class=checkmark></span><label class=\"text-copy-2 text-300 pl8\" style=\"padding-left: 8px; font-weight: 300\">Life Event</label></div></div><div class=\"checkbox mt24 border p8 border-radius bg-gray-2\" ng-class=\"{ selected: cont.personaleffects }\" ng-click=\"cont.personaleffects=!cont.personaleffects\"><div class=form-check><input type=checkbox class=form-check-input ng-model=cont.personaleffects> <span class=checkmark></span><label class=\"text-copy-2 text-300 pl8\" style=\"padding-left: 8px; font-weight: 300\">Personal Effects</label></div></div><div class=\"checkbox mt24 border p8 border-radius bg-gray-2\" ng-class=\"{ selected: cont.lifestyle }\" ng-click=\"cont.lifestyle=!cont.lifestyle\"><div class=form-check><input type=checkbox class=form-check-input ng-model=cont.lifestyle> <span class=checkmark></span><label class=\"text-copy-2 text-300 pl8\" style=\"padding-left: 8px; font-weight: 300\">Lifestyle</label></div></div><div class=\"checkbox mt24 border p8 border-radius bg-gray-2\" ng-class=\"{ selected: cont.valuables }\" ng-click=\"cont.valuables=!cont.valuables\"><div class=form-check><input type=checkbox class=form-check-input ng-model=cont.valuables> <span class=checkmark></span><label class=\"text-copy-2 text-300 pl8\" style=\"padding-left: 8px; font-weight: 300\">Valuable Items</label></div></div></div><div class=row><div class=col-xs-12><div class=\"btn btn-d-purple w-100 mb32\" ng-click=cont.go()>Next</div></div></div></div></section></div><div class=flex-fill></div></div></div>");
$templateCache.put("app/embedded/ins-upsell-3.html","<div class=embedded><div id=embedded-flex-outer-container class=\"pt24 pb24 d-flex flex-column\" style=\"background: black\"><div class=flex-fill></div><div id=embedded-flex-inner-container class=bg-white style=\"min-height: 748px\"><section class=\"bg-d-purple pl24 pr24 pt56 pb16 d-flex flex-row\"><img ui-sref=ins-upsell-2 src=assets/images/embedded-flex/arrow-icon-white.svg><div class=\"text-white text-center font-16 flex-fill pr24\">Summary</div></section><section class=bg-gray-2><a ui-sref=ins-upsell-4><img src=assets/images/embedded-flex/insurance-pages/page-3.png class=w-100></a></section><section><div class=container-fluid><div class=row><div class=col-xs-12><div class=\"btn btn-d-purple w-100 mb32\" ng-click=cont.go()>Confirm</div></div></div></div></section></div><div class=flex-fill></div></div></div>");
$templateCache.put("app/embedded/ins-upsell-4.html","<div class=embedded><div id=embedded-flex-outer-container class=\"pt24 pb24 d-flex flex-column\" style=\"background: black\"><div class=flex-fill></div><div id=embedded-flex-inner-container class=bg-white style=\"min-height: 748px\"><section class=\"bg-d-purple pl24 pr24 pt56 pb16 d-flex flex-row\"><img ui-sref=ins-upsell-3 src=assets/images/embedded-flex/arrow-icon-white.svg><div class=\"text-white text-center font-16 flex-fill pr24\">Success</div></section><section class=bg-gray-2><a ui-sref=embedded-landing><img src=assets/images/embedded-flex/insurance-pages/page-4.png class=w-100></a></section><section style=\"background-color: #EBE3FF; margin-top: -24px\"><div class=container-fluid><div class=\"form-group mb32\"><center class=\"font-14 text-300 text-copy-1\"><strong class=\"font-16 text-copy-2\">Craft Your Perfect Coverage</strong><br>Unlock More Discounts as Your Protection Expands</center><div class=\"checkbox mt24 box-shadow border-radius overflow-hidden bg-white\" ng-if=\"cont[\'Family PA\']\" ng-class=\"{ selected: cont.familypa }\" ng-click=\"cont.familypa=!cont.familypa; cont.updatePrice(\'familypa\', 0)\"><div class=form-check><input type=checkbox class=form-check-input ng-model=cont.familypa> <span class=\"checkmark mt16 ml16\"></span><div class=\"d-flex flex-row\"><div class=\"flex-fill p16\"><label class=\"text-copy-2 flex-fill text-300\" style=\"padding-left: 8px; font-weight: 300\">Family PA</label><div class=\"pl8 text-300 font-12 text-copy-0\">{{cont.data.ProductDetails[\"0\"].Description}}</div><div class=\"pl8 mt16 text-copy-2 text-700\">{{cont.data.ProductDetails[\"0\"].Premium}}<span class=\"text-300 text-copy-0\"> PHP</span></div></div><div style=\"width: 80px; background-size: cover; background-image: url(\'assets/images/embedded-flex/insurance-pages/Family PA.png\')\"></div></div></div></div><div class=\"checkbox mt24 box-shadow border-radius overflow-hidden bg-white\" ng-if=\"cont[\'Cyber Cover\']\" ng-class=\"{ selected: cont.cybercover }\" ng-click=\"cont.cybercover=!cont.cybercover; cont.updatePrice(\'cybercover\', 1)\"><div class=form-check><input type=checkbox class=form-check-input ng-model=cont.cybercover> <span class=\"checkmark mt16 ml16\"></span><div class=\"d-flex flex-row\"><div class=\"flex-fill p16\"><label class=\"text-copy-2 flex-fill text-300\" style=\"padding-left: 8px; font-weight: 300\">Cyber Cover</label><div class=\"pl8 text-300 font-12 text-copy-0\">{{cont.data.ProductDetails[\"1\"].Description}}</div><div class=\"pl8 mt16 text-copy-2 text-700\">{{cont.data.ProductDetails[\"1\"].Premium}}<span class=\"text-300 text-copy-0\"> PHP</span></div></div><div style=\"width: 80px; background-size: cover; background-image: url(\'assets/images/embedded-flex/insurance-pages/Cyber Cover.png\')\"></div></div></div></div><div class=\"checkbox mt24 box-shadow border-radius overflow-hidden bg-white\" ng-if=\"cont[\'Valuables\']\" ng-class=\"{ selected: cont.valuables }\" ng-click=\"cont.valuables=!cont.valuables; cont.updatePrice(\'valuables\', 2)\"><div class=form-check><input type=checkbox class=form-check-input ng-model=cont.valuables> <span class=\"checkmark mt16 ml16\"></span><div class=\"d-flex flex-row\"><div class=\"flex-fill p16\"><label class=\"text-copy-2 flex-fill text-300\" style=\"padding-left: 8px; font-weight: 300\">Valuables+</label><div class=\"pl8 text-300 font-12 text-copy-0\">{{cont.data.ProductDetails[\"2\"].Description}}</div><div class=\"pl8 mt16 text-copy-2 text-700\">{{cont.data.ProductDetails[\"2\"].Premium}}<span class=\"text-300 text-copy-0\"> PHP</span></div></div><div style=\"width: 80px; background-size: cover; background-image: url(\'assets/images/embedded-flex/insurance-pages/Valuables.png\')\"></div></div></div></div><div class=\"checkbox mt24 box-shadow border-radius overflow-hidden bg-white\" ng-if=\"cont[\'Mobile Guard\']\" ng-class=\"{ selected: cont.mobileguard }\" ng-click=\"cont.mobileguard=!cont.mobileguard; cont.updatePrice(\'mobileguard\', 3)\"><div class=form-check><input type=checkbox class=form-check-input ng-model=cont.mobileguard> <span class=\"checkmark mt16 ml16\"></span><div class=\"d-flex flex-row\"><div class=\"flex-fill p16\"><label class=\"text-copy-2 flex-fill text-300\" style=\"padding-left: 8px; font-weight: 300\">Mobile Guard</label><div class=\"pl8 text-300 font-12 text-copy-0\">{{cont.data.ProductDetails[\"3\"].Description}}</div><div class=\"pl8 mt16 text-copy-2 text-700\">{{cont.data.ProductDetails[\"3\"].Premium}}<span class=\"text-300 text-copy-0\"> PHP</span></div></div><div style=\"width: 80px; background-size: cover; background-image: url(\'assets/images/embedded-flex/insurance-pages/Mobile Guard.png\')\"></div></div></div></div></div><div class=row><div class=col-xs-12><div class=\"mb16 p16 border-radius\" style=\"background-color: #DED0FF; border: 2px solid #3800D8\"><div class=\"font-14 text-700\">Total Price PHP {{cont.totalPrice}}</div><div class=\"font-14 text-copy-1 text-300\">(Bundle Discount {{cont.effectiveDiscount * 100}}%) <strike>{{cont.totalPrice}}</strike></div></div><div class=\"btn btn-d-purple w-100 mb8\" ng-click=cont.go()>Get More Protection</div><div class=\"mb32 text-copy-1 text-300 text-center\">Skip Limited Offer</div></div></div></div></section></div><div class=flex-fill></div></div></div>");
$templateCache.put("app/embedded/ins-upsell-5.html","<div class=embedded><div id=embedded-flex-outer-container class=\"pt24 pb24 d-flex flex-column\" style=\"background: black\"><div class=flex-fill></div><div id=embedded-flex-inner-container class=bg-white style=\"min-height: 748px\"><div class=\"d-flex flex-column\" style=\"min-height: 100%\"><section class=\"bg-d-purple pl24 pr24 pt56 pb16 d-flex flex-row\"><div class=\"text-white text-center font-16 flex-fill pr24\">Success</div></section><div class=\"flex-fill d-flex flex-column\"><div class=flex-fill></div><center class=\"font-21 text-700\"><img src=assets/images/embedded-flex/insurance-pages/shield-graphic.png width=200></center><center class=\"font-21 text-300 p40\">Your Additional Coverage Has Been Added</center><div class=flex-fill></div></div><section class=p24><a class=\"btn btn-d-purple w-100\" ng-click=cont.go()>Go Back</a></section></div></div><div class=flex-fill></div></div></div>");
$templateCache.put("app/embedded/landing.html","<div class=embedded><div id=embedded-flex-outer-container class=\"pt24 pb24 d-flex flex-column\" style=\"background: black\"><div class=flex-fill></div><div id=embedded-flex-inner-container><section class=\"bg-gray-4 w-100\"><div class=container-fluid><div class=\"row pt8 pb8\"><div class=\"col-xs-12 font-21 p0\"><div class=\"text-copy-1 font-12 text-right\" style=\"cursor: pointer\" ng-click=cont.MonthlyProcessing()>Monthly Processing</div></div></div></div></section><section class=\"bg-white w-100\"><div class=container-fluid><div class=\"row pt16 pb16 pl8 pr8\"><div class=\"col-xs-12 font-21\"><div class=\"d-flex flex-row pb8\"><img src=assets/images/embedded-flex/notif-icon.svg><div class=\"dropdown mr16 flex-fill\"><button style=\"padding: 16 0 0 0; background: transparent\" class=\"btn btn-secondary dropdown-toggle font-14\" type=button id=dropdownMenuButton data-toggle=dropdown aria-haspopup=true aria-expanded=false>Hello <span ng-bind=cont.activePersona class=text-700></span>!</button><div class=\"dropdown-menu p16 w-100 dropdown-menu-left\" aria-labelledby=dropdownMenuButton style=\"width: 332px; margin-left: -24px\"><a class=\"w-100 dropdown-item inline-block text-copy-2\" ng-repeat=\"persona in cont.personas\" ng-click=\"console.log(\'a-clicked\');cont.setPersona(persona.Persona_ID)\"><div class=\"border border-radius-md bg-gray-1 w-100 p16 pt8 pb8 mb16\"><div class=\"d-flex flex-row\"><img src=assets/images/avatars/{{persona.Name.toLowerCase()}}.png height=60px><div class=\"flex-fill ml16\"><div class=\"font-16 text-700\" ng-bind=persona.Name><strong>Vander</strong></div><div class=\"d-flex flex-row font-12 mt8\"><div><div><span class=\"text-300 text-copy-1\">Age: </span><span class=\"text-700 text-copy-2\" ng-bind=persona.Prm_Age></span></div><div><span class=\"text-300 text-copy-1\">Gender: </span><span class=\"text-700 text-copy-2\" ng-bind=persona.Prm_Gender></span></div><div><span class=\"text-300 text-copy-1\">M.Status: </span><span class=\"text-700 text-copy-2\" ng-bind=persona.Prm_Marital_Status></span></div><div><span class=\"text-300 text-copy-1\">Balance: </span><span class=\"text-700 text-copy-2\" ng-bind=persona.Prm_Deposits></span></div></div></div></div></div></div></a></div></div><img src=/assets/images/avatars/{{cont.activePersona.toLowerCase()}}.png style=\"border-radius: 50%; height: 32px; width: 32px; margin-left: auto; margin-right: auto\"></div></div></div></div></section><section class=bg-white><div class=container-fluid><div class=\"row pt24 pb16 pl8 pr8\"><div class=\"col-xs-12 font-21\"><img src=assets/images/digital-banking.svg alt=\"\" width=250></div></div></div></section><div class=\"container-fluid bg-white pl24 pb16 border-bottom pt24\" style=\"overflow: scroll\"><div class=\"row pr16\" style=\"width: 458px\"><a class=\"col-xs-4 pr0\" ui-sref=pay-bills-1><div class=\"border p8 border-radius d-flex flex-row\"><img src=assets/images/embedded-flex/bills.svg width=20><div class=\"font-12 flex-fill pl8 text-copy-2\">Pay Bills</div></div></a><a class=\"col-xs-4 pr0\" ui-sref=scan-to-pay-1><div class=\"border p8 border-radius d-flex flex-row\"><img src=assets/images/embedded-flex/transfer.svg width=20><div class=\"font-12 flex-fill pl8 text-copy-2\">Scan to Pay</div></div></a><div class=col-xs-4><div class=\"border p8 border-radius d-flex flex-row\"><img src=assets/images/embedded-flex/invest.svg width=20><div class=\"font-12 flex-fill pl8 text-copy-2\">Save</div></div></div></div></div><section class=\"bg-white w-100\" ng-if=cont.landing><div class=container-fluid><div class=\"row pt16 pb16 pl8 pr8\"><div class=\"col-xs-12 font-21\"><div class=\"border border-radius-md p16\"><div class=\"d-flex flex-row\"><div class=flex-fill><div class=\"font-12 text-copy-1 text-300\">Deposit Account</div><div class=\"font-16 text-300 mt4 text-copy-0\">$ <span class=\"text-700 text-copy-2\" ng-bind=cont.bankBalance></span></div></div><div class=\"d-flex flex-column\"><img src=assets/images/plus-circle.svg alt=\"\" ng-click=cont.AddMoney()><div class=flex-fill></div></div></div><div class=\"font-10 text-copy-1 text-300 mt4\">Your Effective Interest Rate <span ng-bind=\"cont.RewardsData.savingsrate * 100\"></span>% (pa)</div></div><div class=\"border border-radius-md mt8\"><div class=p16><div class=\"d-flex flex-row\"><div class=flex-fill><div class=\"font-12 text-copy-1 text-300\">Rewards</div><div class=\"font-16 mt4 text-300 text-copy-0\"><span class=\"text-700 text-copy-2\" ng-bind=cont.RewardsData.totalpoints></span></div><div class=\"font-10 text-copy-1 text-300 mt4\">Loyalty Points</div></div><div class=\"d-flex flex-column\"><div class=\"d-flex flex-row\"><span class=\"text-700 text-copy-2 font-12\" style=\"margin-right: 6px; text-transform: uppercase\">{{cont.RewardsData.tier}}</span> <img src=assets/images/badges/badge-{{cont.RewardsData.tier.toLowerCase()}}-sm.svg alt=\"\" ng-click=\"cont.RewardsModal = !cont.RewardsModal\"></div><div class=flex-fill></div></div></div></div><div class=\"p16 bg-gray-2 border-top\" ng-if=cont.RewardsModal><div class=\"d-flex flex-row\"><div class=flex-fill><div class=\"font-16 text-copy-2 text-700 pr16\">What you get with your<br>{{cont.RewardsData.tier}} rewards</div></div><div><img src=assets/images/badges/badge-{{cont.RewardsData.tier.toLowerCase()}}-lg.svg alt=\"\" height=48></div></div><div class=\"font-12 pt16\"><div class=text-copy-1><strong class=text-copy-2>Save More: </strong>{{cont.currentReward.Savings * 100}}% Interest Rate</div><div class=text-copy-1><strong class=text-copy-2>Earn Points: </strong>{{cont.currentReward.Points}}x Points Multiplier</div><div class=text-copy-1><strong class=text-copy-2>Better Loans: </strong>{{cont.currentReward.Loan * 100}}% Personal Loan Interest</div><div class=text-copy-1><strong class=text-copy-2>Exclusive Deals: </strong>{{cont.currentReward[\"Discount1\"] * 100}}% Off on Insurance</div></div></div></div><div class=\"border border-radius-md p16 mt8\"><div class=\"d-flex flex-row\"><div class=flex-fill><div class=\"font-12 text-copy-1 text-300\">Loan</div><div class=\"font-14 text-700 text-copy-2\">Apply for a personal loan at <span ng-bind=\"cont.RewardsData.loanrate * 100\"></span>%</div></div><div class=\"d-flex flex-column\"><div class=flex-fill></div></div></div></div><div class=\"border border-radius-md p16 mt8\" ui-sref=embedded-flex-2 ng-if=!cont.purchased><div class=\"d-flex flex-row\"><div class=flex-fill><div class=\"font-12 text-copy-1 text-300\">Insurance</div><div class=\"font-14 mt4 text-300 text-copy-0\"><span class=\"text-700 text-copy-2\">MyFlex Insurance <span class=\"text-300 text-copy-0\">(Get <span ng-bind=\"cont.RewardsData.merchantdiscount1 * 100\"></span>% Off)</span></span></div><div class=\"font-10 text-copy-1 text-300 mt4\">Starts at $50</div></div><div class=\"d-flex flex-column\"><div class=flex-fill></div></div></div></div><div class=\"border border-radius-md p16 mt8\" ng-if=cont.purchased><div class=\"font-12 text-copy-1 text-300\">MyFlex Insurance</div><div class=mt16><div ng-repeat=\"coverage in cont.modules\" class=\"inline-block ml8 mr8\" ng-if=\"coverage.included==true\"><img src=assets/images/embedded-flex/covers/{{coverage.name}}.svg height=32></div></div></div><div class=\"border border-radius-md p16 mt8\"><div class=\"d-flex flex-row\"><div class=flex-fill><div class=\"font-12 text-copy-1 text-300\">Wealth Planning</div><div class=\"font-14 text-700 text-copy-2\">Discover the right financial path for you - Take the Financial Planning Assessement</div></div><div class=\"d-flex flex-column\"><div class=flex-fill></div></div></div></div><div class=\"border border-radius-md p16 mt8 mb64\"><div class=\"font-12 text-copy-1 text-300\">Cards</div><div class=\"d-flex flex-row\"><div class=flex-fill><div class=\"font-16 mt4 text-300 text-copy-0\"><span class=\"text-700 text-copy-2\">$9234</span></div><div class=\"font-10 text-copy-1 text-300 mt4\">Your Balance</div></div><div class=flex-fill><div class=\"font-16 mt4 text-300 text-copy-0\"><span class=\"text-700 text-copy-2\">$10</span></div><div class=\"font-10 text-copy-1 text-300 mt4\">Minimum due</div></div></div><img src=assets/images/embedded-flex/flex-card.png class=\"w-100 pt24\"></div></div></div></div></section><section class=\"bg-white w-100\" ng-if=cont.spending><div class=container-fluid><div class=\"row pt16 pb16 pl8 pr8 border-bottom\"><div class=col-xs-12><div class=\"font-21 text-700\">Spending</div><div class=\"text-center mt32\"><svg width=256 height=256><rect width=180 height=180 fill=none rx=100 ry=100 stroke=#3ECB0C stroke-width=40 stroke-dasharray=\"{{ cont.dasharray1}}\" stroke-dashoffset={{cont.offset1}} stroke-linecap=butt x=30 y=30 /><rect width=180 height=180 fill=none rx=100 ry=100 stroke=#24C4CC stroke-width=40 stroke-dasharray=\"{{ cont.dasharray2}}\" stroke-dashoffset={{cont.offset2}} stroke-linecap=butt x=30 y=30 /><rect width=180 height=180 fill=none rx=100 ry=100 stroke=#9C43FF stroke-width=40 stroke-dasharray=\"{{ cont.dasharray3}}\" stroke-dashoffset={{cont.offset3}} stroke-linecap=butt x=30 y=30 /><rect width=180 height=180 fill=none rx=100 ry=100 stroke=#D533A3 stroke-width=40 stroke-dasharray=\"{{ cont.dasharray4}}\" stroke-dashoffset={{cont.offset4}} stroke-linecap=butt x=30 y=30 /><rect width=180 height=180 fill=none rx=100 ry=100 stroke=#E87722 stroke-width=40 stroke-dasharray=\"{{ cont.dasharray5}}\" stroke-dashoffset={{cont.offset5}} stroke-linecap=butt x=30 y=30 /><rect width=180 height=180 fill=none rx=100 ry=100 stroke=#3B8CFF stroke-width=40 stroke-dasharray=\"{{ cont.dasharray6}}\" stroke-dashoffset={{cont.offset6}} stroke-linecap=butt x=30 y=30 /><rect width=180 height=180 fill=none rx=100 ry=100 stroke=#FFDB1D stroke-width=40 stroke-dasharray=\"{{ cont.dasharray7}}\" stroke-dashoffset={{cont.offset7}} stroke-linecap=butt x=30 y=30 /></svg></div><div class=\"border-top d-flex flex-row p16 mt16\"><img src=assets/images/embedded-flex/shopping.svg><div class=\"ml16 flex-fill\"><div>Shopping</div><div class=\"text-300 font-12 text-copy-1\"><span ng-bind=cont.txn3Count></span> transactions</div></div><div><div class=text-right><span class=\"text-copy-1 text-300\">$</span> <span ng-bind=cont.txn3></span></div><div class=\"text-300 font-12 text-copy-1 text-right\"><span ng-bind=cont.txn3Pct></span>%</div></div></div><div class=\"border-top d-flex flex-row p16 mt16\"><img src=assets/images/embedded-flex/healthcare.svg><div class=\"ml16 flex-fill\"><div>Healthcare</div><div class=\"text-300 font-12 text-copy-1\"><span ng-bind=cont.txn1Count></span> transactions</div></div><div><div class=text-right><span class=\"text-copy-1 text-300\">$</span> <span ng-bind=cont.txn1></span></div><div class=\"text-300 font-12 text-copy-1 text-right\"><span ng-bind=cont.txn1Pct></span>%</div></div></div><div class=\"border-top d-flex flex-row p16 mt16\"><img src=assets/images/embedded-flex/child.svg><div class=\"ml16 flex-fill\"><div>Child</div><div class=\"text-300 font-12 text-copy-1\"><span ng-bind=cont.txn2Count></span> transactions</div></div><div><div class=text-right><span class=\"text-copy-1 text-300\">$</span> <span ng-bind=cont.txn2></span></div><div class=\"text-300 font-12 text-copy-1 text-right\"><span ng-bind=cont.txn2Pct></span>%</div></div></div><div class=\"border-top d-flex flex-row p16 mt16\"><img src=assets/images/embedded-flex/transport.svg><div class=\"ml16 flex-fill\"><div>Transport</div><div class=\"text-300 font-12 text-copy-1\"><span ng-bind=cont.txn4Count></span> transactions</div></div><div><div class=text-right><span class=\"text-copy-1 text-300\">$</span> <span ng-bind=cont.txn4></span></div><div class=\"text-300 font-12 text-copy-1 text-right\"><span ng-bind=cont.txn4Pct></span>%</div></div></div><div class=\"border-top d-flex flex-row p16 mt16\"><img src=assets/images/embedded-flex/rent.svg><div class=\"ml16 flex-fill\"><div>Rent</div><div class=\"text-300 font-12 text-copy-1\"><span ng-bind=cont.txn5Count></span> transactions</div></div><div><div class=text-right><span class=\"text-copy-1 text-300\">$</span> <span ng-bind=cont.txn5></span></div><div class=\"text-300 font-12 text-copy-1 text-right\"><span ng-bind=cont.txn5Pct></span>%</div></div></div><div class=\"border-top d-flex flex-row p16 mt16\"><img src=assets/images/embedded-flex/travel.svg><div class=\"ml16 flex-fill\"><div>Travel</div><div class=\"text-300 font-12 text-copy-1\"><span ng-bind=cont.txn6Count></span> transactions</div></div><div><div class=text-right><span class=\"text-copy-1 text-300\">$</span> <span ng-bind=cont.txn6></span></div><div class=\"text-300 font-12 text-copy-1 text-right\"><span ng-bind=cont.txn6Pct></span>%</div></div></div><div class=\"border-top d-flex flex-row p16 mt16\"><img src=assets/images/embedded-flex/crypto.svg><div class=\"ml16 flex-fill\"><div>Crypto</div><div class=\"text-300 font-12 text-copy-1\"><span ng-bind=cont.txn7Count></span> transactions</div></div><div><div class=text-right><span class=\"text-copy-1 text-300\">$</span> <span ng-bind=cont.txn7></span></div><div class=\"text-300 font-12 text-copy-1 text-right\"><span ng-bind=cont.txn7Pct></span>%</div></div></div></div></div></div></section><section class=bg-white style=\"padding-bottom: 120px\" ng-if=cont.spending></section></div><div id=embedded-navbar-container class=\"bg-white pb-24\"><div id=bank-nav-container class=\"d-flex flex-row\" ng-if=!cont.purchased><div class=flex-fill></div><div class=\"bg-black bank-nav border-radius-md pl24 pr24 pt8 pb8\"><a><img src=assets/images/embedded-flex/home-fill.svg height=32 ng-if=cont.landing></a><a><img src=assets/images/embedded-flex/home.svg height=32 ng-if=!cont.landing ng-click=\"cont.clickTab(\'landing\')\"></a><a><img src=assets/images/embedded-flex/wallet.svg height=32></a><a><img src=assets/images/embedded-flex/spending.svg height=32 ng-if=!cont.spending ng-click=\"cont.clickTab(\'spending\')\"></a><a><img src=assets/images/embedded-flex/spending-fill.svg height=32 ng-if=cont.spending></a></div><div class=flex-fill></div></div><section id=journey-nav-container ng-if=cont.purchased><div class=container-fluid><div class=row><div class=col-xs-12><div class=\"text-white pt16\">Success! MyFlex is now being activated</div><div class=\"mt16 btn btn-ghost-white mb40 w-100\" ng-click=cont.resetPurchase(1)>Reset Journey</div></div></div></div></section></div><div class=flex-fill></div></div></div>");
$templateCache.put("app/embedded/loyalty-add-money.html","<div class=embedded><div id=embedded-flex-outer-container class=\"pt24 pb24 d-flex flex-column\" style=\"background: black\"><div class=flex-fill></div><div id=embedded-flex-inner-container class=bg-white style=\"min-height: 748px\"><section class=\"bg-d-purple pl24 pr24 pt56 pb16 d-flex flex-row\"><img ui-sref=embedded-landing src=assets/images/embedded-flex/arrow-icon-white.svg><div class=\"text-white text-center font-16 flex-fill pr24\">Pay Bills</div></section><section class=bg-gray-2><div class=container-fluid><div class=row><div class=\"col-xs-12 pt8 pb8\"><div class=\"border-radius-md border font-14 text-300 text-copy-1 p8\"><div class=\"d-flex flex-row\"><img ui-sref=embedded-landing src=assets/images/embedded-flex/icon-search.svg><div class=\"flex-fill pl8\">Search Billers</div></div></div></div></div></div></section><section class=white><div class=container-fluid><div class=row><div class=col-xs-12><div class=\"d-flex flex-row mt16 mb32\"><div class=flex-fill>Categories</div><a>View All</a></div><div class=row><a class=\"col-xs-3 pb24\" ng-click=\"cont.seeBillers(\'electric\')\"><img class=w-100 src=assets/images/embedded-flex/bills/electric.png><center class=\"font-12 text-300 text-copy-1\">Electric Utilities</center></a><a class=col-xs-3 ng-click=\"cont.seeBillers(\'water\')\"><img class=w-100 src=assets/images/embedded-flex/bills/water.png><center class=\"font-12 text-300 text-copy-1\">Water Utilities</center></a><a class=col-xs-3 ng-click=\"cont.seeBillers(\'telco\')\"><img class=w-100 src=assets/images/embedded-flex/bills/telco.png><center class=\"font-12 text-300 text-copy-1\">Telecoms</center></a><a class=col-xs-3 ng-click=\"cont.seeBillers(\'cable\')\"><img class=w-100 src=assets/images/embedded-flex/bills/cable.png><center class=\"font-12 text-300 text-copy-1\">Cable / Internet</center></a></div><div class=row><a class=col-xs-3 ng-click=\"cont.seeBillers(\'healthcare\')\"><img class=w-100 src=assets/images/embedded-flex/bills/healthcare.png><center class=\"font-12 text-300 text-copy-1\">Healthcare</center></a><a class=col-xs-3 ng-click=\"cont.seeBillers(\'transpo\')\"><img class=w-100 src=assets/images/embedded-flex/bills/transpo.png><center class=\"font-12 text-300 text-copy-1\">Transportation</center></a><a class=col-xs-3 ng-click=\"cont.seeBillers(\'creditcard\')\"><img class=w-100 src=assets/images/embedded-flex/bills/creditcard.png><center class=\"font-12 text-300 text-copy-1\">Credit Cards</center></a><a class=col-xs-3 ng-click=\"cont.seeBillers(\'other\')\"><img class=w-100 src=assets/images/embedded-flex/bills/other.png><center class=\"font-12 text-300 text-copy-1\">Other</center></a></div></div></div></div></section></div><div class=flex-fill></div></div></div>");
$templateCache.put("app/embedded/pay-bills-1.html","<div class=embedded><div id=embedded-flex-outer-container class=\"pt24 pb24 d-flex flex-column\" style=\"background: black\"><div class=flex-fill></div><div id=embedded-flex-inner-container class=bg-white style=\"min-height: 748px\"><section class=\"bg-d-purple pl24 pr24 pt56 pb16 d-flex flex-row\"><img ui-sref=embedded-landing src=assets/images/embedded-flex/arrow-icon-white.svg><div class=\"text-white text-center font-16 flex-fill pr24\">Pay Bills</div></section><section class=bg-gray-2><div class=container-fluid><div class=row><div class=\"col-xs-12 pt8 pb8\"><div class=\"border-radius-md border font-14 text-300 text-copy-1 p8\"><div class=\"d-flex flex-row\"><img ui-sref=embedded-landing src=assets/images/embedded-flex/icon-search.svg><div class=\"flex-fill pl8\">Search Billers</div></div></div></div></div></div></section><section class=white><div class=container-fluid><div class=row><div class=col-xs-12><div class=\"d-flex flex-row mt16 mb32\"><div class=flex-fill>Categories</div><a>View All</a></div><div class=row><a class=\"col-xs-3 pb24\" ng-click=\"cont.seeBillers(\'electric\')\"><img class=w-100 src=assets/images/embedded-flex/bills/electric.png><center class=\"font-12 text-300 text-copy-1\">Electric Utilities</center></a><a class=col-xs-3 ng-click=\"cont.seeBillers(\'water\')\"><img class=w-100 src=assets/images/embedded-flex/bills/water.png><center class=\"font-12 text-300 text-copy-1\">Water Utilities</center></a><a class=col-xs-3 ng-click=\"cont.seeBillers(\'telco\')\"><img class=w-100 src=assets/images/embedded-flex/bills/telco.png><center class=\"font-12 text-300 text-copy-1\">Telecoms</center></a><a class=col-xs-3 ng-click=\"cont.seeBillers(\'cable\')\"><img class=w-100 src=assets/images/embedded-flex/bills/cable.png><center class=\"font-12 text-300 text-copy-1\">Cable / Internet</center></a></div><div class=row><a class=col-xs-3 ng-click=\"cont.seeBillers(\'healthcare\')\"><img class=w-100 src=assets/images/embedded-flex/bills/healthcare.png><center class=\"font-12 text-300 text-copy-1\">Healthcare</center></a><a class=col-xs-3 ng-click=\"cont.seeBillers(\'transpo\')\"><img class=w-100 src=assets/images/embedded-flex/bills/transpo.png><center class=\"font-12 text-300 text-copy-1\">Transportation</center></a><a class=col-xs-3 ng-click=\"cont.seeBillers(\'creditcard\')\"><img class=w-100 src=assets/images/embedded-flex/bills/creditcard.png><center class=\"font-12 text-300 text-copy-1\">Credit Cards</center></a><a class=col-xs-3 ng-click=\"cont.seeBillers(\'other\')\"><img class=w-100 src=assets/images/embedded-flex/bills/other.png><center class=\"font-12 text-300 text-copy-1\">Other</center></a></div></div></div></div></section></div><div class=flex-fill></div></div></div>");
$templateCache.put("app/embedded/pay-bills-2.html","<div class=embedded><div id=embedded-flex-outer-container class=\"pt24 pb24 d-flex flex-column\" style=\"background: black\"><div class=flex-fill></div><div id=embedded-flex-inner-container class=bg-white style=\"min-height: 748px\"><section class=\"bg-d-purple pl24 pr24 pt56 pb16 d-flex flex-row\"><img ui-sref=pay-bills-1 src=assets/images/embedded-flex/arrow-icon-white.svg><div class=\"text-white text-center font-16 flex-fill pr24\">Pay Bills</div></section><section class=bg-gray-2><div class=container-fluid><div class=row><div class=\"col-xs-12 pt8 pb8\"><div class=\"border-radius-md border font-14 text-300 text-copy-1 p8\"><div class=\"d-flex flex-row\"><img ui-sref=embedded-landing src=assets/images/embedded-flex/icon-search.svg><div class=\"flex-fill pl8\">Search Billers</div></div></div></div></div></div></section><section class=white><div class=\"container-fluid mb32\"><div class=\"row border-bottom pt16 pb16\" ng-repeat=\"biller in cont.billers\" ng-if=\"cont.billType==biller.type\" ng-click=cont.payBiller(biller)><div class=col-xs-12><div class=\"d-flex flex-row\"><img src=assets/images/embedded-flex/billers/{{biller.image}} width=24><div class=\"flex-fill pl8\">{{biller.name}}</div></div></div></div></div></section></div><div class=flex-fill></div></div></div>");
$templateCache.put("app/embedded/pay-bills-3.html","<div class=embedded><div id=embedded-flex-outer-container class=\"pt24 pb24 d-flex flex-column\" style=\"background: black\"><div class=flex-fill></div><div id=embedded-flex-inner-container class=bg-white style=\"min-height: 748px\"><section class=\"bg-d-purple pl24 pr24 pt56 pb16 d-flex flex-row\"><img ui-sref=pay-bills-2 src=assets/images/embedded-flex/arrow-icon-white.svg><div class=\"text-white text-center font-16 flex-fill pr24\">Pay Bills</div></section><section class=\"white flex-fill\"><div class=\"container-fluid mb32\"><div class=row><div class=col-xs-12><div class=\"d-flex flex-row mt32\"><img src=assets/images/embedded-flex/billers/{{cont.biller.image}} width=40><div class=\"flex-fill pl16\"><div>{{cont.biller.name}}</div><div class=\"font-12 text-copy-1\">Posting Period: within 3 business days</div></div></div><div class=\"border border-radius-md p24 pt16 d-flex flex-row mt24\"><div class=\"font-24 text-300 text-copy-0 pt8\">$</div><input type=text name=bill-amount id=bill-amount ng-model=cont.billAmount placeholder=\"Enter Amount\" style=\"text-decoration: underline; border: none\" class=\"w-100 pt8 flex-fill text-right font-24 text-700 text-copy-2\" ng-blur=cont.getProduct()><div class=\"font-24 text-300 text-copy-0 pt8\" ng-if=\"cont.checkbox&&cont.billAmount>0\">+{{cont.product.Premium * cont.billAmount / 100}}</div></div><center class=\"pt8 font-12 text-copy-0\">You will be charged a service fee of PHP 20.00</center><div class=\"form-group mt32 mb48\"><label class=\"text-300 mb8 text-copy-1\" for=accref>Account Reference Number</label><input type=text id=accref class=\"form-control text-300 mb8\" placeholder=\"Enter 8-digit account number\"><label class=\"text-300 mb8 text-copy-1 pt8\" for=accref>Account Reference Number</label><input type=text id=accref class=\"form-control text-300 mb8\" placeholder=\"Enter 8-digit account number\"></div><div class=\"border-radius-md font-12 p16 mb16 embeddedbill {{cont.product.ProductTrim}}\"><div class=\"mt16 mb16 text-white p8 border-radius bg-black\" id=activeRule style=\"font-family: monospace; position: absolute; margin-top: -40px\">Active Rule: {{cont.activeRule[\"Rules\"]}}</div><div class=\"d-flex flex-row pb8\"><div class=flex-fill><img src=assets/images/embedded-flex/icons/{{cont.data.assetsThumbnail}}.svg></div><div><img src=assets/images/embedded-flex/icons/close.svg ng-click=cont.snooze()></div></div><strong>{{cont.product.Intro}}</strong><div class=\"text-copy-1 text-300 pt8\">Get <span class=coloredText>{{cont.product.Cover}}</span> months of coverage, for less than <span class=coloredText>{{cont.product.Premium}}%</span> of your bill amount! <u>Learn more</u></div><div class=\"checkbox m0 mt8 dynamicColor\" ng-class=\"{ selected: cont.checkbox }\" ng-click=\"cont.checkbox=!cont.checkbox\"><div class=form-check><input type=checkbox class=form-check-input ng-model=cont.checkbox> <span class=checkmark></span><label class=\"text-copy-1 text-300 pl8\" style=\"padding-left: 8px; font-weight: 300\">Yes, I agree to pay purchase {{cont.product.Product}} <u>View group policy</u></label></div></div></div><div class=\"btn btn-d-purple w-100\" ng-click=cont.go()>Confirm and Pay</div></div></div></div></section></div><div class=flex-fill></div></div></div>");
$templateCache.put("app/embedded/pay-bills-4.html","<div class=embedded><div id=embedded-flex-outer-container class=\"pt24 pb24 d-flex flex-column\" style=\"background: black\"><div class=flex-fill></div><div id=embedded-flex-inner-container class=bg-white style=\"min-height: 748px\"><div class=\"d-flex flex-column\" style=\"min-height: 100%\"><section class=\"bg-d-purple pl24 pr24 pt56 pb16 d-flex flex-row\"><div class=\"text-white text-center font-16 flex-fill pr24\">Success</div></section><div class=\"flex-fill d-flex flex-column\"><div class=flex-fill></div><center class=\"font-21 text-700\"><img src=assets/images/check.png></center><center class=\"font-21 text-700 mt32\">Payment Successful</center><div class=flex-fill></div></div><section class=p24><a class=\"btn btn-d-purple w-100\" ng-click=cont.go()>Go Back</a></section></div></div><div class=flex-fill></div></div></div>");
$templateCache.put("app/embedded/scan-to-pay-1.html","<div class=embedded><div id=embedded-flex-outer-container class=\"pt24 pb24 d-flex flex-column\" style=\"background: black\"><div class=flex-fill></div><div id=embedded-flex-inner-container class=bg-white style=\"min-height: 748px\"><div class=\"d-flex flex-column\" style=\"min-height: 100%\"><section class=\"bg-d-purple pl24 pr24 pt56 pb16 d-flex flex-row\"><img ui-sref=embedded-landing src=assets/images/embedded-flex/arrow-icon-white.svg><div class=\"text-white text-center font-16 flex-fill pr24\">Scan To Pay</div></section><div class=\"flex-fill d-flex flex-column\"><div class=\"flex-fill bg-d-gray\"></div><center class=\"font-21 text-700\" ng-repeat=\"merchant in cont.merchants\" ng-if=\"merchant.name==cont.merchant\"><img src=assets/images/{{merchant.image}} class=w-100 ng-click=cont.go()></center><div class=\"flex-fill bg-d-gray\"></div></div><section class=\"p24 bg-d-gray\"><div class=\"d-flex flex-row\"><div class=\"flex-fill pl4 pr4\" ng-repeat=\"merchant in cont.merchants\"><a class=\"btn btn-sm w-100\" ng-class=\"{\'btn-d-purple\': cont.merchant == merchant.name, \'btn-ghost-white\': cont.merchant != merchant.name}\" ng-click=cont.setMerchant(merchant.name)>{{merchant.type}}</a></div></div></section></div></div><div class=flex-fill></div></div></div>");
$templateCache.put("app/embedded/scan-to-pay-2.html","<div class=embedded><div id=embedded-flex-outer-container class=\"pt24 pb24 d-flex flex-column\" style=\"background: black\"><div class=flex-fill></div><div id=embedded-flex-inner-container class=bg-white style=\"min-height: 748px\"><div class=\"d-flex flex-column\" style=\"min-height: 100%\"><section class=\"bg-d-purple pl24 pr24 pt56 pb16 d-flex flex-row\"><img ui-sref=embedded-landing src=assets/images/embedded-flex/arrow-icon-white.svg><div class=\"text-white text-center font-16 flex-fill pr24\">Scan To Pay</div></section><div class=\"flex-fill d-flex flex-column\"><div class=\"p24 pt16 pb16 border-bottom d-flex flex-row\"><div class=flex-fill><div class=\"pb8 font-12 text-copy-0\">Transfer From</div><div class=text-700>Deposit Account</div><div class=\"font-12 text-copy-0 pt4\">989-12454-01</div></div></div><div class=\"p24 pt16 pb16 border-bottom d-flex flex-row\"><div class=flex-fill><div class=\"pb8 font-12 text-copy-0\">Transfer To</div><div class=text-700 ng-bind=cont.merchant></div><div class=\"font-12 text-copy-0 pt4\">***-**454-01</div></div></div><div class=p24><div class=\"pb8 font-12 text-copy-0\">Amount to Transfer</div><div class=\"border border-radius-md p24 pt16 d-flex flex-row bg-gray-1\"><div class=\"font-24 text-300 text-copy-0 pt8\">$</div><input type=text name=bill-amount id=bill-amount ng-model=cont.billAmount placeholder=0.00 style=\"text-decoration: underline; border: none\" class=\"w-100 pt8 flex-fill bg-gray-1 text-right font-24 text-700 text-copy-2\" ng-blur=cont.getProduct()><div class=\"font-24 text-300 text-copy-0 pt8\" ng-if=\"cont.checkbox&&cont.billAmount>0\">+{{ (cont.premium) | number:2 }}</div></div></div><div class=flex-fill></div><section class=\"p24 pb0\"><div class=\"border-radius-md font-12 p16 mb8 embeddedbill {{cont.merchantObject.style}}\"><div class=\"d-flex flex-row pb8\"><div class=flex-fill><img src=assets/images/{{cont.merchantObject.productIcon}}></div><div><img src=assets/images/embedded-flex/icons/close.svg ng-click=cont.snooze()></div></div><strong>{{cont.merchantObject.intro}}</strong><div class=\"text-copy-1 text-300 pt8\" ng-if=\"cont.priceMode ==\'multi\'\">Get <span class=coloredText>${{cont.billAmount * 10}}</span> of coverage, for <span class=coloredText>10%</span> of your bill amount! <u>Learn more</u></div><div class=\"text-copy-1 text-300 pt8\" ng-if=\"cont.priceMode == \'fixed\'\">Get <span class=coloredText>${{cont.merchantObject.basePremium * 107}}</span> of coverage, for <span class=coloredText>${{cont.merchantObject.basePremium}}</span><u> Learn more</u></div><div class=\"checkbox m0 mt8 dynamicColor\" ng-class=\"{ selected: cont.checkbox }\" ng-click=\"cont.checkbox=!cont.checkbox;\"><div class=form-check><input type=checkbox class=form-check-input ng-model=cont.checkbox> <span class=checkmark></span><label class=\"text-copy-1 text-300 pl8\" style=\"padding-left: 8px; font-weight: 300\">Yes, I agree to pay purchase {{cont.product.Product}} <u>View group policy</u></label></div></div></div><div class=\"d-flex flex-row\"><div class=flex-fill></div><div class=\"font-12 text-copy-0 pr8\" ng-class=\"{\'text-copy-2 text-700\': cont.priceMode==\'multi\'}\" ng-click=\"cont.setMode(\'multi\')\">Multiplier</div><div class=\"font-12 text-copy-0\" ng-class=\"{\'text-copy-2 text-700\': cont.priceMode==\'fixed\'}\" ng-click=\"cont.setMode(\'fixed\')\">Fixed</div></div></section></div><section class=p24><a class=\"btn btn-d-purple w-100\" ng-click=cont.go()>Pay</a></section></div></div><div class=flex-fill></div></div></div>");
$templateCache.put("app/embedded/scan-to-pay-3.html","<div class=embedded><div id=embedded-flex-outer-container class=\"pt24 pb24 d-flex flex-column\" style=\"background: black\"><div class=flex-fill></div><div id=embedded-flex-inner-container class=bg-white style=\"min-height: 748px\"><div class=\"d-flex flex-column\" style=\"min-height: 100%\"><section class=\"bg-d-purple pl24 pr24 pt56 pb16 d-flex flex-row\"><div class=\"text-white text-center font-16 flex-fill pr24\">Success</div></section><div class=\"flex-fill d-flex flex-column\"><div class=flex-fill></div><center class=\"font-21 text-700\"><img src=assets/images/check.png></center><center class=\"font-21 text-700 mt32\">Payment Successful</center><section class=\"p24 pb0\"><div class=\"mt16 border p16 border-radius\"><div class=\"text-center font-12\">Your {{cont.merchantObject.match}} insurance will be sent to your email</div></div></section><section class=\"p24 pt0 mt8\"><div class=\"border p16 border-radius\"><div class=font-12><div><b>Amount:</b> {{cont.txn.amount}}</div><div><b>From:</b> {{cont.txn.source}}</div><div><b>To:</b> {{cont.txn.destination}}</div></div></div></section><div class=flex-fill></div></div><section class=p24><a class=\"btn btn-d-purple w-100\" ng-click=cont.go()>Go Back</a></section></div></div><div class=flex-fill></div></div></div>");
$templateCache.put("app/underwriting/life-uw-1.html","<div class=embedded><div id=embedded-flex-outer-container class=\"pt24 pb24 d-flex flex-column\" style=\"background: black\"><div class=flex-fill></div><div id=embedded-flex-inner-container class=bg-white style=\"min-height: 748px\"><section class=\"bg-d-purple pl24 pr24 pt56 pb16 d-flex flex-row\"><img src=assets/images/embedded-flex/arrow-icon-white.svg><div class=\"text-white text-center font-16 flex-fill pr24\">Complete Your Application</div></section><section class=\"pl16 pr16\"><div class=container-fluid><div class=row><div class=col-xs-12><div class=\"font-21 text-700 mt32 mb32\">Enter the Following Details</div><div class=\"text-700 mb16 mt16\">Basic Information</div><label class=\"text-300 mb8 text-copy-1\" for=Age>Age</label><input type=number id=Age class=\"form-control text-300 mb8\" placeholder=30 ng-model=cont.Age><label for=Occupation>Occupation</label><select type=text class=form-control id=Occupation placeholder=\"Select an occupation\" ng-model=cont.Occupation><option ng-repeat=\"occ in cont.OptionsOccupations\" value={{occ.key}}>{{occ.Descr}}</option></select><div class=\"text-700 mb16 mt16\">Medical Document</div><div class=\"border p8 border-radius\"><label for=med-results class=\"text-300 mb16\">Upload Medical Results (Must contain height, weight and BP)</label><div class=\"d-flex felx-row\"><input class=\"form-control-file flex-fill\" type=file id=yourFileInputId> <img src=assets/images/loading.gif height=16 width=16 id=file-loader ng-if=cont.Loading></div></div><div class=\"text-700 mb16 mt16\">BMI</div><label class=\"text-300 mb8 text-copy-1\" for=Weight>Weight (kg)</label><input type=number id=Weight class=\"form-control text-300 mb8\" placeholder=64 ng-model=cont.Weight><label class=\"text-300 mb8 text-copy-1\" for=Height>Height (m)</label><input type=number id=Height class=\"form-control text-300 mb8\" placeholder=1.61 ng-model=cont.Height><div class=\"text-700 mb16 mt16\">Blood Pressure</div><label class=\"text-300 mb8 text-copy-1\" for=Diastolic>Diastolic</label><input type=number id=Diastolic class=\"form-control text-300 mb8\" placeholder=80 ng-model=cont.Diastolic><label class=\"text-300 mb8 text-copy-1\" for=Systolic>Systolic</label><input type=number id=Systolic class=\"form-control text-300 mb8\" placeholder=120 ng-model=cont.Systolic> <button class=\"btn btn-d-purple mb32 mt32\" ng-click=cont.SaveData()>Next: Health Declaration</button></div></div></div></section></div><div class=flex-fill></div></div></div>");
$templateCache.put("app/underwriting/life-uw-2.html","<div class=embedded><div id=embedded-flex-outer-container class=\"pt24 pb24 d-flex flex-column\" style=\"background: black\"><div class=flex-fill></div><div id=embedded-flex-inner-container class=bg-white style=\"min-height: 748px\"><section class=\"bg-d-purple pl24 pr24 pt56 pb16 d-flex flex-row\"><img src=assets/images/embedded-flex/arrow-icon-white.svg ui-sref=life-uw-1><div class=\"text-white text-center font-16 flex-fill pr24\">Health Declaration</div></section><section class=\"pl16 pr16\"><div class=container-fluid><div class=row><div class=col-xs-12><div class=\"font-21 text-700 mt32 mb32\">Please Answer the Following Questions</div><div ng-repeat=\"item in cont.HealthQuestions\" class=\"font-16 mb32\" ng-if=\"item.Show==\'Y\'\"><div>{{item[\"Question\"]}}</div><div class=mt16 ng-if=\"item.Index!=\'Q2.1\'\"><button class=btn ng-click=\"cont.Answer(item[\'Index\'], \'Y\')\" ng-class=\"{\'btn-d-purple\': cont.YesCheck(item[\'Index\'])}\">YES</button> <button class=btn ng-click=\"cont.Answer(item[\'Index\'], \'N\')\" ng-class=\"{\'btn-d-purple\': !cont.YesCheck(item[\'Index\'])}\">NO</button></div><div ng-if=\"item.Index==\'Q2.1\'\" class=mt16><select type=text class=form-control id=Occupation placeholder=\"Select an occupation\" ng-model=cont.CancerType><option ng-repeat=\"ct in cont.CancerTypes\" value=ct.key>{{ct[\"Cancer Types\"]}}</option></select></div></div><button class=\"btn btn-d-purple mb32 mt32\" ng-click=cont.Submit() ng-disabled=cont.Decline><span ng-if=\"cont.refer==false&&!cont.Decline\">Next: Checkout</span> <span ng-if=\"cont.refer==true&&!cont.Decline\">Next: Submit Application</span> <span ng-if=cont.Decline>Not eligible to purchase</span></button></div></div></div></section></div><div class=flex-fill></div></div></div>");
$templateCache.put("app/underwriting/life-uw-3.html","<div class=embedded><div id=embedded-flex-outer-container class=\"pt24 pb24 d-flex flex-column\" style=\"background: black\"><div class=flex-fill></div><div id=embedded-flex-inner-container class=bg-white style=\"min-height: 748px\"><section class=\"bg-d-purple pl24 pr24 pt56 pb16 d-flex flex-row\"><img ui-sref=life-uw-2 src=assets/images/embedded-flex/arrow-icon-white.svg><div class=\"text-white text-center font-16 flex-fill pr24\">Checkout</div></section><section class=\"pl16 pr16 pt32\"><div class=container-fluid><div class=row><div class=col-xs-12><div class=\"border border-radius-md p16\"><div class=\"text-700 pb8\">Total Premium</div><h3 class=\"mb32 mt0 pt0\">$ <span ng-bind=cont.TotalPremium></span></h3><div class=\"d-flex flex-row\"><span>Loading - BP</span><div class=flex-fill></div><div ng-bind=\"cont.data[\'BPLoading\']\"></div></div><div class=\"d-flex flex-row\"><span>Loading - Occupation</span><div class=flex-fill></div><div ng-bind=\"cont.data[\'OccLoading\']\"></div></div><div class=\"d-flex flex-row\"><span>Loading - BMI</span><div class=flex-fill></div><div ng-bind=\"cont.data[\'BMILoading\']\"></div></div><br><div class=\"d-flex flex-row\"><strong>Basic Premium</strong><div class=flex-fill></div><div ng-bind=cont.BasicPremium></div></div><div class=\"d-flex flex-row\"><strong>Total Loading</strong><div class=flex-fill></div><div ng-bind=\"cont.data[\'Total_Loading\']\"></div></div></div></div></div></div></section><section class=\"pl16 pr16\"><button class=\"btn btn-d-purple mb32 mt32 w-100\" ui-sref=life-uw-1>Pay (Go Back to Start)</button></section></div><div class=flex-fill></div></div></div>");
$templateCache.put("app/underwriting/life-uw-4.html","<div class=embedded><div id=embedded-flex-outer-container class=\"pt24 pb24 d-flex flex-column\" style=\"background: black\"><div class=flex-fill></div><div id=embedded-flex-inner-container class=\"bg-white d-flex flex-column\" style=\"min-height: 748px\"><section class=\"bg-d-purple pl24 pr24 pt56 pb16 d-flex flex-row\"><img ui-sref=embedded-landing src=assets/images/embedded-flex/arrow-icon-white.svg><div class=\"text-white text-center font-16 flex-fill pr24\">We will Get Back</div></section><section class=flex-fill></section><section class=\"pl16 pr16\"><div class=container-fluid><div class=row><div class=col-xs-12><center><h3 class=mb32>Your application has been submitted successfully</h3><p>Please wait for 3-5 days to process. Your reference number is 0009323PCL3A. Please contact service@insurer.com for inquiries</p></center></div></div></div></section><section class=flex-fill></section><section class=\"pl16 pr16\"><button class=\"btn btn-d-purple mb32 mt32 w-100\" ui-sref=life-uw-1>Go Back</button></section></div><div class=flex-fill></div></div></div>");
$templateCache.put("app/components/backNavbar/backNavbar.html","<div class=\"container back-navbar\" ng-class=\"{\'with-bottom-margin\': !vm.removeMargin}\"><a href=# ng-click=vm.back()><span class=\"glyphicon {{ vm.icon }}\" ng-class=\"{ \'glyphicon-menu-left\': !vm.icon }\"></span> <img ng-if=!vm.content class=\"img-responsive m0\" src=/assets/images/coherent-logo-white.svg> </a><span class=content ng-if=vm.content ng-bind=vm.content></span></div>");
$templateCache.put("app/components/footer/footer.html","<div class=footer><div class=text-center><button class=\"btn btn-default\" ng-click=\"vm.translate(\'en\')\">English</button> <button class=\"btn btn-default\" ng-click=\"vm.translate(\'jp\')\">Japanese</button></div></div>");
$templateCache.put("app/components/loader/loader.html","<div class=loader ng-show=vm.loading><div class=sk-chase><div class=sk-chase-dot></div><div class=sk-chase-dot></div><div class=sk-chase-dot></div><div class=sk-chase-dot></div><div class=sk-chase-dot></div><div class=sk-chase-dot></div></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-inverse display-none\"><div class=container-fluid><div class=navbar-header><button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#nav-bar-1 aria-expanded=false><span class=sr-only>Toggle navigation</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button> <a class=navbar-brand ui-sref=main><!-- <img class=\"img-responsive\" src=\"/assets/images/coherent-logo.svg\" /> --><div class=text-copy-0>Coherent</div></a></div><div class=\"collapse navbar-collapse\" id=nav-bar-1><ul class=\"nav navbar-nav\"><li data-toggle=collapse data-target=#nav-bar-1 ng-class=\"{active: vm.$state.includes(\'purchase\')}\"><a ui-sref=purchase-1>Personal Accident</a></li><li data-toggle=collapse data-target=#nav-bar-1 ng-class=\"{active: vm.$state.includes(\'policy\')}\"><a ui-sref=policy-login>Policy Management + Claim</a></li><li data-toggle=collapse data-target=#nav-bar-1 ng-class=\"{active: vm.$state.includes(\'policy\')}\"><a ui-sref=embedded-dbs-1>CMS</a></li><li data-toggle=collapse data-target=#nav-bar-1 ng-class=\"{active: vm.$state.includes(\'policy\')}\"><a ui-sref=micro-5>Micro Insurance</a></li><li data-toggle=collapse data-target=#nav-bar-1 ng-class=\"{active: vm.$state.includes(\'policy\')}\"><a ui-sref=reward-landing>Free Insurance</a></li><li data-toggle=collapse data-target=#nav-bar-1 ng-class=\"{active: vm.$state.includes(\'policy\')}\"><a ui-sref=embedded-landing>Flex</a></li><li data-toggle=collapse data-target=#nav-bar-1 ng-class=\"{active: vm.$state.includes(\'policy\')}\"><a ui-sref=embedded-flex-invest>Invest</a></li><!-- <li data-toggle=\"collapse\" data-target=\"#nav-bar-1\" ng-class=\"{active: vm.$state.includes(\'claim\')}\"><a ui-sref=\"claim-1\">Claim Submission</a></li> --></ul></div></div></nav>");
$templateCache.put("app/components/range/range.html","<input type=range ng-model=vm.model min=\"{{ vm.min }}\" max=\"{{ vm.max }}\" step=1 ng-disabled=vm.disabled onmouseup=vm.change>");}]);